/**
 * Engleza aplicației: textul românesc din cod → fraza în engleză (britanică),
 * scrisă natural, nu cuvânt cu cuvânt. „Șantier” se scrie „site”; cuvântul firmei
 * (location, farm, project) îl pune `siteTextEn`. {0}, {1}… sunt valorile; <b>…</b>
 * doar în frazele trecute prin `rich`. Grupat după fișierul în care apare prima dată.
 */
export const EN: Record<string, string> = {
  // apps/api/src/access.ts
  'Firma nu a fost găsită.': 'Company not found.',
  // apps/api/src/anaf.ts
  'ANAF a răspuns {0}': 'ANAF responded {0}',
  // apps/api/src/auth/loginLimiter.ts
  'Prea multe încercări greșite.': 'Too many failed attempts.',
  'un minut': 'a minute',
  '{0} de minute': '{0} minutes',
  '{0} Încearcă din nou peste {1}.': '{0} Try again in {1}.',
  // apps/api/src/auth/requireAuth.ts
  'Trebuie să fii autentificat.': 'You need to be signed in.',
  // apps/api/src/auth/sessions.ts
  'Accesul firmei tale la Procumi este suspendat. Scrie-ne la sales@procumi.com.':
    "Your company's access to Procumi is suspended. Write to us at sales@procumi.com.",
  // apps/api/src/billing.ts
  'Plata cu cardul nu e pornită încă. Alege pachetul și îți trimitem factura.':
    "Card payment isn't switched on yet. Choose a plan and we'll send you an invoice.",
  'Plata cu cardul nu răspunde acum. Încearcă din nou în câteva minute.':
    "Card payment isn't responding right now. Try again in a few minutes.",
  'Procumi {0}': 'Procumi {0}',
  'Pachetul {0} are prețul stabilit după demo. Cere-l și te sunăm.':
    "The {0} plan is priced after a demo. Request it and we'll call you.",
  'Stripe nu a dat pagina de plată. Încearcă din nou.': "Stripe didn't return a payment page. Try again.",
  'Firma nu a plătit încă cu cardul.': "The company hasn't paid by card yet.",
  lună: 'month',
  'Plata cu cardul nu e pornită.': "Card payment isn't switched on.",
  'Semnătura Stripe nu e bună.': "The Stripe signature isn't valid.",
  // apps/api/src/deliveries.ts
  'Comanda nu e emisă: livrările se adaugă pe o comandă emisă.':
    "The order isn't issued: deliveries are added to an issued order.",
  'Nu ai trimis niciun fișier.': "You didn't send any files.",
  'O livrare poate avea cel mult {0} fișiere.': 'A delivery can have at most {0} files.',
  'Fișierul nu face parte din această livrare.': "The file isn't part of this delivery.",
  'Fișierul „{0}” nu mai e pe server.': 'The file "{0}" is no longer on the server.',
  'Returul se trece doar la comenzile cu chirie (cofraje, schele).':
    'Returns are only logged on rental orders (formwork, scaffolding).',
  // apps/api/src/demoSeed.ts
  'Departament achiziții': 'Purchasing department',
  'Șantier demo inexistent: {0}': 'Demo site missing: {0}',
  'Furnizor demo inexistent: {0}': 'Demo supplier missing: {0}',
  '15 zile': '15 days',
  // apps/api/src/env.ts
  'Lipsește variabila de mediu {0}. Copiază apps/api/.env.example în apps/api/.env.':
    'Environment variable {0} is missing. Copy apps/api/.env.example to apps/api/.env.',
  // apps/api/src/fx.ts
  'Cursul BNR nu se poate lua acum. Scrie cursul de mână.':
    "The BNR exchange rate can't be fetched right now. Enter the rate by hand.",
  'BNR nu are curs pentru ziua aceea. Scrie cursul de mână.':
    'BNR has no rate for that day. Enter the rate by hand.',
  // apps/api/src/inbound/agent.ts
  'Nu am putut face adresa căsuței.': "Couldn't create the inbox address.",
  'Nu știu al cui furnizor e {0}. Alege furnizorul și cererea.':
    "I don't know whose supplier {0} is. Choose the supplier and the request.",
  'Furnizorul are mai multe cereri deschise și nu se vede la care răspunde. Alege cererea.':
    "The supplier has several open requests and it isn't clear which one they're replying to. Choose the request.",
  'Furnizorul nu are nicio cerere deschisă. Alege cererea sau pune mailul deoparte.':
    'The supplier has no open requests. Choose the request or set the email aside.',
  'Aceeași ofertă a venit deja pe {0}: n-am citit-o a doua oară.':
    "The same quote already arrived on {0}: I didn't read it a second time.",
  'Citirea automată nu e pornită: completează prețurile din document.':
    "Automatic reading isn't switched on: fill in the prices from the document.",
  'Mailul nu are document sau prețuri de citit.': 'The email has no document or prices to read.',
  'N-am găsit prețuri pentru pozițiile cererii. Verifică documentul.':
    "I couldn't find prices for the request's items. Check the document.",
  'Citirea n-a mers. Completează prețurile din document.':
    "Reading didn't work. Fill in the prices from the document.",
  // apps/api/src/mail.ts
  '[mail netrimis — adresă de test]': '[email not sent — test address]',
  '[mail netrimis — lipsește RESEND_API_KEY]': '[email not sent — RESEND_API_KEY missing]',
  'Către: {0}': 'To: {0}',
  'De la: {0}': 'From: {0}',
  'Răspuns la: {0}': 'Reply-To: {0}',
  'Subiect: {0}': 'Subject: {0}',
  'Atașamente: {0}': 'Attachments: {0}',
  '[sfârșit mail]': '[end of email]',
  'Resend a răspuns {0}: {1}': 'Resend replied {0}: {1}',
  'Codul tău Procumi: {0}': 'Your Procumi code: {0}',
  'Bună ziua, {0},': 'Hello {0},',
  'Ca să termini înscrierea în Procumi, scrie codul acesta în pagina deschisă:':
    'To finish signing up for Procumi, enter this code on the page you have open:',
  'Codul merge {0} de minute.': 'The code works for {0} minutes.',
  'Dacă nu tu te-ai înscris, ignoră mailul: fără cod nu se face niciun cont.':
    "If you didn't sign up, just ignore this email: no account is created without the code.",
  'Echipa Procumi': 'The Procumi team',
  'Confirmă-ți emailul': 'Confirm your email',
  'Codul tău: {0}. Merge {1} de minute.': 'Your code: {0}. It works for {1} minutes.',
  'Codul merge <b>{0} de minute</b>.': 'The code works for <b>{0} minutes</b>.',
  'o oră': 'one hour',
  'Parolă nouă pentru Procumi': 'New password for Procumi',
  'Cineva, probabil tu, a cerut o parolă nouă pentru contul tău Procumi.':
    'Someone, probably you, asked for a new password for your Procumi account.',
  'Deschide linkul de mai jos și alege-ți parola:': 'Open the link below and choose your password:',
  'Linkul merge o singură dată și expiră în {0}.': 'The link works once and expires in {0}.',
  'Dacă nu tu ai cerut, ignoră mailul: parola ta rămâne cea de acum.':
    "If you didn't ask for this, ignore this email: your password stays as it is.",
  'Alege-ți o parolă nouă. Linkul expiră în {0}.': 'Choose a new password. The link expires in {0}.',
  '<table role="presentation" cellpadding="0" cellspacing="0" border="0" style="margin:24px 0 0"><tr><td style="background:{0};border-radius:5px"><a href="{1}" style="display:inline-block;padding:13px 24px;font:600 16px/20px {2};color:#FFFFFF;text-decoration:none">Alege parola nouă</a></td></tr></table>':
    '<table role="presentation" cellpadding="0" cellspacing="0" border="0" style="margin:24px 0 0"><tr><td style="background:{0};border-radius:5px"><a href="{1}" style="display:inline-block;padding:13px 24px;font:600 16px/20px {2};color:#FFFFFF;text-decoration:none">Choose a new password</a></td></tr></table>',
  'Linkul merge o singură dată și expiră în <b>{0}</b>.': 'The link works once and expires in <b>{0}</b>.',
  'Dacă butonul nu merge, copiază adresa în browser:<br><a href="{0}" style="color:{1};word-break:break-all">{2}</a>':
    'If the button doesn\'t work, copy this address into your browser:<br><a href="{0}" style="color:{1};word-break:break-all">{2}</a>',
  '{0} te invită în {1} pe Procumi': '{0} has invited you to {1} on Procumi',
  'Bună ziua,': 'Hello,',
  '{0} te-a invitat în contul firmei {1} pe Procumi, unde se cer și se compară ofertele de la furnizori.':
    "{0} has invited you to {1}'s company account on Procumi, where you request and compare quotes from suppliers.",
  'Rolul tău: {0}.': 'Your role: {0}.',
  'Deschide linkul, alege-ți o parolă și intri direct:': "Open the link, choose a password and you're in:",
  'Linkul expiră în {0} zile și merge o singură dată.': 'The link expires in {0} days and works once.',
  'Invitație în {0}': 'Invitation to {0}',
  '{0} te invită pe Procumi, ca {1}.': '{0} has invited you to Procumi, as {1}.',
  '<b>{0}</b> te-a invitat în contul firmei <b>{1}</b> pe Procumi, unde se cer și se compară ofertele de la furnizori.':
    "<b>{0}</b> has invited you to <b>{1}</b>'s company account on Procumi, where you request and compare quotes from suppliers.",
  'Rolul tău: <b>{0}</b>.': 'Your role: <b>{0}</b>.',
  '<table role="presentation" cellpadding="0" cellspacing="0" border="0" style="margin:24px 0 0"><tr><td style="background:{0};border-radius:5px"><a href="{1}" style="display:inline-block;padding:13px 24px;font:600 16px/20px {2};color:#FFFFFF;text-decoration:none">Intră în firmă</a></td></tr></table>':
    '<table role="presentation" cellpadding="0" cellspacing="0" border="0" style="margin:24px 0 0"><tr><td style="background:{0};border-radius:5px"><a href="{1}" style="display:inline-block;padding:13px 24px;font:600 16px/20px {2};color:#FFFFFF;text-decoration:none">Join the company</a></td></tr></table>',
  'Alegi o parolă și intri direct. Linkul expiră în <b>{0} zile</b>.':
    "Choose a password and you're in. The link expires in <b>{0} days</b>.",
  '{0} a cerut pachetul {1}, {2}: {3}, fără TVA.': '{0} requested the {1} plan, {2}: {3}, excl. VAT.',
  'Cine: {0} <{1}>': 'Who: {0} <{1}>',
  'Firma: {0}': 'Company: {0}',
  'Reg. Com.: {0}': 'Trade Register: {0}',
  'Adresa: {0}': 'Address: {0}',
  'După plată, pune pachetul și „plătit până la” în Administrare → Firme.':
    'After payment, set the plan and "paid until" in Administration → Companies.',
  'Pachet cerut: {0} — {1}, {2}': 'Plan requested: {0} — {1}, {2}',
  '{0} în {1} {2}{3}': '{0} across {1} {2}{3}',
  ' ({0}{1}% față de luna de dinainte)': ' ({0}{1}% on the previous month)',
  '{0} față de a doua ofertă': '{0} against the second quote',
  '{0} până la cel mai bun preț posibil': '{0} short of the best possible price',
  '{0} peste cea mai mică ofertă: {1}. Poate e un motiv bun; merită întrebat.':
    '{0} above the lowest quote: {1}. There may be a good reason; worth asking.',
  'O cerere a fost hotărâtă': 'One request was decided',
  '{0} cereri au fost hotărâte': '{0} requests were decided',
  '{0} a luat {1} din comenzi: firma depinde mult de un singur furnizor.':
    '{0} took {1} of orders: the company depends heavily on a single supplier.',
  '{0} din {1} cereri au avut cel mult o ofertă, deci prețul nu a fost comparat.':
    "{0} of {1} requests had at most one quote, so the price wasn't compared.",
  'Raportul pe {0}: {1} comandat, {2} economisit': 'Report for {0}: {1} ordered, {2} saved',
  'Bună, {0},': 'Hi {0},',
  'Achizițiile {0} pe {1}:': 'Purchasing at {0} for {1}:',
  'De urmărit:': 'Worth a look:',
  'Raportul întreg: {0}': 'The full report: {0}',
  'Îl primești pentru că ești administrator sau aprobator. Îl oprești din Profilul meu.':
    "You get this because you're an administrator or approver. You can turn it off in My profile.",
  'Raportul pe {0}': 'Report for {0}',
  '{0} comandat, {1} economisit': '{0} ordered, {1} saved',
  'Achizițiile <b>{0}</b> pe {1}:': 'Purchasing at <b>{0}</b> for {1}:',
  '<b>De urmărit</b>': '<b>Worth a look</b>',
  'Deschide raportul': 'Open the report',
  'o ofertă': 'one quote',
  '{0} oferte': '{0} quotes',
  'Primul pas în Procumi: furnizorii tăi': 'Your first step in Procumi: your suppliers',
  'Ca să ceri oferte, Procumi trebuie să-ți știe furnizorii.':
    'To request quotes, Procumi needs to know your suppliers.',
  'Copiază lista din Excel (nume, email, ce vând) și lipește-o în Furnizori → Importă. Durează un minut.':
    'Copy the list from Excel (name, email, what they sell) and paste it into Suppliers → Import. It takes a minute.',
  'Adaug furnizorii': 'Add my suppliers',
  'Trimite prima cerere de ofertă': 'Send your first request for quotes',
  'Ai furnizorii în Procumi. Acum alege ce cumperi, lipește pozițiile din Excel și alege cui trimiți.':
    "Your suppliers are in Procumi. Now choose what you're buying, paste the items from Excel and pick who to send it to.",
  'Procumi trimite cererea fiecărui furnizor și le amintește dacă nu răspund.':
    "Procumi sends the request to each supplier and reminds them if they don't reply.",
  'Fac prima cerere': 'Create my first request',
  'Ai trimis prima cerere. Ce urmează': "You've sent your first request. What's next",
  'Furnizorii pot răspunde direct din link sau pe mail, ca până acum.':
    'Suppliers can reply straight from the link, or by email as they do now.',
  'Ofertele venite pe mail, PDF sau poză le urci în cerere: Procumi citește prețurile și le pune în tabel.':
    'Quotes that come by email, as a PDF or photo, you upload to the request: Procumi reads the prices and puts them in the table.',
  'Văd cererea': 'See the request',
  'Ofertele sunt în tabel: compară-le': 'The quotes are in the table: compare them',
  'Ai deja {0}. Tabelul arată cel mai mic preț pe fiecare poziție și oferta cu cel mai mic total.':
    'You already have {0}. The table shows the lowest price for each item and the quote with the lowest total.',
  'De acolo faci comanda cu un clic.': 'From there, you place the order in one click.',
  'Compar ofertele': 'Compare quotes',
  'Ai {0}: alege furnizorul': 'You have {0}: choose the supplier',
  'În tabelul comparativ vezi pe fiecare poziție cel mai bun preț și ce lipsește din fiecare ofertă (transport, termen).':
    "In the comparison table you see the best price for each item and what's missing from each quote (delivery, lead time).",
  'Poți lua tot de la un furnizor sau împarte comanda între mai mulți.':
    'You can take everything from one supplier or split the order between several.',
  'Furnizorii n-au răspuns încă?': "Suppliers haven't replied yet?",
  'Din cerere trimiți un memento cu un clic, fiecăruia cu textul lui.':
    'From the request you send a reminder in one click, each with its own text.',
  'Ofertele venite pe WhatsApp sau pe mail le urci în cerere și Procumi le citește.':
    'Quotes that come by WhatsApp or email you upload to the request, and Procumi reads them.',
  'Deschid cererile': 'Open my requests',
  '5 minute pentru prima cerere de ofertă': '5 minutes for your first request for quotes',
  'Ia o cerere pe care ai trimis-o oricum săptămâna asta și trimite-o din Procumi.':
    'Take a request you were sending this week anyway and send it from Procumi.',
  'O singură cerere, la toți furnizorii, iar răspunsurile vin în același tabel.':
    'One request, to all your suppliers, and the replies land in the same table.',
  '{0} furnizori în agendă': '{0} suppliers in your address book',
  'cerere trimisă': 'request sent',
  'cereri trimise': 'requests sent',
  'o ofertă primită': 'one quote received',
  '{0} oferte primite': '{0} quotes received',
  'Proba gratuită se termină mâine': 'Your free trial ends tomorrow',
  'Mai ai {0} zile de probă': '{0} days of your trial left',
  'Până acum: {0}.': 'So far: {0}.',
  'Încă n-ai apucat să încerci Procumi cu o cerere adevărată.':
    "You haven't had a chance to try Procumi with a real request yet.",
  'De mâine contul rămâne doar pentru citire: tot ce ai lucrat se păstrează. Ca să lucrezi mai departe, alege un pachet din Contul firmei → Pachet.':
    "From tomorrow the account becomes read-only: everything you've done is kept. To keep working, choose a plan in Company account → Plan.",
  'Ca să lucrezi mai departe după probă, alege pachetul din Contul firmei → Pachet. Prețul e pe firmă, nu pe om.':
    'To keep working after the trial, choose a plan in Company account → Plan. The price is per company, not per person.',
  'Aleg pachetul': 'Choose a plan',
  'Dacă ai întrebări, răspunde la acest mail.': 'If you have any questions, just reply to this email.',
  '{0} are pachetul {1}, {2}: {3}, fără TVA, plătit cu cardul.':
    '{0} is on the {1} plan, {2}: {3}, excl. VAT, paid by card.',
  'Prima plată se ia la sfârșitul probei gratuite.':
    'The first payment is taken at the end of the free trial.',
  'Pachetul s-a pus singur. Factura și plățile sunt în Stripe → Clienți.':
    'The plan was set automatically. Invoices and payments are in Stripe → Customers.',
  'Pachet plătit: {0} — {1}, {2}': 'Plan paid: {0} — {1}, {2}',
  'comanda {0} către {1}, {2} fără TVA': 'order {0} to {1}, {2} excl. VAT',
  'De aprobat: {0} — {1}, {2}': 'To approve: {0} — {1}, {2}',
  '{0} îți cere aprobarea pentru {1}.': '{0} is asking you to approve {1}.',
  'Cererea: {0} · șantierul {1}': 'Request: {0} · site {1}',
  'Deschide comanda, vezi ofertele și aprobă sau respinge: {0}':
    'Open the order, see the quotes, and approve or reject it: {0}',
  'Ai o comandă de aprobat': 'You have an order to approve',
  '<b>{0}</b> îți cere aprobarea pentru comanda <b>{1}</b> către <b>{2}</b>: <b>{3}</b> fără TVA.':
    '<b>{0}</b> is asking you to approve order <b>{1}</b> to <b>{2}</b>: <b>{3}</b> excl. VAT.',
  'Deschide și aprobă': 'Open and approve',
  'Comanda nu pleacă la furnizor până nu e aprobată.':
    "The order won't go to the supplier until it's approved.",
  'Comanda {0} către {1} a fost aprobată de {2} și e emisă.':
    'Order {0} to {1} was approved by {2} and has been issued.',
  'Comanda {0} către {1} a fost respinsă de {2}.': 'Order {0} to {1} was rejected by {2}.',
  Nota: 'Note',
  'Aprobată: {0} — {1}': 'Approved: {0} — {1}',
  'Respinsă: {0} — {1}': 'Rejected: {0} — {1}',
  'O poți trimite furnizorului: {0}': 'You can send it to the supplier: {0}',
  'Vezi comanda și refă-o: {0}': 'See the order and redo it: {0}',
  'Comanda a fost aprobată': 'The order was approved',
  'Comanda a fost respinsă': 'The order was rejected',
  'Vezi și refă comanda': 'See and redo the order',
  ', necesar pe șantier la {0}': ', needed on site by {0}',
  'Necesar nou {0}: {1} — {2}': 'New requisition {0}: {1} — {2}',
  '{0} a trimis necesarul {1} pentru șantierul {2}{3}:': '{0} sent requisition {1} for the {2} site{3}:',
  '… și încă {0}': '… and {0} more',
  'Fă din el o cerere de ofertă sau respinge-l: {0}': 'Turn it into a request for quotes or reject it: {0}',
  'Necesar nou de pe șantier': 'New site requisition',
  '<b>{0}</b> a trimis necesarul <b>{1}</b> pentru șantierul <b>{2}</b>{3}.':
    '<b>{0}</b> sent requisition <b>{1}</b> for the <b>{2}</b> site{3}.',
  '<li style="color:{0}">… și încă {1}</li>': '<li style="color:{0}">… and {1} more</li>',
  'Deschide necesarul': 'Open the requisition',
  'Din necesar faci cererea de ofertă cu un clic: liniile se copiază singure.':
    'Turn the requisition into a request for quotes in one click: the lines copy across automatically.',
  '{0} a preluat necesarul {1} („{2}”) și cere oferte de la furnizori.':
    '{0} picked up requisition {1} ("{2}") and is requesting quotes from suppliers.',
  '{0} a respins necesarul {1} („{2}”).': '{0} rejected requisition {1} ("{2}").',
  'Motivul: {0}': 'Reason: {0}',
  'Preluat: {0} — {1}': 'Picked up: {0} — {1}',
  'Respins: {0} — {1}': 'Rejected: {0} — {1}',
  'Vezi unde a ajuns: {0}': 'See where it stands: {0}',
  'Necesarul tău e în lucru': 'Your requisition is in progress',
  'Necesarul tău a fost respins': 'Your requisition was rejected',
  'Vezi necesarul': 'See the requisition',
  'Îți scriem din nou când pleacă comanda la furnizor.':
    "We'll email you again when the order goes to the supplier.",
  '{0} a trimis oferta pentru „{1}”, prin linkul din mail.':
    '{0} sent their quote for "{1}" through the link in the email.',
  '{0} și-a schimbat oferta pentru „{1}”.': '{0} changed their quote for "{1}".',
  'Ofertă nouă: {0} — {1}': 'New quote: {0} — {1}',
  'Ofertă schimbată: {0} — {1}': 'Quote changed: {0} — {1}',
  '{0}. E deja în tabelul comparativ.': "{0}. It's already in the comparison table.",
  'Vezi cererea: {0}': 'See the request: {0}',
  'Ai primit o ofertă': "You've received a quote",
  'O ofertă s-a schimbat': 'A quote has changed',
  'Vezi cererea': 'See the request',
  '{0} a scris la „{1}” ({2}):': '{0} wrote on "{1}" ({2}):',
  'Comentariu nou: {0}': 'New comment: {0}',
  'Răspunde pe cerere: {0}': 'Reply on the request: {0}',
  'Comentariu nou': 'New comment',
  'Răspunde pe cerere': 'Reply on the request',
  'Bună ziua{0},': 'Dear{0},',
  'Vă transmitem comanda nr. {0} pentru „{1}”, conform ofertei dumneavoastră.':
    'Please find below purchase order no. {0} for "{1}", in line with your quotation.',
  'Nr. Reg. Com. {0}': 'Trade Register No. {0}',
  'Vă rugăm să ne confirmați primirea comenzii și data livrării.':
    'Please confirm receipt of this order and the delivery date.',
  'Pozițiile:': 'Items:',
  'Total fără TVA: {0}': 'Total excl. VAT: {0}',
  'TVA {0}%: {1}': 'VAT {0}%: {1}',
  'Total cu TVA: {0}': 'Total incl. VAT: {0}',
  'Cumpărător: {0}': 'Buyer: {0}',
  'Furnizor: {0}': 'Supplier: {0}',
  'Cu stimă,': 'Kind regards,',
  'Comandă trimisă prin Procumi în numele {0}. Răspunsul dumneavoastră ajunge la {1}.':
    'Order sent via Procumi on behalf of {0}. Your reply will go to {1}.',
  '<b>Mențiuni:</b> {0}': '<b>Notes:</b> {0}',
  'Mesaj trimis prin Procumi în numele {0}. Răspunsul dumneavoastră ajunge la {1}.':
    'Message sent via Procumi on behalf of {0}. Your reply will go to {1}.',
  'Planuri și documente (atașate la acest mesaj):': 'Drawings and documents (attached to this message):',
  'Planuri și documente, de descărcat:': 'Drawings and documents, to download:',
  'Puteți completa oferta direct online, fără cont: {0}\nSau răspundeți la acest mesaj, cu oferta atașată.':
    'You can fill in your quote directly online, no account needed: {0}\nOr reply to this message with your quote attached.',
  '<table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="margin:20px 0 0;border-collapse:collapse">\n<tr><th align="left" style="{0};width:28px">Nr.</th><th align="left" style="{1}">Produs</th><th align="right" style="{2}">Cantitate</th></tr>\n{3}\n</table>':
    '<table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="margin:20px 0 0;border-collapse:collapse">\n<tr><th align="left" style="{0};width:28px">No.</th><th align="left" style="{1}">Product</th><th align="right" style="{2}">Quantity</th></tr>\n{3}\n</table>',
  '<b>Planuri și documente</b>{0}': '<b>Drawings and documents</b>{0}',
  '<table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="margin:22px 0 0;border:1px solid #CFDCF5;border-radius:6px;background:#F2F6FE" bgcolor="#F2F6FE">\n<tr><td style="padding:16px">\n<p style="margin:0;font:400 14px/21px {0};color:{1}">Cel mai rapid: completați prețurile direct online, fără cont, în câteva minute.</p>\n<table role="presentation" cellpadding="0" cellspacing="0" border="0" style="margin:12px 0 0"><tr><td bgcolor="{2}" style="background:{3};border-radius:6px"><a href="{4}" style="display:inline-block;padding:12px 20px;font:600 15px/20px {5};color:#FFFFFF;text-decoration:none">{6}</a></td></tr></table>\n<p style="margin:12px 0 0;font:400 13px/19px {7};color:{8}">Sau răspundeți la acest mesaj, cu oferta atașată.</p>\n</td></tr></table>':
    '<table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="margin:22px 0 0;border:1px solid #CFDCF5;border-radius:6px;background:#F2F6FE" bgcolor="#F2F6FE">\n<tr><td style="padding:16px">\n<p style="margin:0;font:400 14px/21px {0};color:{1}">Quickest: enter your prices directly online, no account needed, in a few minutes.</p>\n<table role="presentation" cellpadding="0" cellspacing="0" border="0" style="margin:12px 0 0"><tr><td bgcolor="{2}" style="background:{3};border-radius:6px"><a href="{4}" style="display:inline-block;padding:12px 20px;font:600 15px/20px {5};color:#FFFFFF;text-decoration:none">{6}</a></td></tr></table>\n<p style="margin:12px 0 0;font:400 13px/19px {7};color:{8}">Or reply to this message with your quote attached.</p>\n</td></tr></table>',
  '1 lucru de rezolvat azi': '1 thing to sort out today',
  '{0} lucruri de rezolvat azi': '{0} things to sort out today',
  'Începe cu: {0} · {1}': 'Start with: {0} · {1}',
  '{0} de făcut': '{0} to do',
  '… și încă {0} în aplicație.': '… and {0} more in the app.',
  'Deschide panoul': 'Open the dashboard',
  '<p style="margin:28px 0 0;padding:14px 0 0;border-top:1px solid {0};font:400 12px/18px {1};color:{2}">Primești acest mail de luni până vineri la 7:50, doar în zilele în care ai ceva de rezolvat. <a href="{3}" style="color:{4};text-decoration:underline">Nu mai vreau acest mail</a></p>':
    '<p style="margin:28px 0 0;padding:14px 0 0;border-top:1px solid {0};font:400 12px/18px {1};color:{2}">You get this email Monday to Friday at 7:50, only on days when you have something to sort out. <a href="{3}" style="color:{4};text-decoration:underline">I don\'t want this email</a></p>',
  'Bună dimineața, {0}. {1}:': 'Good morning, {0}. {1}:',
  '… și încă {0} în aplicație: {1}': '… and {0} more in the app: {1}',
  'Primești acest mail de luni până vineri la 7:50, doar în zilele în care ai ceva de rezolvat.':
    'You get this email Monday to Friday at 7:50, only on days when you have something to sort out.',
  'Nu mai vreau acest mail: {0}': "I don't want this email: {0}",
  '{0} · Bună dimineața, {1}. Le-am pus în ordinea în care contează.':
    "{0} · Good morning, {1}. They're in order of importance.",
  'Fără răspuns': 'No reply',
  'Ofertă de verificat': 'Quote to check',
  'Termen pe șantier': 'Site deadline',
  'Cereri de ofertă, comparate rapid': 'Requests for quotes, compared fast',
  'Cumpărător:': 'Buyer:',
  'Furnizor:': 'Supplier:',
  nimic: 'nothing',
  '(atașate la acest mesaj)': '(attached to this message)',
  // apps/api/src/middleware/errors.ts
  'Ruta nu există.': "That route doesn't exist.",
  'Datele trimise nu sunt valide.': "The data sent isn't valid.",
  'Nu mă pot conecta la baza de date. Verifică DATABASE_URL și dacă PostgreSQL rulează.':
    "Can't connect to the database. Check DATABASE_URL and that PostgreSQL is running.",
  'Eroare pe server.': 'Server error.',
  // apps/api/src/notifications.ts
  'Necesarul {0} „{1}” a fost preluat într-o cerere de ofertă':
    'Requisition {0} "{1}" was picked up into a request for quotes',
  '{0} a primit oferta de la {1} pentru „{2}”: verific-o și salveaz-o':
    '{0} received the quote from {1} for "{2}": check it and save it',
  '{0} a primit un mail pe care nu l-a putut pune la o cerere: alege unde merge':
    "{0} received an email it couldn't match to a request: choose where it goes",
  // apps/api/src/offerLinkMail.ts
  '{0} din {1} poziții, {2} fără TVA': '{0} of {1} items, {2} excl. VAT',
  // apps/api/src/requisitionMail.ts
  'Cineva de pe șantier': 'Someone on site',
  // apps/api/src/rfqMailer.ts
  'Persoana de contact nu are adresă de email.': 'The contact person has no email address.',
  'Furnizorul nu face parte din această cerere.': "The supplier isn't part of this request.",
  'Cererea n-a plecat încă la acest furnizor.': "The request hasn't been sent to this supplier yet.",
  // apps/api/src/routes/admin.ts
  'Linkul nu a fost găsit sau a fost deja folosit.': 'Link not found or already used.',
  'Nu îți poți suspenda propria firmă.': "You can't suspend your own company.",
  'S-au înscris': 'Signed up',
  'Au pus furnizori': 'Added suppliers',
  'Au trimis prima cerere': 'Sent their first request',
  'Au primit o ofertă': 'Received a quote',
  'Au făcut o comandă': 'Placed an order',
  'Au cerut sau plătit un pachet': 'Requested or paid for a plan',
  // apps/api/src/routes/auth.ts
  'Ai cerut deja câteva coduri.': "You've already requested several codes.",
  'Există deja un cont cu acest email. Intră în cont cu el.':
    "There's already an account with this email. Sign in with it.",
  'Nu am putut trimite mailul cu codul. Încearcă din nou în câteva minute.':
    "We couldn't send the email with the code. Try again in a few minutes.",
  'Prea multe înscrieri de pe această adresă.': 'Too many sign-ups from this address.',
  'înscriere deschisă': 'open sign-up',
  'Codul a expirat. Apasă „Trimite alt cod".': 'The code has expired. Press "Send another code".',
  'Ai greșit codul de prea multe ori. Apasă „Trimite alt cod".':
    'You\'ve entered the wrong code too many times. Press "Send another code".',
  'Codul nu e bun. Verifică ultimul mail primit.':
    "That code isn't right. Check the latest email you received.",
  'Email sau parolă greșită.': 'Wrong email or password.',
  'Contul tău a fost scos din firmă. Vorbește cu un coleg.':
    'Your account has been removed from the company. Talk to a colleague.',
  'Invitația nu mai e valabilă. Cere-i colegului alta.':
    'The invitation is no longer valid. Ask your colleague for a new one.',
  'Există deja un cont cu acest email.': "There's already an account with this email.",
  'Firma a ajuns la numărul de utilizatori din pachetul ei. Roagă-l pe colegul care te-a invitat să treacă la un pachet mai mare.':
    'The company has reached the number of users in its plan. Ask the colleague who invited you to move to a bigger plan.',
  'Ai cerut deja de câteva ori un link.': "You've already asked for a link several times.",
  'Linkul de înscriere nu mai e valabil. Cere altul de la Procumi.':
    'The sign-up link is no longer valid. Ask Procumi for another.',
  'Linkul nu mai e valabil. Cere altul din „Am uitat parola".':
    'The link is no longer valid. Request another from "I forgot my password".',
  // apps/api/src/routes/boq.ts
  'Excelul vechi (.xls) nu se citește. Salvează-l ca .xlsx și încarcă-l din nou.':
    "Old Excel files (.xls) can't be read. Save it as .xlsx and upload it again.",
  'Citesc PDF, poze, Excel (.xlsx, .xls), CSV și text.': 'I read PDF, photos, Excel (.xlsx, .xls), CSV and text.',
  'Trimite un singur fișier.': 'Send a single file.',
  'Lipește textul antemăsurătorii': 'Paste the bill of quantities text',
  'Textul e prea lung': 'The text is too long',
  // apps/api/src/routes/company.ts
  'Pachetul Echipă are un singur prag de aprobare. Pașii pe valoare sunt în pachetul Companie.':
    'The Team plan has a single approval threshold. Value-based steps are on the Company plan.',
  'Doi pași au același prag. Fiecare pas are pragul lui.':
    'Two steps have the same threshold. Each step needs its own.',
  'Aprobatorul pentru fiecare șantier e în pachetul Companie.':
    'An approver per site is on the Company plan.',
  'Cine aprobă trebuie să fie un coleg activ cu rolul Aprobator.':
    'The approver must be an active colleague with the Approver role.',
  'Tu rămâi activ: ești cel care schimbă echipa.': "You stay active: you're the one changing the team.",
  'Pachetul {0} are {1} utilizatori. Alege cel mult atâția.':
    'The {0} plan has {1} users. Choose at most that many.',
  'Pachetul {0} are {1} șantiere active. Alege cel mult atâtea.':
    'The {0} plan has {1} active sites. Choose at most that many.',
  '{0} lei pe an': '{0} lei a year',
  '{0} lei pe lună': '{0} lei a month',
  'Imaginea e prea mare. Maximul e 512 KB.': 'The image is too big. The maximum is 512 KB.',
  'Trimite o singură imagine, în câmpul „file”.': 'Send a single image, in the "file" field.',
  'Firma nu are logo.': 'The company has no logo.',
  'Alege o imagine.': 'Choose an image.',
  'Logo-ul trebuie să fie PNG, JPG sau WebP.': 'The logo must be PNG, JPG or WebP.',
  // apps/api/src/routes/demo.ts
  'Datele demo se pot încărca doar în firma de demonstrație.':
    'Demo data can only be loaded into the demo company.',
  // apps/api/src/routes/inbox.ts
  'Cererea la care era pusă a fost ștearsă. Alege altă cerere.':
    'The request it was matched to has been deleted. Choose another request.',
  'Mailul nu a fost găsit.': 'Email not found.',
  'Oferta din mailul ăsta e deja salvată.': 'The quote from this email has already been saved.',
  'Documentul nu a fost găsit.': 'Document not found.',
  'Documentul „{0}” nu mai e pe server.': 'The document "{0}" is no longer on the server.',
  'Căsuța lui {0} nu e pornită.': "{0}'s inbox isn't switched on.",
  'Semnătura nu e bună.': "The signature isn't valid.",
  'Corp invalid.': 'Invalid body.',
  // apps/api/src/routes/morning.ts
  'Linkul nu mai e valabil.': 'The link is no longer valid.',
  // apps/api/src/routes/orders.ts
  'Alege întâi furnizorul.': 'Choose the supplier first.',
  'Furnizorul nu face parte din alegere.': "The supplier isn't part of the choice.",
  'Suplimentarea se face după ce comanda din cerere a fost emisă.':
    'A top-up order can be made once the order from the request has been issued.',
  'Cererea are deja o comandă emisă către furnizorul ăsta.':
    'The request already has an issued order to this supplier.',
  'Cererea e anulată.': 'The request is cancelled.',
  'Cererea are deja o comandă emisă către furnizorul ăsta. Anuleaz-o întâi.':
    'The request already has an issued order to this supplier. Cancel it first.',
  'Comanda e în EUR: scrie cursul (lei pentru 1 euro).':
    'The order is in EUR: enter the exchange rate (lei per euro).',
  'Pasul a fost deja decis de altcineva.': 'This step has already been decided by someone else.',
  'Comanda nu mai așteaptă aprobare.': 'The order is no longer awaiting approval.',
  'Doar cine are rolul Aprobator poate aproba comenzi.':
    'Only someone with the Approver role can approve orders.',
  'Pasul ăsta îl aprobă altcineva.': 'Someone else approves this step.',
  'Comanda nu face parte din această cerere.': "The order isn't part of this request.",
  'Comanda e deja anulată.': 'The order is already cancelled.',
  'Comanda nu e emisă.': "The order isn't issued.",
  'Comanda nu e emisă: întâi aprobarea.': "The order isn't issued: approval comes first.",
  'Comanda n-are emailul furnizorului. Scrie-l pe comandă.':
    'The order has no supplier email. Add it to the order.',
  'Comanda n-a plecat: {0}': "The order didn't go out: {0}",
  'Livrarea nu face parte din această comandă.': "The delivery isn't part of this order.",
  'Comanda din cerere așteaptă aprobare. Retrage-o din pagina comenzii dacă vrei s-o refaci.':
    'The order from the request is awaiting approval. Withdraw it from the order page if you want to redo it.',
  // apps/api/src/routes/prices.ts
  'Perioadă necunoscută.': 'Unknown period.',
  'Cererea de ofertă nu a fost găsită.': 'Request for quotes not found.',
  'Produsul nu are istoric de prețuri.': 'The product has no price history.',
  // apps/api/src/routes/profile.ts
  'Poza e prea mare.': 'The photo is too big.',
  'Trimite o singură poză.': 'Send a single photo.',
  'Fără poză.': 'No photo.',
  'Spune dacă mailul e pornit sau oprit.': 'Say whether the email is on or off.',
  'Alege limba: română sau engleză.': 'Choose a language: Romanian or English.',
  'Spune dacă raportul e pornit sau oprit.': 'Say whether the report is on or off.',
  'Lipește semnătura din Outlook (Ctrl+V în chenar).': 'Paste your Outlook signature (Ctrl+V in the box).',
  'Semnătura e prea mare. Scoate imaginile mari sau textul în plus.':
    'The signature is too big. Remove large images or extra text.',
  'Alege o poză.': 'Choose a photo.',
  'Poza trebuie să fie PNG, JPG sau WebP.': 'The photo must be PNG, JPG or WebP.',
  // apps/api/src/routes/publicOffer.ts
  'Prea multe încercări. Încearcă din nou peste un sfert de oră.':
    'Too many attempts. Try again in fifteen minutes.',
  'Linkul nu e bun. Verifică-l în mail sau răspunde direct la mail.':
    "This link isn't valid. Check it in the email or reply directly to the email.",
  'Cererea s-a încheiat; planurile nu mai sunt disponibile.':
    'The request has closed; the drawings are no longer available.',
  'Planul nu mai face parte din cerere.': 'The drawing is no longer part of the request.',
  'Cererea s-a încheiat; datele firmei nu se mai pot trimite de aici.':
    'The request has closed; company details can no longer be sent from here.',
  'Prea multe salvări. Încercați din nou peste o oră.': 'Too many saves. Please try again in an hour.',
  'CUI-ul nu există la ANAF. Verificați-l pe o factură.':
    "This CUI doesn't exist at ANAF. Please check it on an invoice.",
  'Oferta voastră a fost deja primită. Pentru schimbări, răspundeți la mail.':
    'Your quote has already been received. For any changes, please reply to the email.',
  'Cererea s-a încheiat și nu mai primește oferte.':
    'The request has closed and is no longer accepting quotes.',
  // apps/api/src/routes/receiving.ts
  'Livrările de aici sunt pentru contul de șantier; tu le treci din pagina comenzii.':
    'Deliveries here are for the site account; you log them from the order page.',
  'Livrarea e confirmată de Achiziții: o mai schimbă doar ei.':
    'The delivery has been confirmed by Purchasing: only they can change it now.',
  'Livrarea a trecut-o altcineva: o schimbă el sau Achizițiile.':
    'Someone else logged this delivery: they or Purchasing can change it.',
  // apps/api/src/routes/reorder.ts
  'Data de valabilitate a trecut deja.': 'The validity date has already passed.',
  'Furnizorul nu mai e în agendă.': 'The supplier is no longer in your address book.',
  'Prețul nu a fost găsit.': 'Price not found.',
  'Oferta aleasă nu are prețuri pe bucată de păstrat.': 'The chosen quote has no unit prices to keep.',
  'Locul ales nu există.': "The chosen location doesn't exist.",
  'Lista nu a fost găsită.': 'List not found.',
  '„{0}” e închis. Redeschide-l sau alege altul.': '"{0}" is closed. Reopen it or choose another.',
  'Fără preț convenit valabil: {0}. Scoate-le din comandă sau cere oferte pentru ele.':
    'No valid agreed price: {0}. Remove them from the order or request quotes for them.',
  'Comandă la prețurile convenite, fără cerere de ofertă.':
    'Order at the agreed prices, without a request for quotes.',
  'Preț convenit': 'Agreed price',
  'Fiecare produs are nevoie de denumire': 'Each product needs a name',
  'Scrie unitatea': 'Enter the unit',
  'Prețul trebuie să fie mai mare decât zero': 'The price must be greater than zero',
  'Adaugă cel puțin un produs': 'Add at least one product',
  'Dă un nume listei': 'Give the list a name',
  'Alege locul de livrare': 'Choose the delivery location',
  'Scrie cel puțin o cantitate': 'Enter at least one quantity',
  // apps/api/src/routes/requisitions.ts
  'Necesarul îl preiau sau îl resping achizițiile.': 'Requisitions are picked up or rejected by purchasing.',
  'Șantierul ales nu există.': "The chosen site doesn't exist.",
  'Șantierul „{0}” e închis.': 'Site "{0}" is closed.',
  'Necesarul îl modifică doar cine l-a trimis sau achizițiile.':
    'A requisition can only be changed by whoever sent it, or by purchasing.',
  'Necesarul nu se mai poate modifica: a fost preluat, respins sau retras.':
    "The requisition can no longer be changed: it's been picked up, rejected or withdrawn.",
  'Necesarul nu mai așteaptă: a fost deja preluat, respins sau retras.':
    "The requisition is no longer waiting: it's already been picked up, rejected or withdrawn.",
  'Doar cine a trimis necesarul îl poate retrage.':
    'Only the person who sent the requisition can withdraw it.',
  'Necesarul a fost deja preluat sau respins.': 'The requisition has already been picked up or rejected.',
  'Se poate redeschide doar un necesar respins.': 'Only a rejected requisition can be reopened.',
  // apps/api/src/routes/rfqs.ts
  'Comanda {0} e emisă către {1}. Anuleaz-o întâi, apoi {2}.':
    'Order {0} has been issued to {1}. Cancel it first, then {2}.',
  'Tipul de fișier „{0}” nu e acceptat.': 'The file type "{0}" isn\'t accepted.',
  'Trimite un singur fișier, în câmpul „file”.': 'Send a single file, in the "file" field.',
  'Șantierul „{0}” e închis. Redeschide-l sau alege altul.':
    'Site "{0}" is closed. Reopen it or choose another.',
  'Unul dintre necesare nu mai există.': 'One of the requisitions no longer exists.',
  'Necesarul NC-{0} nu mai așteaptă: a fost preluat, respins sau retras.':
    "Requisition NC-{0} is no longer waiting: it's been picked up, rejected or withdrawn.",
  'Necesarul NC-{0} e pentru alt șantier. O cerere are un singur șantier.':
    'Requisition NC-{0} is for a different site. A request has only one site.',
  'Unul dintre furnizorii aleși nu mai e în agendă.':
    'One of the chosen suppliers is no longer in your address book.',
  'Persoana aleasă nu mai există la „{0}”.': 'The chosen contact no longer exists at "{0}".',
  'Furnizorul „{0}” nu are nicio persoană de contact.': 'Supplier "{0}" has no contact person.',
  'Unul dintre necesare tocmai a fost preluat de altcineva.':
    'One of the requisitions has just been picked up by someone else.',
  'Încarcă șablonul ca fișier Excel (.xlsx).': 'Upload the template as an Excel file (.xlsx).',
  'Fișierul e prea mare. Maximul e 5 MB.': 'The file is too big. The maximum is 5 MB.',
  'Cererea nu a plecat către furnizorul ăsta.': "The request wasn't sent to this supplier.",
  'schimbă împărțirea': 'change the split',
  'schimbă furnizorul': 'change the supplier',
  'șterge alegerea': 'remove the choice',
  'anulează cererea': 'cancel the request',
  'șterge cererea': 'delete the request',
  'Oferta e în EUR: scrie cursul (lei pentru 1 euro).':
    'The quote is in EUR: enter the exchange rate (lei per euro).',
  'Introdu cel puțin un preț.': 'Enter at least one price.',
  'Mailul către acest furnizor nu e marcat ca trimis.': "The email to this supplier isn't marked as sent.",
  'Furnizorul nu are încă o ofertă.': "The supplier doesn't have a quote yet.",
  'Comentariul nu mai există.': 'The comment no longer exists.',
  'Poți șterge doar comentariile tale.': 'You can only delete your own comments.',
  'Fișierul e prea mare. Maximul e {0} MB pe fișier.': 'The file is too big. The maximum is {0} MB per file.',
  'Planul nu face parte din această cerere.': "The drawing isn't part of this request.",
  'O cerere poate avea cel mult {0} planuri și documente.':
    'A request can have at most {0} drawings and documents.',
  'Documentul nu face parte din această cerere.': "The document isn't part of this request.",
  'Nu ai trimis niciun document.': "You didn't send any documents.",
  'Un furnizor poate avea cel mult {0} documente pe o cerere.':
    'A supplier can have at most {0} documents on a request.',
  'Citirea automată a ofertelor nu e pornită. Completează prețurile manual.':
    "Automatic reading of quotes isn't switched on. Fill in the prices by hand.",
  // apps/api/src/routes/sites.ts
  'Șantierul are {0} {1} de ofertă, deci nu poate fi șters. Închide-l.':
    "The site has {0} {1} for quotes, so it can't be deleted. Close it instead.",
  // apps/api/src/routes/suppliers.ts
  'ANAF nu răspunde acum. Completează de mână; verificarea se reia la noapte.':
    "ANAF isn't responding right now. Fill it in by hand; the check runs again overnight.",
  'Furnizorul nu a fost găsit.': 'Supplier not found.',
  'Furnizorul nu are CUI.': 'The supplier has no CUI.',
  'ANAF nu răspunde acum. Încearcă din nou mai târziu.': "ANAF isn't responding right now. Try again later.",
  // apps/api/src/routes/team.ts
  'Omul ăsta e deja în firmă.': 'This person is already in the company.',
  'Invitația nu a fost găsită.': 'Invitation not found.',
  'Nu te poți scoate pe tine din firmă.': "You can't remove yourself from the company.",
  'Utilizatorul nu a fost găsit.': 'User not found.',
  'Colegul nu a fost găsit.': 'Colleague not found.',
  'Un șantier nu există.': "A site doesn't exist.",
  // apps/api/src/serialize.ts
  'furnizor șters': 'deleted supplier',
  // apps/api/src/storage.ts
  'Tipul de fișier nu e acceptat.': "The file type isn't accepted.",
  'Cale de fișier invalidă.': 'Invalid file path.',
  // apps/api/src/templateImport.ts
  'Adusă din șablonul Excel de comparație.': 'Imported from the Excel comparison template.',
  'Excel (șablon)': 'Excel (template)',
  // apps/api/src/validation/schemas.ts
  'Parola trebuie să aibă cel puțin 8 caractere': 'The password must be at least 8 characters',
  'Parola e prea lungă': 'The password is too long',
  'Link de înscriere nevalabil': 'Invalid sign-up link',
  'Alege țara din listă': 'Choose the country from the list',
  'Completează numele tău': 'Enter your name',
  'Alege din listă': 'Choose from the list',
  'Codul are 6 cifre': 'The code has 6 digits',
  'Data trebuie să fie AAAA-LL-ZZ.': 'The date must be YYYY-MM-DD.',
  'Data nu există.': "That date doesn't exist.",
  'Pachet necunoscut': 'Unknown plan',
  'Alege lunar sau anual': 'Choose monthly or yearly',
  'Nu ai trimis nicio modificare.': "You haven't sent any changes.",
  'Completează parola': 'Enter the password',
  'Link de parolă nevalabil': 'Invalid password link',
  'Rol necunoscut': 'Unknown role',
  'Pragul nu poate fi negativ': "The threshold can't be negative",
  'Cel mult 5 pași': 'At most 5 steps',
  'Link de invitație nevalabil': 'Invalid invitation link',
  'Categoria nu poate fi goală': "The category can't be empty",
  'Prea multe categorii': 'Too many categories',
  'Prea multe persoane de contact': 'Too many contacts',
  'Nu e niciun furnizor nou de importat.': 'There are no new suppliers to import.',
  'Bugetul trebuie să fie mai mare decât zero': 'The budget must be greater than zero',
  'Bugetul pare greșit': 'The budget looks wrong',
  'Termenul de răspuns trebuie în formatul AAAA-LL-ZZ': 'The reply deadline must be in YYYY-MM-DD format',
  'Data „necesar pe șantier” trebuie în formatul AAAA-LL-ZZ':
    'The "needed on site" date must be in YYYY-MM-DD format',
  'Completează descrierea poziției': 'Enter the item description',
  'Cantitatea trebuie să fie mai mare decât zero': 'The quantity must be greater than zero',
  'Durata chiriei e în zile întregi': 'The rental period is in whole days',
  'Durata chiriei trebuie să fie de cel puțin o zi': 'The rental period must be at least one day',
  'Durata chiriei e prea mare': 'The rental period is too long',
  'Alege furnizorul': 'Choose the supplier',
  'Valoarea nu poate fi negativă': "The value can't be negative",
  'Totalul pachetului trebuie să fie mai mare decât zero': 'The set total must be greater than zero',
  'Scrie ce e costul (de exemplu „descărcare”)': 'Say what the cost is (e.g. "unloading")',
  'Costul trebuie să fie mai mare decât zero': 'The cost must be greater than zero',
  'Data trebuie în formatul AAAA-LL-ZZ': 'The date must be in YYYY-MM-DD format',
  'Fiecare poziție suplimentară are nevoie de denumire': 'Each extra item needs a description',
  'Cursul pare greșit': 'The exchange rate looks wrong',
  'Textul ofertei e prea lung': 'The quote text is too long',
  'Prețul trebuie să fie mai mare decât zero.': 'The price must be greater than zero.',
  'Scrie comentariul.': 'Write your comment.',
  'Județ necunoscut.': 'Unknown county.',
  'Trimite un document urcat sau textul ofertei, nu amândouă.':
    'Send an uploaded document or the quote text, not both.',
  'Scrie adresa de livrare': 'Enter the delivery address',
  'Data de livrare trebuie în formatul AAAA-LL-ZZ': 'The delivery date must be in YYYY-MM-DD format',
  'Fiecare poziție are nevoie de denumire': 'Each item needs a description',
  'Fiecare poziție are nevoie de un preț mai mare decât zero': 'Each item needs a price greater than zero',
  'Comanda are nevoie de cel puțin o poziție': 'The order needs at least one item',
  'Scrie de ce respingi comanda.': "Say why you're rejecting the order.",
  'Scrie materialul': 'Enter the material',
  'Cel mult 100 de linii într-un necesar': 'At most 100 lines in a requisition',
  'Scrie de ce îl respingi: omul de pe șantier primește motivul':
    "Say why you're rejecting it: the person on site gets the reason",
  // apps/web/src/App.tsx
  'Plata nu s-a făcut. Poți alege pachetul oricând din „Contul firmei”.':
    'Payment didn\'t go through. You can choose a plan any time from "Company account".',
  'Mulțumim! Plata a trecut; pachetul apare în câteva secunde.':
    'Thank you! Payment received; your plan will show up in a few seconds.',
  'Încarci datele demo?': 'Load the demo data?',
  'Se șterg furnizorii și cererile firmei, apoi se încarcă datele demo.':
    "The company's suppliers and requests will be deleted, then the demo data will be loaded.",
  'Încarcă datele demo': 'Load demo data',
  'Datele demo au fost încărcate': 'Demo data loaded',
  // apps/web/src/components/ApprovalPanel.tsx
  'Scrie de ce respingi comanda: omul care a cerut-o primește motivul.':
    "Say why you're rejecting the order: the person who raised it will see your reason.",
  'Ai aprobat comanda {0}': 'You approved order {0}',
  'Ai respins comanda {0}': 'You rejected order {0}',
  'Așteaptă aprobare': 'Awaiting approval',
  'Respinsă la aprobare': 'Rejected at approval',
  Aprobată: 'Approved',
  'Vezi comparația ofertelor': 'See the quote comparison',
  'Comanda nu pleacă la furnizor până nu trece de toți pașii. Valoarea: {0} fără TVA.{1}':
    "The order won't go to the supplier until it clears every step. Value: {0} excl. VAT.{1}",
  ' E o parte dintr-o comandă împărțită de {0}: pragurile se socotesc pe toată împărțirea.':
    " It's part of an order split by {0}: the thresholds apply to the whole split.",
  'Peste {0}: {1}': 'Over {0}: {1}',
  'oricare aprobator': 'any approver',
  'Aprobată de {0}{1}': 'Approved by {0}{1}',
  'Respinsă de {0}{1}': 'Rejected by {0}{1}',
  'Așteaptă decizia': 'Waiting for a decision',
  'Nu s-a mai ajuns aici': 'Not reached',
  'Notă (la respingere, obligatorie)': 'Note (required if you reject)',
  'ex. Negociază transportul inclus și retrimite': 'e.g. Negotiate delivery included and resend',
  Respinge: 'Reject',
  'Aprobă comanda': 'Approve order',
  // apps/web/src/components/ApprovalSection.tsx
  'Nu am putut încărca regulile.': "Couldn't load the rules.",
  'Aprobarea comenzilor': 'Order approvals',
  șantier: 'site',
  'Alege pachetul': 'Choose a plan',
  'Scrie pragul fiecărui pas, în lei fără TVA': 'Enter the threshold for each step, in lei excl. VAT',
  'Regulile de aprobare au fost salvate': 'Approval rules saved',
  'Comenzile se emit fără aprobare': 'Orders are issued without approval',
  'orice aprobator': 'any approver',
  șantierului: 'site',
  'O comandă trece prin toți pașii al căror prag îl depășește, de la cel mai mic la cel mai mare. Fără pași, comenzile se emit direct.':
    'An order goes through every step whose threshold it exceeds, from lowest to highest. With no steps, orders are issued straight away.',
  'Comenzile peste prag se emit abia după ce le aprobă cineva cu rolul Aprobator. Fără prag, se emit direct.':
    "Orders above the threshold are only issued once someone with the Approver role approves them. With no threshold, they're issued straight away.",
  'Nimeni din firmă nu are încă rolul Aprobator. Îl dai din fila „Echipa”.':
    'Nobody in the company has the Approver role yet. You can give it in the "Team" tab.',
  'Comenzile de peste': 'Orders over',
  lei: 'lei',
  'le aprobă': 'are approved by',
  'Cine aprobă pasul {0}': 'Who approves step {0}',
  Scoate: 'Remove',
  'Acum comenzile se emit fără aprobare.': 'Orders are now issued without approval.',
  'Adaugă un pas': 'Add a step',
  'Cere aprobare peste un prag': 'Require approval above a threshold',
  'Se salvează…': 'Saving…',
  'Salvează regulile': 'Save rules',
  'Regulile le schimbă un administrator al contului.': 'Rules are changed by an account administrator.',
  'Aprobatorul pentru {0}': 'Approver for {0}',
  Salvează: 'Save',
  'Comenzile de peste o anumită valoare trec întâi pe la directorul de achiziții sau la CFO, apoi se emit. Aprobările sunt incluse din pachetul Echipă; în Companie poți avea mai mulți pași și câte un aprobator pe fiecare șantier.':
    "Orders above a set value go to the purchasing manager or CFO first, then they're issued. Approvals come with the Team plan; on Company you can have several steps and one approver per site.",
  'aprobatorul șantierului': "the site's approver",
  'Pași pe valoare și aprobator pe fiecare șantier: în pachetul Companie.':
    'Value-based steps and an approver per site: on the Company plan.',
  'Aprobatorul fiecărui șantier': 'Approver for each site',
  'Pentru pașii „aprobatorul șantierului”. Un șantier fără aprobator trece la oricare aprobator.':
    'For "the site\'s approver" steps. A site with no approver goes to any approver.',
  // apps/web/src/components/AskDialog.tsx
  'Notat: l-ai întrebat pe {0}': 'Noted: you asked {0}',
  'Întrebări pentru {0}': 'Questions for {0}',
  ' · ai mai întrebat {0}': " · you've asked before {0}",
  'Oferta lui iese cea mai ieftină, dar lipsește {0}. Când răspunde, trece răspunsul în ofertă și comparația se reface.':
    'Their quote comes out cheapest, but {0} is missing. When they reply, add the answer to the quote and the comparison updates.',
  'Subiect:': 'Subject:',
  'Copiază subiectul': 'Copy subject',
  Anulează: 'Cancel',
  'Copiază textul': 'Copy text',
  'Am întrebat': "I've asked",
  // apps/web/src/components/Avatar.tsx
  ' (a răspuns)': ' (replied)',
  ' (așteptăm)': ' (waiting)',
  '{0} din {1}': '{0} of {1}',
  // apps/web/src/components/Bell.tsx
  'Notificări, {0} necitite': 'Notifications, {0} unread',
  Notificări: 'Notifications',
  'Marchează toate ca citite': 'Mark all as read',
  necitită: 'unread',
  'Nimic nou. Aici apar comenzile de aprobat, ofertele noi, comentariile și necesarele care te privesc.':
    'Nothing new. Orders to approve, new quotes, comments and requisitions that concern you show up here.',
  // apps/web/src/components/CategoryPicker.tsx
  'Scoate categoria {0}': 'Remove category {0}',
  'Alege cel puțin o categorie.': 'Choose at least one category.',
  'Adaugă categorie': 'Add category',
  Adaugă: 'Add',
  // apps/web/src/components/ChoiceDialog.tsx
  'Oferta a expirat pe {0}: confirmă prețurile cu furnizorul.':
    'The quote expired on {0}: confirm the prices with the supplier.',
  '{0}: propune alt produs — {1}.': '{0}: offers a different product — {1}.',
  'Accepți și produsele echivalente propuse de {0}.': 'This also accepts the equivalent products {0} proposed.',
  'Alege furnizorul.': 'Choose the supplier.',
  'Valoarea comenzii nu e un număr.': "The order value isn't a number.",
  'Furnizor ales': 'Supplier chosen',
  'Alegerea a fost ștearsă': 'Choice removed',
  'Schimbă furnizorul ales': 'Change the chosen supplier',
  'Cu cine ai rămas?': 'Who did you go with?',
  'Acum comanda e împărțită între {0}. Dacă salvezi un singur furnizor, renunți la împărțire.':
    'The order is currently split between {0}. If you save a single supplier, the split is dropped.',
  '· ofertă parțială': '· partial quote',
  '· fără ofertă completă': '· no complete quote',
  '· {0} lei': '· {0} lei',
  'cel mai ieftin': 'cheapest',
  'Înainte să alegi:': 'Before you choose:',
  'Valoarea comenzii (lei fără TVA)': 'Order value (lei excl. VAT)',
  opțional: 'optional',
  'Valoarea vine din comanda {0}. Ca s-o schimbi, anulează comanda și refă-o.':
    'The value comes from order {0}. To change it, cancel the order and redo it.',
  'Se completează cu totalul ofertei, dar poți scrie ce ai comandat de fapt.':
    'Filled in with the quote total, but you can enter what you actually ordered.',
  'Motivul alegerii': 'Reason for the choice',
  'livra în 3 zile': 'delivers in 3 days',
  'Un rând ajunge. Contează mai ales când n-a fost cel ieftin.':
    "One line is enough. It matters most when it wasn't the cheapest.",
  'Închide și cererea': 'Close the request too',
  'Șterge alegerea': 'Remove choice',
  'Se scrie în istoricul șantierului și în scorecard-ul furnizorilor. Dacă n-ai ales cel mai ieftin, motivul e partea folositoare peste un an.':
    "This goes into the site's history and the supplier scorecard. If you didn't pick the cheapest, the reason is what will be useful a year from now.",
  // apps/web/src/components/CofrajHelper.tsx
  Pereți: 'Walls',
  'Înălțime turnare (m)': 'Pour height (m)',
  'cofraj vertical pereți': 'vertical wall formwork',
  Stâlpi: 'Columns',
  'cofraj stâlpi': 'column formwork',
  Fundații: 'Foundations',
  'cofraj fundații': 'foundation formwork',
  Grinzi: 'Beams',
  'Înălțime grindă (cm)': 'Beam depth (cm)',
  'cofraj grinzi': 'beam formwork',
  Planșeu: 'Slab',
  'Grosime placă (cm)': 'Slab thickness (cm)',
  'cofraj planșeu': 'slab formwork',
  'Adaugă în poziții': 'Add to items',
  'Scrie durata chiriei în zile întregi.': 'Enter the rental period in whole days.',
  'Scrie înălțimea de sprijinire, în m. Pentru mai multe: 3; 4; 6.':
    'Enter the propping height in m. For several: 3; 4; 6.',
  'Completează: {0}. Pentru mai multe: 3; 4; 6.': 'Fill in: {0}. For several: 3; 4; 6.',
  'Completează: {0}.': 'Fill in: {0}.',
  'sprijinire la {0} m': 'propped at {0} m',
  'înălțime turnare {0} m': 'pour height {0} m',
  'Scrie suprafața pentru înălțimea de {0} m.': 'Enter the area for the {0} m height.',
  'Scrie suprafața de cofrat, în mp.': 'Enter the formwork area in m².',
  'Poziție de cofraj': 'Formwork item',
  'Ca furnizorii să oferteze același lucru și ofertele să se poată compara.':
    'So suppliers quote for the same thing and the quotes can be compared.',
  Element: 'Element',
  'Suprafață (mp)': 'Area (m²)',
  '3 sau 3; 4; 6': '3 or 3; 4; 6',
  'Înălțime sprijinire (m)': 'Propping height (m)',
  Regim: 'Basis',
  Închiriere: 'Rental',
  Cumpărare: 'Purchase',
  'Durată estimată (zile)': 'Estimated duration (days)',
  'Ai scris {0} înălțimi: {1} m. Cantitățile de la înălțimi diferite nu se adună.':
    "You entered {0} heights: {1} m. Quantities at different heights aren't added together.",
  'Cum se cer înălțimile': 'How to request the heights',
  'O singură poziție': 'One item',
  'Câte o poziție pe înălțime': 'One item per height',
  '· fiecare cu suprafața ei': '· each with its own area',
  'Suprafață la {0} m (mp)': 'Area at {0} m (m²)',
  'Adaugă {0} poziții': 'Add {0} items',
  '· aceleași materiale, diferă doar înălțimea popilor': '· same materials, only the prop height differs',
  '· aceleași materiale, diferă doar înălțimea': '· same materials, only the height differs',
  mp: 'm²',
  // apps/web/src/components/CommandSearch.tsx
  'Cereri de ofertă': 'Requests for quotes',
  '{0} · {1} · {2} din {3} oferte': '{0} · {1} · {2} of {3} quotes',
  Furnizori: 'Suppliers',
  Șantiere: 'Sites',
  închis: 'closed',
  Comenzi: 'Orders',
  'Caută cereri, furnizori, șantiere, comenzi…': 'Search requests, suppliers, sites, orders…',
  Caută: 'Search',
  Esc: 'Esc',
  'Nimic pentru „{0}”.': 'Nothing for "{0}".',
  'Scrie ce cauți.': "Type what you're looking for.",
  Enter: 'Enter',
  alegi: 'to choose',
  deschizi: 'to open',
  // apps/web/src/components/Comments.tsx
  'Ștergi comentariul?': 'Delete the comment?',
  'Dispare din discuție. Cine a primit deja mailul îl păstrează.':
    'It disappears from the discussion. Anyone who already got the email keeps it.',
  Șterge: 'Delete',
  Discuție: 'Discussion',
  'Doar echipa ta vede discuția': 'Only your team sees this discussion',
  'Fost coleg': 'Former colleague',
  'Scrie un comentariu…': 'Write a comment…',
  'Se trimite…': 'Sending…',
  Trimite: 'Send',
  'Lasă o notă pentru colegi: ce ai negociat, de ce alegi un furnizor, ce trebuie verificat. Responsabilii șantierului primesc un mail.':
    "Leave a note for colleagues: what you negotiated, why you're picking a supplier, what needs checking. The people responsible for the site get an email.",
  // apps/web/src/components/CommitMonths.tsx
  'pe șantier': 'at the site',
  '{0}: achiziționat {1}, angajat {2}, planificat {3}': '{0}: bought {1}, committed {2}, planned {3}',
  Achiziționat: 'Bought',
  Angajat: 'Committed',
  Planificat: 'Planned',
  'include fără dată: {0}': 'includes undated: {0}',
  'O cerere nu are încă ofertă completă, deci nu intră la planificat.':
    "One request has no complete quote yet, so it isn't counted as planned.",
  '{0} cereri nu au încă ofertă completă, deci nu intră la planificat.':
    "{0} requests have no complete quote yet, so they aren't counted as planned.",
  'Nicio comandă emisă și nicio ofertă de estimat încă. Graficul se umple din comenzile tale: ce a venit pe șantier, ce e comandat și ce urmează.':
    "No orders issued and no quotes to estimate from yet. The chart fills up from your orders: what has arrived at the site, what's on order and what's coming.",
  '{0} angajat': '{0} committed',
  '{0} planificat': '{0} planned',
  // apps/web/src/components/ComparisonTable.tsx
  'Nicio ofertă încă. Când un furnizor răspunde, apasă „Adaugă oferta” și prețurile apar aici, poziție cu poziție.':
    'No quotes yet. When a supplier replies, press "Add quote" and the prices appear here, item by item.',
  ' + transport': ' + delivery',
  Poziție: 'Item',
  '{0} · ofertă parțială': '{0} · partial quote',
  'alt regim decât cel cerut': 'different basis from the one requested',
  'ofertă incompletă': 'incomplete quote',
  'în euro · curs {0}': 'in euros · rate {0}',
  ' · chirie, {0}': ' · rental, {0}',
  'nu se compară': 'not compared',
  'cel mai mic': 'lowest',
  ' + {0} o dată': ' + {0} one-off',
  'Propune:': 'Offers instead:',
  'Ofertă parțială: {0}': 'Partial quote: {0}',
  'Poziții suplimentare ofertate': 'Extra items quoted',
  'puse de furnizor în plus față de cerere; nu intră în costul total':
    'added by the supplier on top of the request; not included in the total cost',
  'suplimentar · {0}': 'extra · {0}',
  'fără sumă': 'no amount',
  'Valoare poziții': 'Items value',
  Transport: 'Delivery',
  'separat, suma nu se știe': 'charged separately, amount unknown',
  'Alte costuri': 'Other costs',
  'Cost total fără TVA': 'Total cost excl. VAT',
  'Total fără TVA': 'Total excl. VAT',
  'cea mai mică completă': 'lowest complete',
  'ofertă parțială: nu se compară la total': 'partial quote: not compared on total',
  'Prețurile ofertei față de ce ai plătit ultima dată sau, unde n-ai comandat încă, față de media ta.':
    "The quote's prices compared with what you paid last time or, where you haven't ordered yet, with your average.",
  'Față de istoric': 'Against history',
  'pe {0} din {1} poziții': 'on {0} of {1} items',
  'Poziții suplimentare': 'Extra items',
  '+ {0} fără sumă': '+ {0} with no amount',
  'separat, în afara totalului': 'separate, outside the total',
  Avans: 'Deposit',
  'nu spune': 'not stated',
  'Termen plată': 'Payment terms',
  'Termen livrare': 'Delivery time',
  'Valabilitate ofertă': 'Quote valid',
  Observații: 'Notes',
  'Înainte să alegi, întreabă-l pe {0}: {1}.{2}': 'Before you choose, ask {0}: {1}.{2}',
  ' Ai întrebat {0}.': ' You asked {0}.',
  Întreabă: 'Ask',
  'Cel mai mic cost total': 'Lowest total cost',
  'Cel mai mic total': 'Lowest total',
  'Dacă împarți comanda pe poziții': 'If you split the order by item',
  '−{0} față de cel mai mic total': '−{0} compared with the lowest total',
  'Schimbă împărțirea': 'Change the split',
  'Împarte comanda': 'Split the order',
  'Diferență între oferte': 'Spread between quotes',
  'între cea mai mică și cea mai mare completă': 'between the lowest and highest complete quote',
  'Cum se compară': 'How the comparison works',
  'Prețuri unitare în lei fără TVA; ofertele în euro sunt trecute în lei la cursul de sub furnizor. La chirie se compară costul pe toată durata cerută. Costul total adaugă transportul și costurile pe comandă; la comanda minimă se socotește cantitatea plătită. Pozițiile suplimentare puse de furnizor se arată separat și nu intră în costul total. O ofertă parțială (mai puțin decât s-a cerut) se vede, dar nu câștigă. Verde = cel mai bun preț pe poziție.':
    "Unit prices in lei excl. VAT; quotes in euros are converted to lei at the rate shown under the supplier. For rentals, the cost over the whole requested period is compared. The total cost adds delivery and per-order charges; where there's a minimum order, the quantity you'd pay for is used. Extra items added by the supplier are shown separately and aren't included in the total cost. A partial quote (less than requested) is shown but can't win. Green = best price per item.",
  'mai puțin': 'less',
  'mai mult': 'more',
  '{0}/{1}/lună': '{0}/{1}/month',
  'expirată pe {0}': 'expired on {0}',
  'până pe {0}': 'until {0}',
  // apps/web/src/components/dashboard/ActiveRfqsTable.tsx
  Întârziat: 'Overdue',
  'Comparație gata': 'Comparison ready',
  'De comandat': 'To order',
  Așteaptă: 'Waiting',
  Netrimisă: 'Not sent',
  Toate: 'All',
  Întârziate: 'Overdue',
  'Achiziții în lucru': 'Purchasing in progress',
  'Cererile de ofertă deschise pe șantierele tale': 'Open requests for quotes on your sites',
  'Toate cererile →': 'All requests →',
  'Toate {0}': 'All {0}',
  'Caută cerere, material': 'Search request, material',
  'Caută în cereri': 'Search requests',
  Cerere: 'Request',
  Răspunsuri: 'Replies',
  Termen: 'Deadline',
  Acțiune: 'Action',
  'încă {0} în „Cereri de ofertă” →': '{0} more in "Requests for quotes" →',
  'Nicio cerere nu se potrivește filtrului.': 'No requests match the filter.',
  'Nicio cerere deschisă.': 'No open requests.',
  'Toate șantierele': 'All sites',
  'Cea mai bună': 'Best',
  // apps/web/src/components/dashboard/AttentionPanel.tsx
  Ascunde: 'Hide',
  'Necesită atenție': 'Needs attention',
  'Lucrurile din achiziții care așteaptă un pas de la tine': 'Purchasing items waiting for a step from you',
  'Nimic nu așteaptă după tine acum': 'Nothing is waiting on you right now',
  Urgent: 'Urgent',
  'De făcut': 'To do',
  'Totul e la zi: nicio ofertă de comparat, niciun furnizor care întârzie, nicio livrare restantă.':
    'All up to date: no quotes to compare, no late suppliers, no overdue deliveries.',
  // apps/web/src/components/dashboard/Bridge.tsx
  'Unde sunt achizițiile acum': 'Where purchasing stands now',
  // apps/web/src/components/dashboard/DashboardHeader.tsx
  'Luna aceasta': 'This month',
  'Ultimele 30 de zile': 'Last 30 days',
  'Ultimele 90 de zile': 'Last 90 days',
  'Anul acesta': 'This year',
  'Perioadă aleasă': 'Custom period',
  'Bună dimineața': 'Good morning',
  'Bună ziua': 'Good afternoon',
  'Bună seara': 'Good evening',
  'Centru de ajutor': 'Help centre',
  'Caută cereri, furnizori, comenzi…': 'Search requests, suppliers, orders…',
  Ctrl: 'Ctrl',
  Aplică: 'Apply',
  // apps/web/src/components/dashboard/Horizon.tsx
  'Termene de răspuns': 'Quote deadlines',
  'Termen de răspuns': 'Quote deadline',
  'Material necesar': 'Material needed',
  'Probabil urmează': 'Probably coming up',
  'Săptămâna asta': 'This week',
  'Mai încolo': 'Later',
  'Următoarele 30 de zile': 'Next 30 days',
  'Din comenzi, cereri de ofertă și necesarul de pe șantier':
    'From orders, requests for quotes and site requisitions',
  'Nimic programat': 'Nothing scheduled',
  ', {0} întârziate': ', {0} overdue',
  azi: 'today',
  'Livrările, termenele de răspuns, materialul cerut de pe șantier și comenzile care se repetă apar aici singure.':
    'Deliveries, quote deadlines, material requested from the site and repeat orders show up here automatically.',
  '{0} programate': '{0} scheduled',
  // apps/web/src/components/dashboard/Insights.tsx
  Competitiv: 'Competitive',
  'Uneori cel mai bun': 'Sometimes the best',
  'Rar cel mai bun': 'Rarely the best',
  'Fără comparație': 'Not compared',
  zi: 'day',
  zile: 'days',
  'Răspunde cel mai des': 'Replies most often',
  'Cel mai rapid': 'Fastest',
  'Cel mai des cel mai ieftin': 'Most often the cheapest',
  'De urmărit': 'Keep an eye on',
  'răspunde {0}': 'replies {0}',
  'Cum lucrează furnizorii': 'How your suppliers perform',
  'Din cererile trimise: răspunsuri, viteză, cel mai bun preț':
    'From the requests you sent: replies, speed, best price',
  'Analiza furnizorilor →': 'Supplier analysis →',
  '{0} oferte din {1} cereri': '{0} quotes from {1} requests',
  'cel mai ieftin în {0} din {1} comparații': 'cheapest in {0} of {1} comparisons',
  'Nicio cerere trimisă furnizorilor în perioadă.': 'No requests sent to suppliers in this period.',
  'Activitate recentă': 'Recent activity',
  'Ce s-a întâmplat în cereri, comenzi și livrări': 'What happened in requests, orders and deliveries',
  'Toată activitatea →': 'All activity →',
  'Aici apar ofertele primite, comenzile, livrările și cererile noi.':
    'Quotes received, orders, deliveries and new requests show up here.',
  // apps/web/src/components/dashboard/PriceMoves.tsx
  'Prețuri care s-au mișcat': 'Prices that moved',
  'Cel mai mic preț la ultima cerere, față de data trecută':
    'Lowest price on the latest request, compared with last time',
  'Toate prețurile': 'All prices',
  'acum {0} lei/{1}, la {2}': 'now {0} lei/{1}, from {2}',
  ofertă: 'quote',
  oferte: 'quotes',
  materialele: 'Materials',
  'Aici apar materialele al căror preț s-a schimbat față de data trecută când le-ai cerut.':
    'Materials whose price changed since the last time you requested them show up here.',
  // apps/web/src/components/dashboard/ProcurementChart.tsx
  'Oportunitatea de achiziție': 'Purchasing opportunity',
  'Din comparațiile ofertelor, {0}': 'From the quote comparisons, {0}',
  'Vezi economiile →': 'See the savings →',
  'Economii posibile': 'Possible savings',
  '{0}% sub prețul de referință, la {1} {2}': '{0}% below the reference price, on {1} {2}',
  'cerere comparată': 'compared request',
  'cereri comparate': 'compared requests',
  'nicio cerere cu două oferte complete în perioadă': 'no requests with two complete quotes in this period',
  'Economii obținute': 'Savings achieved',
  Captat: 'Captured',
  'Cea mai mare diferență': 'Biggest difference',
  'Cea mai mare oportunitate deschisă': 'Biggest open opportunity',
  'Economia posibilă nu e garantată: devine obținută când comanzi la cel mai bun preț.':
    "Possible savings aren't guaranteed: they become achieved when you order at the best price.",
  'preț de referință': 'reference price',
  'cel mai bun preț': 'best price',
  'economie posibilă': 'possible saving',
  'Graficul se umple din cererile cu cel puțin două oferte complete.':
    'The chart fills up from requests with at least two complete quotes.',
  'Preț de referință și cel mai bun preț, pe luni': 'Reference price and best price, by month',
  Referință: 'Reference',
  'Cel mai bun': 'Best',
  'Economie posibilă <em>{0}</em>': 'Possible saving <em>{0}</em>',
  'nicio cerere comparată': 'no compared requests',
  'la {0} {1}': 'on {0} {1}',
  // apps/web/src/components/dashboard/shared.tsx
  'fără comparație': 'not compared',
  'la fel': 'same',
  '{0} mil.': '{0}m',
  '{0} mii': '{0}k',
  // apps/web/src/components/dashboard/SpendCharts.tsx
  'Valoare comandată': 'Order value',
  'Din comenzile emise, pe ultimele 12 luni': 'From issued orders, over the last 12 months',
  'Comenzile →': 'Orders →',
  'în 12 luni': 'over 12 months',
  'Valoarea comandată pe luni': 'Order value by month',
  'Graficul se umple din comenzile emise.': 'The chart fills up from issued orders.',
  'Din comenzile emise, {0}': 'From issued orders, {0}',
  'Valoarea comandată pe categorii': 'Order value by category',
  'total lei': 'total lei',
  'Nicio comandă emisă în perioadă.': 'No orders issued in this period.',
  // apps/web/src/components/DateInput.tsx
  'Alege data din calendar': 'Pick a date from the calendar',
  Calendar: 'Calendar',
  'Luna trecută': 'Previous month',
  'Luna viitoare': 'Next month',
  Azi: 'Today',
  'zz.ll.aaaa': 'dd.mm.yyyy',
  // apps/web/src/components/Deliveries.tsx
  'Ștergi livrarea?': 'Delete the delivery?',
  '{0} din {1}{2}. Nu se mai poate recupera.': "{0} of {1}{2}. This can't be undone.",
  ', cu {0}': ', with {0}',
  'fișierul ei': 'its file',
  'cele {0} fișiere': 'all {0} files',
  'Șterge livrarea': 'Delete delivery',
  'Trecută de {0} de pe șantier · de confirmat': 'Logged by {0} at the site · to be confirmed',
  'Trecută de {0} · confirmată de {1}': 'Logged by {0} · confirmed by {1}',
  'Livrarea a fost ștearsă': 'Delivery deleted',
  'Livrarea e confirmată': 'Delivery confirmed',
  'Livrări și avize': 'Deliveries and delivery notes',
  '1 de confirmat': '1 to confirm',
  '{0} de confirmat': '{0} to confirm',
  'Adaugă livrarea': 'Add delivery',
  Confirmă: 'Confirm',
  Modifică: 'Edit',
  'La fiecare livrare, trece aici avizul de însoțire: poza sau PDF-ul lui, cu data și numărul. Așa știi mereu ce s-a adus și când. Îl poate trece și șeful de șantier, din contul lui; tu doar îl confirmi.':
    'For each delivery, add the delivery note here: a photo or PDF of it, with its date and number. That way you always know what arrived and when. The site manager can add it from their own account; you just confirm it.',
  ' Când pleacă înapoi la furnizor, trece la fel și returul.':
    ' When it goes back to the supplier, log the return the same way.',
  'Comanda e anulată; nu s-a trecut nicio livrare pe ea.':
    'The order is cancelled; no deliveries were logged on it.',
  'Salvată de tine, livrarea e și confirmată.': 'Saved by you, so the delivery is confirmed too.',
  'fără fișier': 'no file',
  '„{0}” are peste {1} MB.': '"{0}" is over {1} MB.',
  'Ștergi fișierul?': 'Delete the file?',
  '„{0}” se șterge de tot.': '"{0}" will be deleted for good.',
  'Șterge fișierul': 'Delete file',
  'Alege data livrării.': 'Choose the delivery date.',
  'Se urcă {0} din {1}…': 'Uploading {0} of {1}…',
  'Livrarea a fost salvată': 'Delivery saved',
  'Livrarea a fost adăugată': 'Delivery added',
  'Modifică livrarea': 'Edit delivery',
  'Livrare nouă': 'New delivery',
  'Comanda {0}, de la {1}. Datele sunt cele de pe aviz.{2}':
    'Order {0}, from {1}. Use the details on the delivery note.{2}',
  'Ce s-a întâmplat': 'What happened',
  Livrare: 'Delivery',
  Retur: 'Return',
  '· a plecat înapoi la furnizor, la sfârșitul chiriei':
    '· sent back to the supplier at the end of the rental',
  'Data de pe aviz': 'Date on the delivery note',
  'Numărul avizului': 'Delivery note number',
  'lipsesc 2 panouri, livrat parțial': '2 panels missing, partly delivered',
  'Doar ce a fost altfel decât pe comandă.': 'Only what differed from the order.',
  Avizul: 'Delivery note',
  Deschide: 'Open',
  '{0} · se urcă la salvare': '{0} · uploads when you save',
  'Poza avizului făcută cu telefonul sau PDF-ul primit':
    'A phone photo of the delivery note, or the PDF you received',
  'Alege fișiere': 'Choose files',
  '· s-a livrat pe șantier': '· delivered to the site',
  // apps/web/src/components/Dialog.tsx
  'Închizi fără să salvezi?': 'Close without saving?',
  'Ce ai scris în fereastra asta se pierde.': "What you've typed in this window will be lost.",
  'Închide fără salvare': 'Close without saving',
  Continuă: 'Keep editing',
  Închide: 'Close',
  // apps/web/src/components/FirstSteps.tsx
  'Completează datele firmei': 'Fill in your company details',
  '{0}-ul și adresa sediului apar pe comenzile de achiziție.':
    'Your {0} and registered address appear on purchase orders.',
  'Adaugă primul șantier': 'Add your first site',
  'Cererile, comenzile și bugetul se țin pe șantiere.': 'Requests, orders and budgets are tracked by site.',
  'Adaugă cel puțin {0} furnizori': 'Add at least {0} suppliers',
  'Îi lipești dintr-un tabel Excel sau îi adaugi pe rând, cu numele și emailul lor.':
    'Paste them from an Excel sheet or add them one by one, with their name and email.',
  'Fă prima cerere de ofertă': 'Send your first request for quotes',
  'Procumi trimite câte un mail fiecărui furnizor, în numele tău.':
    'Procumi sends each supplier an email on your behalf.',
  'Invită un coleg': 'Invite a colleague',
  'Șeful de șantier sau cine mai cumpără lucrează în același cont.':
    'The site manager, or anyone else who buys, works in the same account.',
  'Bifează că ești de acord cu termenii și politica de confidențialitate.':
    'Please tick the box to agree to the Terms and Conditions and the Privacy Policy.',
  'Sunt de acord cu {0} și cu {1}.': 'I agree to the {0} and the {1}.',
  'Termenii și condițiile': 'Terms and Conditions',
  'Arată': 'Show',
  'Politica de confidențialitate': 'Privacy Policy',
  'Securitate':
    'Security',
  'Parola de acum':
    'Current password',
  'Parola nouă, încă o dată':
    'New password, again',
  'Arată parolele':
    'Show passwords',
  'Cele două parole noi nu sunt la fel.':
    'The two new passwords don\'t match.',
  'Parola e schimbată.':
    'Password changed.',
  'Parola e schimbată. Am scos contul de pe celelalte {0} dispozitive.':
    'Password changed. You\'ve been signed out on {0} other devices.',
  'Am scos contul de pe celelalte {0} dispozitive.':
    'You\'ve been signed out on {0} other devices.',
  'Nu erai intrat de pe alte dispozitive.':
    'You weren\'t signed in on any other devices.',
  'După schimbare, ieși din cont de pe celelalte dispozitive. Aici rămâi intrat.':
    'Changing it signs you out on your other devices. You stay signed in here.',
  'Schimbă parola':
    'Change password',
  'Ieși de pe celelalte dispozitive':
    'Sign out on other devices',
  'Scrie parola de acum':
    'Enter your current password',
  'Parola nouă trebuie să fie alta decât cea de acum':
    'The new password must be different from the current one',
  'Parola de acum nu e bună.':
    'Your current password isn\'t right.',
  'Parola contului tău Procumi a fost schimbată':
    'Your Procumi password was changed',
  'Parola contului tău Procumi tocmai a fost schimbată, din aplicație.':
    'The password for your Procumi account was just changed, from inside the app.',
  'Celelalte dispozitive pe care erai intrat au fost scoase din cont.':
    'You\'ve been signed out on any other devices you were using.',
  'Dacă n-ai fost tu, alege imediat o parolă nouă cu „Am uitat parola” și scrie-ne la sales@procumi.com.':
    'If this wasn\'t you, choose a new password straight away with “Forgot password” and email us at sales@procumi.com.',
  'Parola a fost schimbată':
    'Password changed',
  'Primii pași': 'First steps',
  'Cifrele, termenele și economiile apar aici după prima cerere de ofertă.':
    'Your figures, deadlines and savings show up here after your first request for quotes.',
  '{0} din {1} gata. Se bifează singuri, pe măsură ce lucrezi.':
    '{0} of {1} done. They tick themselves off as you work.',
  'Ascunde lista': 'Hide the list',
  Începe: 'Start',
  '(gata)': '(done)',
  // apps/web/src/components/FollowUpDialog.tsx
  'Follow-up trimis la {0}': 'Follow-up sent to {0}',
  'Re: Cerere de ofertă – {0}': 'Re: Request for quote – {0}',
  'Notat: follow-up către {0}': 'Noted: follow-up to {0}',
  'Follow-up către {0}': 'Follow-up to {0}',
  ' · deja ai trimis {0} follow-up': " · you've already sent {0} follow-up(s)",
  'Procumi îl trimite în numele tău; răspunsul vine la {0}. Dacă preferi, îl copiezi și îl trimiți tu, apoi apeși „Am trimis”.':
    'Procumi sends it on your behalf; the reply comes to {0}. If you\'d rather, copy it and send it yourself, then press "I\'ve sent it".',
  'Îl trimiți tu, din programul tău de mail, ca răspunsul să vină la tine. După ce pleacă, apasă „Am trimis”, ca să știm de când aștepți.':
    "You send it yourself, from your email program, so the reply comes to you. Once it's gone, press \"I've sent it\" so we know how long you've been waiting.",
  'Deschide în programul de mail': 'Open in my email program',
  'Am trimis': "I've sent it",
  'Trimite din Procumi': 'Send from Procumi',
  // apps/web/src/components/ImportSuppliersDialog.tsx
  'Din Excel: selectează tabelul, copiază-l (Ctrl+C) și lipește-l aici. Sau salvează-l ca CSV.':
    'From Excel: select the table, copy it (Ctrl+C) and paste it here. Or save it as CSV.',
  'Un furnizor adăugat': 'One supplier added',
  '{0} furnizori adăugați': '{0} suppliers added',
  '; {0} existau deja': '; {0} were already there',
  '; {0} fără adresă la ANAF, adaugă-i de mână': '; {0} have no address at ANAF, add them by hand',
  'Importă furnizori': 'Import suppliers',
  'Din Excel sau Google Sheets: selectezi tabelul cu tot cu capul lui, îl copiezi (Ctrl+C) și îl lipești mai jos. Sau alegi un fișier CSV.':
    'From Excel or Google Sheets: select the table including its header row, copy it (Ctrl+C) and paste it below. Or choose a CSV file.',
  'Tabelul cu furnizori': 'Supplier table',
  'Firma\tPersoana\tEmail\tTelefon\tCategorie\nArmax Distribuție\tIon Pop\tion@armax.ro\t0722 123 456\tArmătură':
    'Company\tContact\tEmail\tPhone\tCategory\nNorthern Steel Ltd\tJohn Smith\tjohn@northernsteel.co.uk\t07700 900123\tRebar',
  'Recunoaștem coloanele Firma, Email, Persoana, Telefon, Categorie, {0} și Adresa. Obligatorii: firma, emailul, {1}-ul și adresa{2}. Mai multe rânduri cu aceeași firmă devin persoane de contact ale aceluiași furnizor.':
    'We recognise the columns Company, Email, Contact, Phone, Category, {0} and Address. Required: company, email, {1} and address{2}. Several rows for the same company become contacts of the same supplier.',
  ' (dacă lipsește, o luăm de la ANAF după CUI)': " (if it's missing, we get it from ANAF using the CUI)",
  'Alege un fișier CSV': 'Choose a CSV file',
  'Categoria pentru cei fără categorie': 'Category for those without one',
  'ex. Armătură': 'e.g. Rebar',
  'Un furnizor nou': 'One new supplier',
  '{0} furnizori noi': '{0} new suppliers',
  ' · {0} există deja': ' · {0} already exist',
  ' · {0} nu pot intra': " · {0} can't be added",
  ' — alege o categorie pentru cei fără': ' — choose a category for those without one',
  Firma: 'Company',
  'Persoane de contact': 'Contacts',
  Categorii: 'Categories',
  Stare: 'Status',
  'rândul {0}{1}': 'row {0}{1}',
  'intră, {0}': 'will be added, {0}',
  intră: 'will be added',
  Renunță: 'Cancel',
  'Cel mult {0} furnizori dintr-o dată': 'At most {0} suppliers at a time',
  'Se importă…': 'Importing…',
  'Importă {0}': 'Import {0}',
  'un furnizor': 'one supplier',
  '{0} furnizori': '{0} suppliers',
  Importă: 'Import',
  // apps/web/src/components/MailDialog.tsx
  'N-a plecat la {0}': 'Not sent to {0}',
  'Mailul a plecat': 'Email sent',
  'Au plecat {0} mailuri': '{0} emails sent',
  'Marcat ca trimis: {0}': 'Marked as sent: {0}',
  'Mailurile de trimis': 'Emails to send',
  'Fiecare dintre cei {0} furnizori primește un mail separat, cu o cerere de ofertă formală. Procumi îl trimite în numele tău; când furnizorul răspunde, mailul ajunge la {1}. Mailul din Procumi are și un buton prin care furnizorul trece oferta direct în tabel. Poți și să-l copiezi și să-l trimiți tu.':
    'Each of the {0} suppliers gets a separate email with a formal request for quotes. Procumi sends it on your behalf; when the supplier replies, the email comes to {1}. The Procumi email also has a button that lets the supplier enter their quote straight into the table. You can also copy it and send it yourself.',
  'Fiecare dintre cei {0} furnizori primește un mail separat, cu același text. Alege furnizorul, deschide un mail nou în programul tău de mail și copiază pe rând adresa, subiectul și textul. După ce l-ai trimis, apasă „Am trimis”.':
    'Each of the {0} suppliers gets a separate email with the same text. Pick the supplier, open a new email in your email program and copy the address, subject and text in turn. Once you\'ve sent it, press "I\'ve sent it".',
  'Către:': 'To:',
  'Copiază adresa': 'Copy address',
  'Planuri și documente ({0}).': 'Drawings and documents ({0}).',
  'Pleacă atașate la mailul din Procumi. Dacă îl trimiți tu, atașează-le:':
    'They go as attachments in the Procumi email. If you send it yourself, attach them:',
  'Pleacă în mailul din Procumi ca linkuri de descărcare, fiindcă sunt mari. Dacă îl trimiți tu, atașează-le sau trimite-le separat:':
    "They go in the Procumi email as download links, because they're large. If you send it yourself, attach them or send them separately:",
  'Atașează-le în mailul tău:': 'Attach them to your email:',
  'Ultimul mail din Procumi n-a plecat: {0}': "The last email from Procumi didn't go out: {0}",
  'Trimis din Procumi': 'Sent from Procumi',
  Trimis: 'Sent',
  'Trimite din nou': 'Send again',
  '{0}: marcat din nou ca netrimis': '{0}: marked as not sent again',
  'Nu l-am trimis': "I didn't send it",
  'Trimite din Procumi la toți ({0})': 'Send from Procumi to all ({0})',
  'Marcate ca trimise: {0} mailuri': 'Marked as sent: {0} emails',
  'Le-am trimis pe toate': "I've sent them all",
  // apps/web/src/components/MoreMenu.tsx
  'Mai multe acțiuni': 'More actions',
  // apps/web/src/components/NewRequisitions.tsx
  '{0} să fie preluat': '{0} to be picked up',
  'unul așteaptă': 'one waiting',
  '{0} așteaptă': '{0} waiting',
  'Vezi tot': 'See all',
  '1 material': '1 material',
  '{0} materiale': '{0} materials',
  'pe șantier la {0}': 'at the site by {0}',
  'fără dată': 'no date',
  // apps/web/src/components/OfferDialog.tsx
  Accesoriu: 'Accessory',
  Consumabil: 'Consumable',
  Serviciu: 'Service',
  Altele: 'Other',
  poză: 'photo',
  '„{0}” a fost urcat': '"{0}" uploaded',
  'Ștergi documentul?': 'Delete the document?',
  '„{0}” se șterge definitiv și nu se mai poate recupera.':
    '"{0}" will be deleted permanently and can\'t be recovered.',
  'Șterge documentul': 'Delete document',
  'Document șters': 'Document deleted',
  'Citit: {0} din {1} poziții. Verifică-le.': 'Read: {0} of {1} items. Please check them.',
  'Lipește întâi textul ofertei': 'Paste the quote text first',
  'Spune întâi dacă prețurile din ofertă sunt cu sau fără TVA':
    'First say whether the prices in the quote include VAT or not',
  '{0}: comanda minimă și ambalajul trebuie să fie numere pozitive':
    '{0}: minimum order and pack size must be positive numbers',
  '{0}: cantitatea ofertată trebuie să fie un număr pozitiv':
    '{0}: the quoted quantity must be a positive number',
  'Introdu cel puțin un preț': 'Enter at least one price',
  'Scrie cursul: câți lei face un euro': 'Enter the exchange rate: how many lei to one euro',
  'Costul transportului nu e un număr': "The delivery cost isn't a number",
  'Fiecare cost are nevoie de ce e și de o sumă': 'Each cost needs a description and an amount',
  'Fiecare poziție suplimentară are nevoie de denumire și de numere pozitive':
    'Each extra item needs a name and positive numbers',
  'Scrie procentul avansului': 'Enter the deposit percentage',
  'Scrie suma avansului': 'Enter the deposit amount',
  'Avansul nu poate trece de 100%': "The deposit can't be more than 100%",
  'Termenele de plată și de livrare se scriu în zile întregi': 'Payment and delivery terms are in whole days',
  'Oferta de la {0} a fost salvată': 'Quote from {0} saved',
  'Oferta de la {0}': 'Quote from {0}',
  'Prețuri fără TVA, în moneda ofertei. În tabel se compară în lei.':
    "Prices excl. VAT, in the quote's currency. The table compares them in lei.",
  'Documente primite': 'Documents received',
  'se păstrează imediat, chiar dacă nu salvezi prețurile':
    "kept straight away, even if you don't save the prices",
  '{0} · urcat {1}': '{0} · uploaded {1}',
  Descarcă: 'Download',
  'Citesc…': 'Reading…',
  'Citește oferta': 'Read the quote',
  'Trage aici PDF-ul, Excel-ul sau poza primită de la furnizor': 'Drop the PDF, Excel file or photo from the supplier here',
  'Se urcă…': 'Uploading…',
  'Alege fișier': 'Choose file',
  'Textul ofertei': 'Quote text',
  'Lipește aici mailul sau mesajul de pe WhatsApp…': 'Paste the email or WhatsApp message here…',
  'Se salvează lângă prețuri, ca sursă a lor.': "It's saved next to the prices, as their source.",
  'Citește textul': 'Read the text',
  'Citirea automată nu e pornită pe acest server — prețurile se completează de mână.':
    "Automatic reading isn't switched on on this server — fill in the prices by hand.",
  'Citire automată: <b>{0}</b> din {1} poziții completate{2}. Verifică-le și salvează — până atunci nimic nu e în bază.':
    'Automatic reading: <b>{0}</b> of {1} items filled in{2}. Check them and save — nothing is stored until you do.',
  ', {0} fără preț': ', {0} without a price',
  'Verifică în ofertă:': 'Check in the quote:',
  'Oferta nu spune clar dacă prețurile includ TVA. În tabel se compară prețuri fără TVA, deci spune cum sunt înainte de a salva.':
    "The quote doesn't make it clear whether prices include VAT. The table compares prices excl. VAT, so say which they are before saving.",
  'Sunt fără TVA': 'They exclude VAT',
  'Oferta mai are <b>{0}</b> {1} în plus față de cerere. Le găsești mai jos, la „Poziții suplimentare”: se văd în tabel, dar nu intră în costul total.':
    'The quote also has <b>{0}</b> {1} on top of the request. You\'ll find them below under "Extra items": they show in the table but aren\'t included in the total cost.',
  poziție: 'item',
  poziții: 'items',
  'Moneda ofertei': 'Quote currency',
  Lei: 'Lei',
  Euro: 'Euro',
  'Curs (lei pentru 1 €)': 'Rate (lei per €1)',
  'Iau cursul BNR…': 'Getting the BNR rate…',
  'Cursul BNR din {0}': 'BNR rate for {0}',
  'Curs scris de mână': 'Rate entered by hand',
  'Ia cursul BNR': 'Get the BNR rate',
  'ofertă pe set': 'quote for a set',
  'Preț unitar': 'Unit price',
  'Preț unitar {0}': 'Unit price {0}',
  'minim / ambalaj': 'minimum / pack',
  'e pe set': 'priced as a set',
  'altă cantitate': 'different quantity',
  'alt produs': 'different product',
  'Nu apare în ofertă. ': 'Not in the quote. ',
  'Oferta nu spune': 'Not stated in the quote',
  'Inclus în prețuri': 'Included in prices',
  'Se plătește separat': 'Charged separately',
  'Cost transport ({0}, toată comanda)': 'Delivery cost ({0}, whole order)',
  'nu se știe': 'unknown',
  'Dacă e pe unitate, scrie suma pentru toată cantitatea.':
    "If it's per unit, enter the amount for the whole quantity.",
  'Gol = suma nu e în ofertă. Tabelul te avertizează.':
    "Empty = the amount isn't in the quote. The table will flag it.",
  'Alt cost': 'Other cost',
  'descărcare cu macara': 'crane unloading',
  'livrare la rampă': 'delivery to the ramp',
  'Sumă ({0})': 'Amount ({0})',
  '+ Alt cost pe comandă (descărcare, paleți, taxă de comandă mică)':
    '+ Other per-order cost (unloading, pallets, small-order fee)',
  'Ce a pus furnizorul în plus față de cerere: console, popi, decofrol, montaj. Se văd în tabel, separat; nu intră în costul total.':
    'What the supplier added on top of the request: brackets, props, release agent, installation. Shown separately in the table; not included in the total cost.',
  Denumire: 'Description',
  Cantitate: 'Quantity',
  'Preț ({0})': 'Price ({0})',
  'Valoare ({0})': 'Value ({0})',
  'cant. × preț': 'qty × price',
  Fel: 'Type',
  '+ Poziție suplimentară': '+ Extra item',
  'Fără avans': 'No deposit',
  Procent: 'Percentage',
  'Sumă fixă': 'Fixed amount',
  'Altă condiție': 'Other terms',
  'Avans (%)': 'Deposit (%)',
  'Avans ({0})': 'Deposit ({0})',
  'Avans, cu cuvintele ofertei': 'Deposit, as worded in the quote',
  '30% la semnarea contractului': '30% on signing the contract',
  'Termen plată (zile)': 'Payment terms (days)',
  '0 = la livrare': '0 = on delivery',
  'Condiții plată': 'Payment terms',
  'Termen livrare (zile)': 'Delivery time (days)',
  'Termen livrare, cu cuvintele ofertei': 'Delivery time, as worded in the quote',
  'Data ofertei': 'Quote date',
  'Valabilă până pe': 'Valid until',
  'Valabilitate, cu cuvintele ofertei': 'Validity, as worded in the quote',
  'Sursa prețurilor: {0}': 'Source of the prices: {0}',
  'Salvează oferta': 'Save quote',
  'Cantitate ofertată ({0})': 'Quoted quantity ({0})',
  'Produs propus în loc': 'Product offered instead',
  'echivalent Baumit MPI 25': 'equivalent to Baumit MPI 25',
  'Ofertă parțială: {0}. Se vede în tabel, dar nu câștigă comparația.':
    "Partial quote: {0}. It shows in the table but can't win the comparison.",
  'Comandă minimă ({0})': 'Minimum order ({0})',
  'Se vinde doar câte ({0})': 'Only sold in multiples of ({0})',
  'palet, rolă': 'pallet, roll',
  'Scrie numere mai mari decât zero.': 'Enter numbers greater than zero.',
  UM: 'Unit',
  'TVA-ul de {0}% a fost scăzut din toate sumele': '{0}% VAT has been taken off all amounts',
  'Sunt cu TVA: scade {0}%': 'They include VAT: take off {0}%',
  buc: 'pcs',
  // apps/web/src/components/OrderDialog.tsx
  'Poziția {0} nu are denumire.': 'Item {0} has no description.',
  'Poziția {0}: cantitatea trebuie să fie mai mare decât zero.':
    'Item {0}: the quantity must be greater than zero.',
  'Poziția {0} nu are preț: scrie prețul negociat sau șterge poziția.':
    'Item {0} has no price: enter the negotiated price or remove the item.',
  'Poziția {0}: prețul trebuie să fie un număr mai mare decât zero.':
    'Item {0}: the price must be a number greater than zero.',
  'Comanda are nevoie de cel puțin o poziție.': 'The order needs at least one item.',
  'Fiecare cost are nevoie de ce e și de o sumă.': 'Each cost needs a description and an amount.',
  'Costul transportului nu e un număr.': "The delivery cost isn't a number.",
  'Cota de TVA nu e un procent.': "The VAT rate isn't a percentage.",
  'Scrie cursul: câți lei face un euro.': 'Enter the exchange rate: how many lei to one euro.',
  'Scrie adresa de livrare.': 'Enter the delivery address.',
  'Datele firmei le completează un administrator, în „Contul firmei”.':
    'Company details are filled in by an administrator, in "Company account".',
  'Comanda a plecat la aprobare. Primești un email când e aprobată.':
    "The order has gone for approval. You'll get an email when it's approved.",
  'Suplimentarea a fost emisă': 'Top-up order issued',
  'Comanda a fost emisă': 'Order issued',
  'Suplimentare către {0}': 'Top-up order to {0}',
  'Comandă către {0}': 'Order to {0}',
  'Mai comanzi de la același furnizor, pe același proiect. Pozițiile din ofertă au prețul ei; scrie cantitățile, scoate ce nu-ți trebuie, adaugă poziții noi cu prețul negociat. Fără concurență: nu intră la diferența obținută.':
    "You're ordering more from the same supplier, for the same job. Items from the quote keep its price; enter the quantities, remove what you don't need, and add new items at the negotiated price. No competition, so it doesn't count towards savings achieved.",
  'Completată din oferta aleasă. Corectează ce s-a negociat, apoi emite: comanda primește număr și nu se mai schimbă.':
    "Filled in from the chosen quote. Correct anything that was negotiated, then issue it: the order gets a number and can't be changed after that.",
  Furnizor: 'Supplier',
  Adresă: 'Address',
  'Persoană de contact': 'Contact person',
  Email: 'Email',
  'Adresa de livrare': 'Delivery address',
  'Data dorită': 'Requested date',
  'Termen din ofertă': 'Lead time from the quote',
  Poziții: 'Items',
  '· prețuri în {0}, fără TVA': '· prices in {0}, excl. VAT',
  'Pozițiile comenzii': 'Order items',
  Valoare: 'Value',
  'Denumire, poziția {0}': 'Description, item {0}',
  'Cantitate, poziția {0}': 'Quantity, item {0}',
  'Unitate, poziția {0}': 'Unit, item {0}',
  'Preț unitar, poziția {0}': 'Unit price, item {0}',
  'Scoate poziția {0}': 'Remove item {0}',
  'Scoate poziția': 'Remove item',
  'În ofertă: {0} {1}. Comanzi cu {2}% {3}.': "In the quote: {0} {1}. You're ordering {2}% {3}.",
  'mai scump': 'higher',
  'mai ieftin': 'lower',
  ', minim {0} de zile': ', minimum {0} days',
  '+ Adaugă poziție': '+ Add item',
  'Transport și alte costuri': 'Delivery and other costs',
  'Nu e trecut pe comandă': 'Not on the order',
  'Cost transport ({0})': 'Delivery cost ({0})',
  '+ Alt cost pe comandă': '+ Other per-order cost',
  Condiții: 'Terms',
  Plată: 'Payment',
  '30 de zile de la livrare': '30 days from delivery',
  'TVA (%)': 'VAT (%)',
  Mențiuni: 'Notes',
  'descărcare cu macaraua furnizorului, livrare între 8 și 16':
    "unloading with the supplier's crane, delivery between 8am and 4pm",
  'Firma ta, pe comandă': 'Your company, on the order',
  'Completează {0}-ul și adresa sediului: apar pe comandă și rămân pentru următoarele.':
    'Fill in your {0} and registered address: they appear on the order and are kept for next time.',
  'Adresa sediului': 'Registered address',
  'Total cu TVA': 'Total incl. VAT',
  'Peste {0}: merge întâi la aprobare{1}.': 'Over {0}: goes for approval first{1}.',
  'Trimite la aprobare': 'Send for approval',
  'Emite suplimentarea': 'Issue top-up order',
  'Emite comanda': 'Issue order',
  'Chirie: se plătește pe zilele reale de pe șantier, din avize{0}. Cantitatea de aici e estimarea.':
    'Rental: paid on the actual days at the site, from the delivery notes{0}. The quantity here is the estimate.',
  aprobator: 'approver',
  // apps/web/src/components/PackageEditor.tsx
  'Scrie totalul pachetului.': 'Enter the total for the set.',
  'Scrie câte zile acoperă totalul (30 pentru o lună).':
    'Enter how many days the total covers (30 for a month).',
  'Chiria minimă e în zile întregi.': 'The minimum rental is in whole days.',
  'Costurile o singură dată nu pot fi negative.': "One-off costs can't be negative.",
  Chirie: 'Rental',
  Vânzare: 'Sale',
  'Chirie pe perioadă ({0})': 'Rental for the period ({0})',
  'Total set ({0})': 'Set total ({0})',
  'Pentru câte zile': 'For how many days',
  'Chirie minimă (zile)': 'Minimum rental (days)',
  'Acoperă ({0})': 'Covers ({0})',
  'O singură dată ({0})': 'One-off ({0})',
  'transport, montaj': 'delivery, installation',
  'Valoare de înlocuire ({0})': 'Replacement value ({0})',
  'Nu include': 'Excludes',
  'ex. transport': 'e.g. delivery',
  'Pentru {0} cerute: ': 'For the {0} requested: ',
  'Cost: ': 'Cost: ',
  'S-a cerut chirie, iar oferta e de vânzare: rămâne la ofertă, dar nu intră în comparație.':
    "Rental was requested but the quote is for sale: it stays on the quote but isn't compared.",
  'S-a cerut cumpărare, iar oferta e de chirie: rămâne la ofertă, dar nu intră în comparație.':
    "Purchase was requested but the quote is for rental: it stays on the quote but isn't compared.",
  '{0} {1} din ofertă · suma {2}': '{0} {1} from the quote · total {2}',
  'Scoate liniile': 'Remove the lines',
  '· {0}/{1}/lună': '· {0}/{1}/month',
  // apps/web/src/components/PlanBanner.tsx
  '<b>Plata cu cardul n-a trecut.</b> Stripe mai încearcă câteva zile; schimbă cardul din „Contul firmei → Pachet”, ca pachetul să nu se oprească.':
    '<b>The card payment didn\'t go through.</b> Stripe will keep trying for a few days; change the card in "Company account → Plan" so your plan doesn\'t stop.',
  'Ai cerut pachetul': "You've requested the plan",
  ', {0}, pe {1}. {2}': ', {0}, on {1}. {2}',
  'Îți trimitem factura pe email{0}': "We'll email you the invoice{0}",
  '; contul se deschide când primim plata.': '; the account opens once we receive payment.',
  'Te contactăm în curând.': "We'll be in touch soon.",
  'o zi': 'one day',
  '{0} zile': '{0} days',
  'Schimbă cererea': 'Change the request',
  'Contul nu are încă un pachet.': "The account doesn't have a plan yet.",
  'Vezi tot, dar ca să creezi sau să schimbi ceva {0}':
    'You can see everything, but to create or change anything {0}',
  'alege un pachet.': 'choose a plan.',
  'un administrator al contului trebuie să aleagă un pachet.':
    'an account administrator needs to choose a plan.',
  'Ai cerut pachetul <b>{0}</b>, {1}, pe {2}. {3}': "You've requested the <b>{0}</b> plan, {1}, on {2}. {3}",
  'Probă gratuită: mai ai <b>{0}</b>.': 'Free trial: <b>{0}</b> left.',
  // apps/web/src/components/PlanDialog.tsx
  'fără aprobări': 'no approvals',
  'aprobare peste un prag': 'approval above a threshold',
  'aprobări pe pași și pentru fiecare șantier': 'multi-step approvals, and per site',
  'Ai acum pachetul {0}. Diferența se socotește la următoarea factură.':
    "You're now on the {0} plan. The difference is settled on the next invoice.",
  'Am primit cererea. Te contactăm în curând.': "We've received your request. We'll be in touch soon.",
  'Am primit cererea. Te sunăm să stabilim prețul.':
    "We've received your request. We'll call you to agree the price.",
  'Am primit cererea. Îți trimitem factura pe email.':
    "We've received your request. We'll email you the invoice.",
  șantiere: 'sites',
  'Cum plătești': 'How you pay',
  Lunar: 'Monthly',
  Anual: 'Yearly',
  '2 luni gratuite': '2 months free',
  Pachetul: 'Plan',
  'pachetul tău': 'your plan',
  'șantier activ': 'active site',
  'șantiere active': 'active sites',
  ' · suport prioritar': ' · priority support',
  'de la ': 'from ',
  '/ an': '/ year',
  'economisești {0}': 'you save {0}',
  '/ lună': '/ month',
  'Schimbarea se face pe loc, pe cardul de acum. Diferența de preț se socotește la următoarea factură.':
    'The change happens straight away, on your current card. The price difference is settled on the next invoice.',
  'Plătești cu cardul pe pagina securizată Stripe; pachetul se pune imediat, iar factura vine pe email.{0} Anulezi oricând.':
    "You pay by card on Stripe's secure page; the plan starts straight away and the invoice comes by email.{0} Cancel any time.",
  ' Prima plată se ia abia când se termină proba gratuită.':
    ' The first payment is only taken when the free trial ends.',
  'Procumi e în acces timpuriu și încă nu ia plăți online. Trimite cererea și te contactăm pentru pasul următor.':
    "Procumi is in early access and doesn't take online payments yet. Send your request and we'll be in touch about the next step.",
  'Prețul pentru Companie îl stabilim după un demo, după mărimea firmei. Trimite cererea și te sunăm.':
    "We set the Company price after a demo, based on the size of your business. Send your request and we'll call you.",
  'Îți trimitem factura pe email, cu datele din „Contul firmei”. Pachetul se activează când primim plata.':
    'We\'ll email you the invoice, using the details in "Company account". The plan starts once we receive payment.',
  'Se deschide plata…': 'Opening payment…',
  'Trec la {0}': 'Switch to {0}',
  'Plătesc {0} cu cardul': 'Pay {0} by card',
  'Cer pachetul {0}': 'Request the {0} plan',
  'Comparația, comenzile și istoricul de prețuri sunt în fiecare pachet. Diferă câți colegi lucrează în Procumi, câte șantiere ai deschise deodată și aprobarea comenzilor. Prețuri fără TVA.':
    'Comparison, orders and price history come with every plan. What differs is how many colleagues work in Procumi, how many sites you have open at once, and order approvals. Prices excl. VAT.',
  utilizator: 'user',
  utilizatori: 'users',
  '{0} nelimitat': '{0} unlimited',
  // apps/web/src/components/PlanFit.tsx
  '<b>Pachetul firmei s-a schimbat în {0}.</b> Până alege administratorul cine rămâne activ, poți doar să vezi.':
    "<b>Your company's plan has changed to {0}.</b> Until an administrator chooses who stays active, you can only view.",
  'Gata, firma încape în pachetul nou': 'Done, the company now fits the new plan',
  'Firma tot nu încape în pachet. Reîncarcă pagina și încearcă din nou.':
    "The company still doesn't fit the plan. Reload the page and try again.",
  'Pachetul firmei s-a schimbat în {0}': "Your company's plan has changed to {0}",
  'Firma folosește acum mai mult decât are pachetul. Alege ce rămâne activ; până atunci nimeni din firmă nu poate schimba nimic.':
    'The company is now using more than its plan allows. Choose what stays active; until then nobody in the company can change anything.',
  'Vreau un pachet mai mare': 'I want a bigger plan',
  'Cine rămâne activ': 'Who stays active',
  ' · administrator': ' · administrator',
  'Celelalte se închid: rămân în istoric, cu cererile și comenzile lor, dar nu mai primesc cereri noi. Le poți redeschide când termini unul dintre cele active.':
    'The others are closed: they stay in the history, with their requests and orders, but no longer get new requests. You can reopen them when you finish one of the active ones.',
  'Confirmă alegerea': 'Confirm choice',
  'Debifează {0} {1}. ': 'Untick {0} {1}. ',
  'Debifează {0} {1}.': 'Untick {0} {1}.',
  'Ceilalți ies din cont pe loc. Îi poți readuce oricând din „Contul firmei → Echipa”, dacă treci la un pachet mai mare. Ce au lucrat rămâne, cu numele lor. Invitațiile încă neacceptate se retrag. Oamenii de pe șantier nu ocupă loc și rămân toți.':
    'The others are signed out straight away. You can bring them back any time from "Company account → Team" if you move to a bigger plan. Their work stays, with their names. Invitations not yet accepted are withdrawn. Site staff don\'t take up a seat and all stay.',
  'Ce șantiere rămân deschise': 'Which sites stay open',
  coleg: 'colleague',
  colegi: 'colleagues',
  // apps/web/src/components/Plans.tsx
  '„{0}” nu e un tip acceptat. Merg PDF, ZIP, RAR, 7Z, DWG, DXF, imagini, Excel și Word.':
    '"{0}" isn\'t an accepted type. PDF, ZIP, RAR, 7Z, DWG, DXF, images, Excel and Word work.',
  '„{0}” are {1}. Maximul e {2} MB pe fișier.': '"{0}" is {1}. The maximum is {2} MB per file.',
  'Atașează-le în mailul pe care îl trimiți furnizorilor; le descarci de aici.':
    'Attach them to the email you send to suppliers; download them from here.',
  'Pleacă atașate la mailul din Procumi, la toți furnizorii.':
    'They go as attachments in the Procumi email, to every supplier.',
  'Au împreună peste {0} MB, deci pleacă în mail ca linkuri de descărcare, nu atașate: așa trec de limitele serverelor de mail.':
    "Together they're over {0} MB, so they go in the email as download links rather than attachments: that way they get past mail server limits.",
  'Trage aici planurile: PDF, ZIP, DWG, imagini, Excel': 'Drop drawings here: PDF, ZIP, DWG, images, Excel',
  'Trage aici documentele: PDF, ZIP, imagini, Excel': 'Drop documents here: PDF, ZIP, images, Excel',
  'O cerere poate avea cel mult {0} planuri.': 'A request can have at most {0} drawings.',
  'Opțional. Furnizorii le primesc odată cu cererea.': 'Optional. Suppliers get them along with the request.',
  'Nu s-au pus: {0}': 'Not added: {0}',
  'Planul a fost pus la cerere': 'Drawing added to the request',
  'Au fost puse {0} planuri': '{0} drawings added',
  'Ștergi planul?': 'Delete the drawing?',
  '„{0}” dispare de pe cerere și de pe pagina furnizorilor. Cei care l-au primit deja în mail îl păstrează.':
    '"{0}" will disappear from the request and from the suppliers\' page. Anyone who already got it by email keeps it.',
  'Șterge planul': 'Delete drawing',
  'Planul a fost șters': 'Drawing deleted',
  'Planuri și documente': 'Drawings and documents',
  '{0} · pus {1}': '{0} · added {1}',
  'Pus după ce cererea a plecat la {0}: ei nu l-au primit.{1}':
    "Added after the request went to {0}: they didn't get it.{1}",
  ' Retrimite-le cererea din „Mailurile de trimis”.': ' Resend them the request from "Emails to send".',
  ' Trimite-l separat.': ' Send it separately.',
  'Planurile de arhitectură sau de cofraj, listele de cantități: furnizorii le primesc odată cu cererea.':
    'Architectural or formwork drawings, quantity lists: suppliers get them along with the request.',
  'Specificațiile, fișele tehnice, listele de cantități: furnizorii le primesc odată cu cererea.':
    'Specifications, data sheets, quantity lists: suppliers get them along with the request.',
  // apps/web/src/components/PlanSection.tsx
  '{0}, fără limită': '{0}, unlimited',
  'Pachetul {0}, {1}': '{0} plan, {1}',
  'Probă gratuită, încă {0}': 'Free trial, {0} left',
  'Fără pachet': 'No plan',
  'Cont fără limite': 'Unlimited account',
  'În probă ai limitele pachetului {0}. Proba se termină pe {1}.':
    'During the trial you have the limits of the {0} plan. The trial ends on {1}.',
  'Vezi tot, dar nu poți crea sau schimba nimic până alegi un pachet.':
    "You can see everything but can't create or change anything until you choose a plan.",
  'Firma ta e de dinainte de pachete și nu are limite.': 'Your company predates our plans and has no limits.',
  'Comparația, comenzile și istoricul sunt incluse în orice pachet. Diferă colegii, șantierele deschise și aprobarea comenzilor.':
    'Comparison, orders and history come with every plan. What differs is the number of colleagues, open sites and order approvals.',
  Utilizatori: 'Users',
  'Documente citite automat': 'Documents read automatically',
  'Documente citite automat luna asta': 'Documents read automatically this month',
  Șantier: 'Site',
  'Ultima plată cu cardul n-a trecut. Stripe mai încearcă; schimbă cardul ca pachetul să nu se oprească.':
    "The last card payment didn't go through. Stripe will try again; change the card so your plan doesn't stop.",
  'Abonamentul e anulat: pachetul merge până pe {0}, apoi contul rămâne doar pentru citire.':
    'The subscription is cancelled: your plan runs until {0}, then the account becomes read-only.',
  'sfârșitul perioadei': 'the end of the period',
  'Plătești cu cardul. {0}: {1}.': 'You pay by card. {0}: {1}.',
  'Prima plată': 'First payment',
  'Următoarea plată': 'Next payment',
  'Îți trimitem factura pe email; pachetul se activează când primim plata.':
    "We'll email you the invoice; the plan starts once we receive payment.",
  'Te contactăm în curând pentru pasul următor.': "We'll be in touch soon about the next step.",
  'Schimbă pachetul': 'Change plan',
  'Se deschide…': 'Opening…',
  'Facturi, card, anulare': 'Invoices, card, cancellation',
  'Pachetul îl alege un administrator al contului.': 'The plan is chosen by an account administrator.',
  'Șantiere active': 'Active sites',
  'La utilizatori se numără și invitațiile încă nefolosite. Oamenii de pe șantier (rolul „Șantier”) nu se numără.':
    'Users include invitations not yet used. Site staff (the "Site" role) aren\'t counted.',
  // apps/web/src/components/PriceChart.tsx
  'Evoluția prețului: {0} oferte, între {1} și {2} lei pe {3}. Valorile exacte sunt în tabelul de mai jos.':
    'Price trend: {0} quotes, between {1} and {2} lei per {3}. Exact values are in the table below.',
  'cel mai bun {0}': 'best {0}',
  '{0} lei/{1}': '{0} lei/{1}',
  // apps/web/src/components/prices/PriceBand.tsx
  'Mișcările de preț de la ultimele cereri': 'Price movements on the latest requests',
  'Mișcări de preț': 'Price movements',
  'la ultimele cereri': 'on the latest requests',
  'lei/{0}': 'lei/{0}',
  // apps/web/src/components/prices/PriceMarks.tsx
  'prima cerere': 'first request',
  'Același preț ca la cererea trecută': 'Same price as the previous request',
  '{0} decât la cererea trecută': '{0} than on the previous request',
  '{0} {1}, între {2} și {3} lei pe {4}': '{0} {1}, between {2} and {3} lei per {4}',
  'Prețul de acum, între cel mai mic și cel mai mare primit în perioadă':
    'Current price, between the lowest and highest received in the period',
  '{0}: {1} lei/{2}, {3}': '{0}: {1} lei/{2}, {3}',
  // apps/web/src/components/prices/PriceVerdict.tsx
  'Clasamentul la cererea din {0}': 'Ranking on the request from {0}',
  '{0} din {1} oferte primite, se mai așteaptă': '{0} of {1} quotes received, still waiting',
  'De la cine să comanzi': 'Who to order from',
  'Cel mai mic preț la ultima cerere': 'Lowest price on the latest request',
  'Până acum, cel mai mic preț e la el': 'So far, they have the lowest price',
  'Același preț ca {0}': 'Same price as {0}',
  'Nicio cerere {0}; ultima e din {1}': 'No requests {0}; the latest is from {1}',
  'Deschide cererea din {0}': 'Open the request from {0}',
  'Ascunde istoricul': 'Hide history',
  'Tot istoricul': 'Full history',
  'Se încarcă istoricul…': 'Loading history…',
  'Nu am putut încărca.': "Couldn't load.",
  Data: 'Date',
  'Cu {0} {1} sub {2}': '{0} {1} cheaper than {2}',
  'Cel mai ieftin la {0} din {1} cerere {2}': 'Cheapest on {0} of {1} request {2}',
  'Cel mai ieftin la {0} din {1} cereri {2}': 'Cheapest on {0} of {1} requests {2}',
  // apps/web/src/components/ProfileDialog.tsx
  'Poza nu s-a putut citi.': "The photo couldn't be read.",
  'Raportul lunar e pornit': 'Monthly report turned on',
  'Raportul lunar e oprit': 'Monthly report turned off',
  'Mailul de dimineață e pornit': 'Morning email turned on',
  'Mailul de dimineață e oprit': 'Morning email turned off',
  'Alege o poză (JPG, PNG sau WebP).': 'Choose a photo (JPG, PNG or WebP).',
  'Poza a fost salvată': 'Photo saved',
  'Poza a fost ștearsă': 'Photo deleted',
  'Profilul meu': 'My profile',
  'Poza ta apare colegilor în echipă, la comentarii și în notificări.':
    'Your colleagues see your photo in the team list, on comments and in notifications.',
  'Schimbă poza': 'Change photo',
  'Pune o poză': 'Add a photo',
  'Șterge poza': 'Delete photo',
  Limba: 'Language',
  'Aplicația și mailurile primite de tine. Furnizorii primesc mailurile în limba lor.':
    'For the app and the emails you receive. Suppliers get their emails in their own language.',
  'Mailul de dimineață': 'Morning email',
  'Ce ai de rezolvat azi, de luni până vineri la 7:50.':
    'What you need to sort out today, Monday to Friday at 7:50.',
  'Raportul lunar pentru conducere': 'Monthly management report',
  'Pe 1 ale lunii: cât s-a comandat, cât s-a economisit și ce merită întrebat.':
    "On the 1st of each month: how much was ordered, how much was saved and what's worth asking about.",
  // apps/web/src/components/Rail.tsx
  'perioadă de probă': 'trial period',
  'fără pachet': 'no plan',
  'fără limite': 'unlimited',
  'Necesar nou': 'New requisition',
  'Cerere nouă': 'New request',
  'Ctrl K': 'Ctrl K',
  Meniu: 'Menu',
  Secțiuni: 'Sections',
  'Necesarul meu': 'My requisitions',
  Livrări: 'Deliveries',
  'Panou de control': 'Dashboard',
  Necesar: 'Requisitions',
  'Comandă rapidă': 'Quick order',
  Date: 'Data',
  Prețuri: 'Prices',
  Analiză: 'Analysis',
  'Raport conducere': 'Management report',
  Cont: 'Account',
  'Contul firmei': 'Company account',
  Administrare: 'Administration',
  'Ieși din cont': 'Sign out',
  'pachet {0}': '{0} plan',
  // apps/web/src/components/SignatureEditor.tsx
  'Semnătura e salvată. Am scos {0} doar pe calculatorul tău: furnizorul n-ar fi văzut-o.':
    "Signature saved. We removed {0} only on your computer: the supplier wouldn't have seen it.",
  'o imagine care era': 'an image that was',
  '{0} imagini care erau': '{0} images that were',
  'Semnătura e salvată': 'Signature saved',
  'Semnătura din mailuri': 'Email signature',
  'La finalul cererilor, follow-up-urilor și comenzilor trimise în numele tău.':
    'At the end of requests, follow-ups and orders sent on your behalf.',
  'Felul semnăturii': 'Signature type',
  'Făcută de Procumi': 'Made by Procumi',
  'Carte de vizită, cu logo-ul firmei': 'Business card, with your company logo',
  'Din Outlook': 'From Outlook',
  'Cea pe care o folosești deja': 'The one you already use',
  Funcția: 'Job title',
  'ex. Achiziții': 'e.g. Purchasing',
  Telefon: 'Phone',
  'ex. 0722 000 000': 'e.g. 07700 900000',
  'Cu logo-ul firmei': 'With the company logo',
  '· firma n-are încă logo; îl pune administratorul în Contul firmei':
    '· the company has no logo yet; an administrator adds it in Company account',
  'În Outlook: <b>Fișier → Opțiuni → Mail → Semnături</b> (pe web: Setări → Conturi → Semnături).':
    'In Outlook: <b>File → Options → Mail → Signatures</b> (on the web: Settings → Accounts → Signatures).',
  'Selectezi semnătura și o copiezi: Ctrl+A, apoi Ctrl+C.':
    'Select the signature and copy it: Ctrl+A, then Ctrl+C.',
  'O lipești în chenarul de mai jos: Ctrl+V.': 'Paste it into the box below: Ctrl+V.',
  'Lipește aici semnătura din Outlook': 'Paste your Outlook signature here',
  'Lipită. Vezi mai jos cum arată.': 'Pasted. See below how it looks.',
  'Lipește aici (Ctrl+V)': 'Paste here (Ctrl+V)',
  '{0} doar pe calculatorul tău, deci furnizorul n-ar vedea-o. Pentru logo, folosește varianta „Făcută de Procumi”.':
    '{0} only on your computer, so the supplier wouldn\'t see it. For a logo, use the "Made by Procumi" option.',
  'O imagine e': 'One image is',
  '{0} imagini sunt': '{0} images are',
  'Așa o vede furnizorul': 'How the supplier sees it',
  'Semnătura, cum o vede furnizorul': 'The signature, as the supplier sees it',
  '<!doctype html><meta charset="utf-8"><body style="margin:12px 14px;font:400 15px/22px Archivo,\'Segoe UI\',Arial,sans-serif;color:#0F1D33">Cu stimă,{0}</body>':
    '<!doctype html><meta charset="utf-8"><body style="margin:12px 14px;font:400 15px/22px Archivo,\'Segoe UI\',Arial,sans-serif;color:#0F1D33">Kind regards,{0}</body>',
  'Lipește semnătura ca s-o vezi aici.': 'Paste your signature to see it here.',
  'Salvează semnătura': 'Save signature',
  // apps/web/src/components/SiteBoard.tsx
  'după 2 oferte': 'after 2 quotes',
  'în curs': 'in progress',
  'Cerere trimisă': 'Request sent',
  'Oferte primite': 'Quotes received',
  Comparare: 'Compare',
  Decizie: 'Decision',
  'Încă nicio ofertă. Tabelul se umple pe măsură ce răspund furnizorii.':
    'No quotes yet. The table fills up as suppliers reply.',
  Material: 'Material',
  'Cea mai bună ofertă': 'Best quote',
  incompletă: 'incomplete',
  '{0} {1} · lei/{2}': '{0} {1} · lei/{2}',
  'Cost total': 'Total cost',
  'Comanda e împărțită: ': 'The order is split: ',
  'Combinând furnizorii ai plăti ': "Combining suppliers you'd pay ",
  'cu {0} mai puțin decât cea mai bună ofertă întreagă{1}': '{0} less than the best single quote{1}',
  ' · o împarți din cerere, câte o comandă pe furnizor':
    ' · split it from the request, one order per supplier',
  'Deschide cererea': 'Open the request',
  'Împarte din cerere': 'Split from the request',
  'Deschide tabelul comparativ întreg →': 'Open the full comparison table →',
  'încă {0}': '{0} more',
  'Total {0}': 'Total {0}',
  'Ofertă primită · {0}': 'Quote received · {0}',
  'Cerere trimisă · {0}': 'Request sent · {0}',
  'Netrimisă încă': 'Not sent yet',
  'cea mai bună': 'best',
  așteptăm: 'waiting',
  'Ofertele în PDF și documentele primite de la furnizori apar aici.':
    'PDF quotes and documents received from suppliers show up here.',
  'Material / poziție': 'Material / item',
  incomplet: 'incomplete',
  'Nicio comandă încă pe șantier.': 'No orders on the site yet.',
  'Aici apar cererile trimise, ofertele, comenzile și livrările șantierului.':
    'Requests sent, quotes, orders and deliveries for the site show up here.',
  '{0} din {1}{2}': '{0} of {1}{2}',
  '{0} complete': '{0} complete',
  // apps/web/src/components/SiteDialog.tsx
  'Completează numele șantierului': 'Enter the site name',
  'Bugetul trebuie să fie o sumă în lei, mai mare decât zero':
    'The budget must be an amount in lei, greater than zero',
  'Șantier actualizat': 'Site updated',
  'Șantier adăugat': 'Site added',
  'Editează {0}': 'Edit {0}',
  'Șantier nou': 'New site',
  'ex. Creșă Pucioasa': 'e.g. Riverside Nursery',
  Localitate: 'Town',
  'ex. Pucioasa, DB': 'e.g. Leeds',
  'Beneficiar (opțional)': 'Client (optional)',
  'ex. Primăria Pucioasa': 'e.g. Leeds City Council',
  'Adresă de livrare (opțional)': 'Delivery address (optional)',
  'strada și numărul, dacă diferă de localitate': 'street and number, if different from the town',
  'Buget achiziții (opțional)': 'Purchasing budget (optional)',
  'lei fără TVA': 'lei excl. VAT',
  'Pe panou vezi cât s-a cumpărat și cât e angajat față de el.':
    'On the dashboard you see how much has been bought and committed against it.',
  'Adaugă șantier': 'Add site',
  'Tot ce se cere și se cumpără ține de un șantier. Adresa ajunge în mailul către furnizori, ca loc de livrare.':
    'Everything you request and buy belongs to a site. The address goes into the email to suppliers, as the delivery location.',
  // apps/web/src/components/SiteLedger.tsx
  'Pe scurt': 'At a glance',
  Comandat: 'Ordered',
  'fără TVA, din comenzile emise': 'excl. VAT, from issued orders',
  'alegere fără comandă': 'choice without an order',
  'alegeri fără comandă': 'choices without an order',
  estimată: 'estimated',
  ', {0} fără valoare': ', {0} with no value',
  'de la {0}': 'from {0}',
  furnizori: 'suppliers',
  'încă niciuna': 'none yet',
  'În lucru': 'In progress',
  'cerere deschisă': 'open request',
  'cereri deschise': 'open requests',
  ', {0} fără ofertă completă': ', {0} without a complete quote',
  'nicio cerere deschisă': 'no open requests',
  'Diferență obținută': 'Savings achieved',
  'sub următoarea ofertă, la {0}': 'below the next quote, on {0}',
  comandă: 'order',
  comenzi: 'orders',
  'apare când alegi cea mai ieftină din cel puțin două':
    'shows up when you pick the cheapest of at least two',
  'ce s-a comandat, de la cine': 'what was ordered, and from whom',
  'Nicio comandă încă. Când alegi furnizorul la o cerere („Cu cine ai rămas?”), comanda apare aici, cu pozițiile și banii ei.':
    'No orders yet. When you choose the supplier on a request ("Who did you go with?"), the order shows up here, with its items and costs.',
  'fără valoare': 'no value',
  'estimată, după ofertă': 'estimated, from the quote',
  'cu {0} sub următoarea': '{0} below the next one',
  'cu {0} peste cea mai ieftină': '{0} above the cheapest',
  necotată: 'not quoted',
  'După ofertă, cu transportul și costurile pe comandă': 'From the quote, with delivery and per-order costs',
  'Valoarea comenzii, trecută de tine': 'Order value, entered by you',
  'Pozițiile din comanda {0}, cum a fost emisă; valoarea e fără TVA.':
    'Items on order {0}, as issued; the value is excl. VAT.',
  'Cantitățile sunt cele cerute, cu prețurile ofertei alese. Fă comanda din cerere ca să rămână ce s-a negociat.':
    "Quantities are as requested, at the chosen quote's prices. Create the order from the request so what was negotiated is kept.",
  'Deschide comanda': 'Open the order',
  'Vezi cererea și comparația': 'See the request and comparison',
  'Pe categorii': 'By category',
  'Pe furnizori': 'By supplier',
  Materiale: 'Materials',
  'Copiază pentru Excel': 'Copy for Excel',
  'Preț mediu': 'Average price',
  '{0} lei': '{0} lei',
  'Adunate pe denumire și unitate de măsură. Prețul mediu e ponderat cu cantitățile.':
    'Grouped by description and unit. The average price is weighted by quantity.',
  'Arată mai puține': 'Show fewer',
  'Arată toate ({0})': 'Show all ({0})',
  '· planificat {0} ({1}{2}{3})': '· planned {0} ({1}{2}{3})',
  furnizor: 'supplier',
  estimate: 'estimated',
  // apps/web/src/components/SpendBars.tsx
  'Nu ai trecut încă nicio valoare de comandă. Apare aici de îndată ce alegi un furnizor și scrii cât ai comandat.':
    "You haven't entered any order values yet. They show up here as soon as you choose a supplier and enter how much you ordered.",
  // apps/web/src/components/SplitAward.tsx
  'Comanda împărțită': 'Split order',
  'Comandă împărțită': 'Split order',
  '{0} furnizori · {1} {2}': '{0} suppliers · {1} {2}',
  '{0} lei fără TVA · ': '{0} lei excl. VAT · ',
  'emisă {0} · {1} fără TVA{2}': 'issued {0} · {1} excl. VAT{2}',
  '1 suplimentare': '1 top-up',
  '{0} suplimentări': '{0} top-ups',
  'așteaptă aprobare': 'awaiting approval',
  'Încă nefăcută': 'Not done yet',
  'Se completează din oferta lui, doar cu pozițiile de aici.':
    'Filled in from their quote, with only the items listed here.',
  Suplimentare: 'Top-up',
  'Fă comanda': 'Create the order',
  // apps/web/src/components/SplitDialog.tsx
  'Comanda e împărțită între {0} furnizori': 'The order is split between {0} suppliers',
  'Fiecare poziție de la furnizorul ales pentru ea. Am propus cel mai mic preț pe poziție; schimbă unde ai alt motiv. Iese câte o comandă pentru fiecare furnizor, fiecare cu transportul ei.':
    "Each item goes to the supplier chosen for it. We've suggested the lowest price per item; change it where you have another reason. One order is created per supplier, each with its own delivery.",
  'De la': 'From',
  'Furnizorul pentru {0}': 'Supplier for {0}',
  ' · necotat': ' · not quoted',
  ' · {0} lei/{1}': ' · {0} lei/{1}',
  'fără preț': 'no price',
  '1 poziție': '1 item',
  '{0} poziții': '{0} items',
  ' · transport {0}': ' · delivery {0}',
  ' · {0} fără preț': ' · {0} without a price',
  'Total împărțit': 'Split total',
  '−{0} față de cea mai bună ofertă întreagă ({1})': '−{0} compared with the best single quote ({1})',
  '+{0} peste cea mai bună ofertă întreagă ({1})': '+{0} above the best single quote ({1})',
  'cât cea mai bună ofertă întreagă ({0})': 'same as the best single quote ({0})',
  'o poziție n-are preț de la furnizorul ales pentru ea':
    'an item has no price from the supplier chosen for it',
  Motivul: 'Reason',
  'plasa e mai ieftină la celălalt furnizor': 'the mesh is cheaper from the other supplier',
  'Opțional. Un rând ajunge.': 'Optional. One line is enough.',
  // apps/web/src/components/StateBox.tsx
  'Se încarcă…': 'Loading…',
  'Încearcă din nou': 'Try again',
  // apps/web/src/components/SupplierDialog.tsx
  'Ultima cifră (cifra de control) nu se potrivește cu celelalte. Verifică-l pe o factură sau pe anaf.ro.':
    "The last digit (the check digit) doesn't match the others. Check it on an invoice or on anaf.ro.",
  'Completează numele firmei': 'Enter the company name',
  'Completează {0}-ul furnizorului': "Enter the supplier's {0}",
  'CUI-ul pare greșit': 'The CUI looks wrong',
  '{0}: ultima cifră (cifra de control) nu se potrivește cu celelalte, de obicei semn că o cifră e tastată greșit. Dacă știi că e corect, îl poți salva așa.':
    "{0}: the last digit (the check digit) doesn't match the others, which usually means a digit was mistyped. If you know it's correct, you can save it anyway.",
  'Salvează așa': 'Save anyway',
  Corectez: "I'll fix it",
  'Completează adresa furnizorului': "Enter the supplier's address",
  'Alege cel puțin o categorie': 'Choose at least one category',
  'Adaugă cel puțin o persoană de contact': 'Add at least one contact person',
  'Completează un email valid pentru {0}': 'Enter a valid email for {0}',
  'Completează un email valid': 'Enter a valid email',
  'Furnizor actualizat': 'Supplier updated',
  'Furnizor adăugat': 'Supplier added',
  'Furnizor nou': 'New supplier',
  'Furnizorul apare în {0} {1}. Numele corectat se vede și acolo.':
    'The supplier appears on {0} {1}. The corrected name shows there too.',
  cereri: 'requests',
  'Un distribuitor poate avea mai multe categorii și mai mulți oameni.':
    'A distributor can have several categories and several contacts.',
  Firmă: 'Company',
  'Apare pe comenzile către el.{0}': 'It appears on orders to them.{0}',
  ' Numele și adresa vin de la ANAF.': ' The name and address come from ANAF.',
  'Adresă (sediu)': 'Address (head office)',
  'Adresă sediu (obligatorie)': 'Head office address (required)',
  'Str. Zizinului 110, Brașov': '12 High Street, Leeds',
  'Furnizorul și-a trecut singur datele pe {0}, după oferta prin link{1}':
    'The supplier filled in their own details on {0}, after quoting through the link{1}',
  '. Livrează în: {0}.': '. Delivers to: {0}.',
  Nume: 'Name',
  'Nume persoană de contact': 'Contact name',
  'Email persoană de contact': 'Contact email',
  'Telefon persoană de contact': 'Contact phone',
  'Se ocupă de (ex. HVAC)': 'Handles (e.g. HVAC)',
  'Gama de care se ocupă': 'Product range they handle',
  'Propus implicit la cereri': 'Suggested by default on requests',
  'Scoate persoana': 'Remove contact',
  'Adaugă persoană': 'Add contact',
  'Adaugă furnizor': 'Add supplier',
  'Caut la ANAF…': 'Looking up at ANAF…',
  'Caută la ANAF': 'Look up at ANAF',
  'Activă, plătitoare de TVA.': 'Active, VAT registered.',
  'Folosește numele și adresa de la ANAF': 'Use the name and address from ANAF',
  'Verific…': 'Checking…',
  'Verifică din nou': 'Check again',
  cerere: 'request',
  'Limba mailurilor către el': 'Language for emails to them',
  'Cererea, mementourile, comanda și pagina ofertei.':
    'The request, reminders, the order and the quote page.',
  // apps/web/src/components/SupplierProfileCard.tsx
  'CUI-ul nu pare corect. Verificați-l pe o factură.':
    "The CUI doesn't look right. Please check it on an invoice.",
  'Alegeți județele în care livrați, sau „Toată țara”.':
    'Choose the counties you deliver to, or "Whole country".',
  'Datele firmei': 'Company details',
  'Livrați în: {0}': 'You deliver to: {0}',
  'Schimbă datele': 'Change details',
  'Datele firmei (opțional)': 'Company details (optional)',
  'Ca să primiți comenzile de la {0} pe datele corecte. Numele și sediul le luăm de la ANAF după CUI.':
    'So you receive orders from {0} with the right details. We take the name and head office from ANAF using the CUI.',
  'Unde livrați': 'Where you deliver',
  'Telefon (opțional)': 'Phone (optional)',
  '07xx xxx xxx': '07xx xxx xxx',
  'Salvează datele firmei': 'Save company details',
  '{0}CUI {1}': '{0}CUI {1}',
  CUI: 'CUI',
  // apps/web/src/components/TeamSection.tsx
  'Retragi invitația?': 'Withdraw the invitation?',
  'Linkul trimis la {0} nu va mai merge.': 'The link sent to {0} will stop working.',
  'Retrage invitația': 'Withdraw invitation',
  'Invitație retrasă': 'Invitation withdrawn',
  'Scoți pe {0} din firmă?': 'Remove {0} from the company?',
  'Nu mai poate intra și iese din aplicație pe loc. Numele rămâne pe cererile făcute până acum.':
    "They can no longer sign in and are signed out straight away. Their name stays on the requests they've made so far.",
  'Scoate din firmă': 'Remove from company',
  'Scos din firmă': 'Removed from company',
  'Readus în firmă': 'Back in the company',
  '{0} e acum {1}': '{0} is now {1}',
  '{0} e acum administrator': '{0} is now an administrator',
  '{0} nu mai e administrator': '{0} is no longer an administrator',
  'Doar un administrator al contului invită colegi și le schimbă rolul.':
    'Only an account administrator can invite colleagues and change their role.',
  'linkul e valabil 14 zile': 'the link is valid for 14 days',
  'Emailul colegului': "Colleague's email",
  'Rolul colegului': "Colleague's role",
  'Contul de șantier nu poate fi administrator': "A site account can't be an administrator",
  'Se face…': 'Creating…',
  'Fă invitația': 'Send invitation',
  ' Administratorul schimbă și datele firmei, echipa și pachetul.':
    ' An administrator also manages the company details, the team and the plan.',
  'Invitația a plecat pe mail la {0}': 'The invitation was emailed to {0}',
  'Mailul către {0} n-a plecat': "The email to {0} didn't go out",
  '{0} Linkul nu se mai arată a doua oară: dacă îl pierzi, faci altă invitație.':
    "{0} The link won't be shown again: if you lose it, create a new invitation.",
  'Dacă nu-l găsește (uneori ajunge în Spam), trimite-i linkul de mai jos pe WhatsApp.':
    "If they can't find it (sometimes it lands in spam), send them the link below on WhatsApp.",
  'Trimite-i tu linkul, pe mail sau pe WhatsApp.': 'Send them the link yourself, by email or WhatsApp.',
  Copiază: 'Copy',
  'Invitații trimise': 'Invitations sent',
  '{0}{1} · {2}expiră {3}': '{0}{1} · {2}expires {3}',
  'invitat de {0} · ': 'invited by {0} · ',
  'n-a intrat încă': "hasn't joined yet",
  Retrage: 'Withdraw',
  'În firmă': 'In the company',
  persoană: 'person',
  Rol: 'Role',
  'Rolul lui {0}': "{0}'s role",
  'Scoși din firmă': 'Removed from the company',
  'rămân scriși pe ce au făcut': 'their names stay on what they did',
  'fără acces': 'no access',
  'Readu în firmă': 'Bring back',
  Schimbă: 'Change',
  Alege: 'Choose',
  'Șantierele lui {0}': "{0}'s sites",
  administrator: 'administrator',
  persoane: 'people',
  Om: 'Person',
  'Răspunde de șantierele': 'Responsible for sites',
  tu: 'you',
  admin: 'admin',
  'trimite necesarul de pe șantier': 'sends site requisitions',
  niciunul: 'none',
  'Primește mailurile despre comentariile de pe cererile acestor șantiere.':
    'Gets the emails about comments on requests for these sites.',
  'email.colegului@firma.ro': 'colleague@company.com',
  // apps/web/src/components/TemplateImportDialog.tsx
  'Alege fișierul Excel cu șablonul completat.': 'Choose the Excel file with the completed template.',
  'Alege șantierul.': 'Choose the site.',
  'Dă un nume cererii.': 'Give the request a name.',
  'Alege o categorie.': 'Choose a category.',
  'Cererea e gata, cu ofertele din șablon': 'The request is ready, with the quotes from the template',
  'Câteva rânduri n-au intrat; le poți adăuga de mână în cerere.':
    "A few rows didn't come in; you can add them to the request by hand.",
  'Din șablonul Excel': 'From the Excel template',
  'Ai completat șablonul „Comparație oferte” de pe': 'Filled in the "Quote comparison" template from',
  Fișierul: 'File',
  'Alege alt fișier': 'Choose another file',
  'Alege fișierul .xlsx': 'Choose the .xlsx file',
  'Șablonul completat, salvat ca .xlsx': 'The completed template, saved as .xlsx',
  'Denumire cerere': 'Request name',
  'ex. Armătură fundații – Bloc P+4': 'e.g. Foundation rebar – Block A',
  'ex. Aprovizionare noiembrie – sediul central': 'e.g. November supplies – head office',
  'Nu ai niciun șantier deschis. Adaugă unul din secțiunea Șantiere.':
    'You have no open sites. Add one from the Sites section.',
  Categorie: 'Category',
  'Furnizorii din capul coloanelor se caută în agendă după nume; cei care nu sunt acolo se adaugă, fără persoană de contact. Nu pleacă niciun mail.':
    "Suppliers in the column headers are matched by name in your address book; any that aren't there are added, without a contact person. No emails are sent.",
  'Se citește…': 'Reading…',
  'Fă cererea': 'Create the request',
  'procumi.com': 'procumi.com',
  '? Încarcă-l aici: pozițiile devin o cerere de ofertă, iar prețurile, ofertele furnizorilor, cu tabelul comparativ gata.':
    "? Upload it here: the items become a request for quotes, and the prices become the suppliers' quotes, with the comparison table ready.",
  'Alege șantierul…': 'Choose the site…',
  // apps/web/src/components/ToApprove.tsx
  'De aprobat': 'To approve',
  '{0} așteaptă decizia ta': '{0} waiting for your decision',
  'o comandă': 'one order',
  '{0} comenzi': '{0} orders',
  'Suplimentare · ': 'Top-up · ',
  ' · pasul {0} din {1}': ' · step {0} of {1}',
  // apps/web/src/lib/api.ts
  'Serverul nu răspunde. Verifică dacă API-ul rulează.':
    "The server isn't responding. Check that the API is running.",
  'Ceva nu a funcționat.': 'Something went wrong.',
  // apps/web/src/lib/clipboard.ts
  Copiat: 'Copied',
  'Copierea nu e permisă aici. Selectează textul manual.':
    "Copying isn't allowed here. Select the text by hand.",
  // apps/web/src/lib/rich.tsx
  'Apasă <b>Trimite</b> când ești gata.': "Press <b>Send</b> when you're ready.",
  // apps/web/src/main.tsx
  'Lipsește #root din index.html': '#root is missing from index.html',
  // apps/web/src/pages/AdminPage.tsx
  'nefolosit încă': 'not used yet',
  'așteaptă codul': 'waiting for the code',
  'firmă făcută': 'company created',
  'linkul ăsta': 'this link',
  'Retragi linkul?': 'Withdraw the link?',
  'Linkul de înscriere pentru {0} nu va mai merge.': 'The sign-up link for {0} will stop working.',
  'Retrage linkul': 'Withdraw link',
  'Link retras': 'Link withdrawn',
  'Firmele se înscriu singure de pe site, cu probă gratuită, sau cu un link făcut de aici. Omul confirmă emailul cu un cod primit pe mail.':
    'Companies sign up on their own from the website, with a free trial, or with a link made here. The person confirms their email with a code we send them.',
  'Link de înscriere nou': 'New sign-up link',
  'merge o singură dată, 14 zile': 'works once, for 14 days',
  'pentru cine e, ex. Construct Brașov, Mihai': "who it's for, e.g. Northside Builders, Mike",
  'Pentru cine e linkul': 'Who the link is for',
  'Fă linkul': 'Create link',
  'Linkul pentru {0}': 'The link for {0}',
  'Linkul de înscriere': 'Sign-up link',
  'Trimite-i-l tu. Nu se mai arată a doua oară: dacă îl pierzi, retragi linkul și faci altul.':
    "Send it to them yourself. It won't be shown again: if you lose it, withdraw it and create another.",
  'Linkuri făcute': 'Links created',
  'fără notă': 'no note',
  'înscrisă {0}': 'signed up {0}',
  'făcut {0} · expiră {1}': 'created {0} · expires {1}',
  'Data plății a fost ștearsă': 'Payment date removed',
  'Suspenzi accesul pentru {0}?': 'Suspend access for {0}?',
  'Toți utilizatorii firmei ies pe loc și nu mai pot intra până nu le redai accesul. Datele lor rămân neatinse.':
    "All the company's users are signed out straight away and can't sign in until you restore access. Their data stays untouched.",
  'Suspendă accesul': 'Suspend access',
  'Accesul pentru {0} e suspendat': 'Access for {0} is suspended',
  '{0}: pachetul {1}': '{0}: {1} plan',
  '{0}: fără pachet': '{0}: no plan',
  '{0}: proba până pe {1}': '{0}: trial until {1}',
  '{0}: fără probă': '{0}: no trial',
  '{0} are din nou acces': '{0} has access again',
  Firme: 'Companies',
  firmă: 'company',
  ' · {0} cu plata expirată': ' · {0} with expired payment',
  '„Plătit până la” e doar evidența ta: accesul nu se oprește singur când trece data. Îl oprești cu „Suspendă”.':
    '"Paid until" is only your record: access doesn\'t stop by itself when the date passes. Stop it with "Suspend".',
  '{0} {1} · {2} {3} · din {4} {5} · {6}': '{0} {1} · {2} {3} · since {4} {5} · {6}',
  'cumpără: {0}': 'buys: {0}',
  'a cerut': 'requested',
  ', {0}, pe {1}': ', {0}, on {1}',
  'suspendată din {0}': 'suspended since {0}',
  'Pachetul pentru {0}': 'Plan for {0}',
  'Cum plătește {0}': 'How {0} pays',
  'Cum plătește': 'How they pay',
  'Ultima zi de probă, pentru {0}': 'Last trial day, for {0}',
  'Ultima zi de probă (gol = fără limite, ca firmele vechi)':
    'Last trial day (empty = no limits, like older companies)',
  'Plătit până la, pentru {0}': 'Paid until, for {0}',
  'Plătit până la': 'Paid until',
  'Redă accesul': 'Restore access',
  Suspendă: 'Suspend',
  'probă până pe {0}': 'trial until {0}',
  'doar citire': 'read-only',
  Pâlnia: 'Funnel',
  Perioada: 'Period',
  'Vizite pe site': 'Website visits',
  'Clicuri „Încearcă gratuit”': '"Try it free" clicks',
  'Clicuri pe demo': 'Demo clicks',
  'Paginile văzute': 'Pages viewed',
  'De unde vin': 'Where they come from',
  'Vizitele se numără fără cookie-uri: doar câte afișări are o pagină pe zi și din ce țară. IP-ul servește doar la aflarea locului și nu se păstrează. Procentul de lângă fiecare pas e din pasul de dinainte.':
    'Visits are counted without cookies: just how many times each page is viewed per day, and from which country. The IP address is only used to work out the location and is never stored. The percentage next to each step is relative to the step before.',
  'Încă nimic.': 'Nothing yet.',
  lunar: 'monthly',
  anual: 'yearly',
  expirat: 'expired',
  // apps/web/src/pages/AgentPage.tsx
  'De verificat': 'To check',
  'De potrivit': 'To match',
  Salvată: 'Saved',
  'Pusă deoparte': 'Set aside',
  'Fișierul e prea mare. Maximul e {0} MB.': 'The file is too big. The maximum is {0} MB.',
  'N-am găsit ce trebuie cumpărat. Scrie produsele și cantitățile.':
    "I couldn't find what needs buying. Write the products and quantities.",
  'ex. Avem nevoie pe șantierul din Cluj de 40 mc beton C25/30, 3 t oțel BST500 Ø12 și 200 saci adeziv, până vineri.':
    'e.g. For the Leeds site we need 40 m³ of C25/30 concrete, 3 t of B500 Ø12 rebar and 200 bags of tile adhesive, by Friday.',
  'ex. Pentru restaurant: 20 l ulei floarea-soarelui, 50 kg făină 000, 30 bax apă plată 0,5 l, până joi.':
    'e.g. For the restaurant: 20 l sunflower oil, 50 kg plain flour, 30 cases of still water 0.5 l, by Thursday.',
  'Îi spui ce-ți trebuie, el face cererile pe categorii. Ofertele venite pe mail le pune singur la cererea lor și citește prețurile. Tu verifici și decizi.':
    'Tell it what you need and it creates the requests by category. Quotes that arrive by email are matched to their request and the prices are read automatically. You check and decide.',
  '{0} lucrează pentru firmele cu pachet': '{0} works for companies on a paid plan',
  'Îi scrii ce-ți trebuie, ca pe WhatsApp, sau îi dai o poză cu lista: face cererile pe categorii.':
    'Write what you need, like on WhatsApp, or give it a photo of the list: it creates the requests by category.',
  'Ofertele venite pe mail le pune singur la cererea lor și citește prețurile.':
    'Quotes that arrive by email are matched to their request and the prices are read automatically.',
  'Tu verifici și decizi: nu trimite și nu salvează nimic fără tine.':
    "You check and decide: it doesn't send or save anything without you.",
  'Spune-i ce-ți trebuie': 'Tell it what you need',
  'Citesc „{0}” și împart pozițiile pe categorii…': 'Reading "{0}" and sorting the items into categories…',
  'Scrie ca pe WhatsApp sau lipește o listă': 'Write as you would on WhatsApp, or paste a list',
  'mesajul tău': 'your message',
  'Fă cererile': 'Create the requests',
  'Încarcă o poză, un PDF sau un Excel': 'Upload a photo, PDF or Excel file',
  'Citirea automată nu e pornită pe server.': "Automatic reading isn't switched on on the server.",
  'Ofertele venite pe mail': 'Quotes received by email',
  'Răspunsurile la cererile trimise din Procumi ajung aici singure. O ofertă venită la tine în căsuță: dă-i <b>Forward</b> la adresa lui {0}.':
    "Replies to requests sent from Procumi arrive here automatically. For a quote that landed in your own inbox, <b>forward</b> it to {0}'s address.",
  'Căsuța lui {0} nu e pornită încă pe server.': "{0}'s inbox isn't switched on on the server yet.",
  'Niciun mail încă. Când un furnizor răspunde, oferta apare aici, citită, gata de verificat.':
    'No emails yet. When a supplier replies, the quote shows up here, already read and ready to check.',
  'Pus la cerere. {0} a citit {1} poziții: verifică oferta.':
    'Matched to the request. {0} read {1} items: check the quote.',
  'Pus la cerere.': 'Matched to the request.',
  '{0} · Forward de la {1}': '{0} · forwarded by {1}',
  '(fără subiect)': '(no subject)',
  '{0} a citit {1} {2}.': '{0} read {1} {2}.',
  'Cererea și furnizorul': 'Request and supplier',
  'Alege cererea și furnizorul…': 'Choose the request and supplier…',
  'Pune la cerere': 'Match to request',
  'Nu e nicio cerere deschisă {0}. Adaugă furnizorul la cerere, apoi încearcă din nou.':
    "There's no open request {0}. Add the supplier to the request, then try again.",
  'trimisă acestui furnizor': 'sent to this supplier',
  'Verifică oferta': 'Check the quote',
  'Alege cererea': 'Choose the request',
  'Altă cerere': 'Another request',
  'Adu înapoi': 'Bring back',
  'Nu e ofertă': 'Not a quote',
  // apps/web/src/pages/AnalysisPage.tsx
  'Banii, lunile și furnizorii, din comenzile și cererile tale':
    'Money, months and suppliers, from your orders and requests',
  'Achiziții și angajamente': 'Purchases and commitments',
  achiziționat: 'bought',
  'ultimele 12 luni': 'last 12 months',
  'Apare după prima comandă emisă.': 'Shows up after the first order is issued.',
  'Pe șantier': 'By site',
  'Parcursul cererilor': 'Request progress',
  'ultimele {0} de zile': 'last {0} days',
  'Toți furnizorii': 'All suppliers',
  'Nimic încă. Aici apar cererile, ofertele, comenzile și livrările.':
    'Nothing yet. Requests, quotes, orders and deliveries show up here.',
  'Pagina {0} din {1}': 'Page {0} of {1}',
  'Paginile activității': 'Activity pages',
  'Pagina {0}': 'Page {0}',
  'Nu există încă suficiente date. Apare la comenzile unde ai ales din cel puțin două oferte complete.':
    'Not enough data yet. It shows up for orders where you chose from at least two complete quotes.',
  'Diferența dintre oferta aleasă și următoarea ofertă completă, la {0} {1}. Nu față de cea mai scumpă: un preț umflat n-ar fi o economie.':
    "The difference between the chosen quote and the next complete quote, across {0} {1}. Not against the most expensive: an inflated price wouldn't be a saving.",
  'Nicio comandă la care să fi ales cea mai ieftină din cel puțin două oferte complete.':
    'No orders where you chose the cheapest of at least two complete quotes.',
  'La {0} {1} ai ales peste cea mai ieftină: +{2}.': 'On {0} {1} you chose above the cheapest: +{2}.',
  'Suplimentări fără concurență: {0}, nu intră aici.':
    'Top-up orders without competition: {0}, not counted here.',
  Buget: 'Budget',
  '{0}% folosit': '{0}% used',
  'Nicio cerere în ultimele {0} de zile.': 'No requests in the last {0} days.',
  Cereri: 'Requests',
  Trimise: 'Sent',
  'Cu oferte': 'With quotes',
  Decise: 'Decided',
  Comandă: 'Ordered',
  Finalizată: 'Completed',
  'Apare după primele cereri trimise: cine răspunde, cât de repede, pe cine alegi.':
    'Shows up after your first requests are sent: who replies, how fast, who you choose.',
  Răspunde: 'Replies',
  'În medie': 'On average',
  Ales: 'Chosen',
  angajat: 'committed',
  planificat: 'planned',
  'Trece bugetul pe șantier (Șantiere → Editează) ca să vezi cât din el e folosit.':
    'Add the budget to the site (Sites → Edit) to see how much of it is used.',
  comandat: 'ordered',
  // apps/web/src/pages/AuthScreen.tsx
  'Ai uitat parola?': 'Forgot your password?',
  'Scrie emailul cu care intri. Îți trimitem un link din care îți alegi o parolă nouă.':
    "Enter the email you sign in with. We'll send you a link to choose a new password.",
  'Intră în cont': 'Sign in',
  'Dacă există un cont pe <b>{0}</b>, îți vine un mail cu linkul pentru parola nouă. Linkul merge o oră. Dacă nu-l vezi în câteva minute, uită-te și în Spam.':
    "If there's an account for <b>{0}</b>, you'll get an email with a link to set a new password. The link works for one hour. If you don't see it within a few minutes, check your spam folder.",
  Parolă: 'Password',
  'Trimite-mi linkul': 'Send me the link',
  'Înapoi la intrare': 'Back to sign in',
  'Am uitat parola': 'I forgot my password',
  'Firma ta nu are cont?': 'Company not on Procumi yet?',
  'Încearcă gratuit {0} zile': 'Try it free for {0} days',
  'Fără card. Colegii intră cu invitația primită din firmă.':
    'No card needed. Colleagues join with the invitation they get from your company.',
  // apps/web/src/pages/BoqPage.tsx
  'N-am găsit poziții de cumpărat în document.': "I couldn't find any items to buy in the document.",
  'Scrie cantitatea pentru „{0}” sau scoate bifa.': 'Enter the quantity for "{0}" or untick it.',
  'Bifează cel puțin o poziție.': 'Tick at least one item.',
  'Citesc „{0}”': 'Reading "{0}"',
  'Lipește lista de cantități': 'Paste the quantity list',
  'ex.\nBeton C25/30 fundații\t42 mc\nOțel BST500 Ø12\t3,2 t\nCofraj pereți h 3 m\t180 mp':
    'e.g.\nC25/30 concrete, foundations\t42 m³\nB500 Ø12 rebar\t3.2 t\nWall formwork h 3 m\t180 m²',
  'textul lipit': 'the pasted text',
  'Citește lista': 'Read the list',
  'Încarc un fișier': 'Upload a file',
  'Deviz, listă de cantități sau necesar: PDF, Excel (.xlsx, .xls), CSV sau o poză clară cu foaia. Până la {0} MB.':
    'Bill of quantities, quantity list or requisition: PDF, Excel (.xlsx, .xls), CSV or a clear photo of the sheet. Up to {0} MB.',
  'Alege fișierul': 'Choose file',
  'Lipește textul': 'Paste text',
  '<b>1</b> Citesc pozițiile și le împart pe categoriile tale: Armătură, Beton, Cofraje…':
    '<b>1</b> I read the items and sort them into your categories: Rebar, Concrete, Formwork…',
  '<b>2</b> Le verifici: corectezi cantitățile, scoți ce nu cumperi acum.':
    "<b>2</b> You check them: correct the quantities, remove anything you're not buying now.",
  '<b>3</b> Faci câte o cerere pe categorie; furnizorii categoriei sunt deja bifați.':
    "<b>3</b> You create one request per category; the category's suppliers are already ticked.",
  'Alt document': 'Another document',
  '<b>{0}</b> {1} în <b>{2}</b> {3}, din „{4}”{5}': '<b>{0}</b> {1} in <b>{2}</b> {3}, from "{4}"{5}',
  'De verificat înainte să trimiți:': 'Check before you send:',
  'Cererea e făcută': 'Request created',
  'mută pozițiile pe o categorie': 'move the items to a category',
  'Fă cererea{0}': 'Create the request{0}',
  'Intră în cerere': 'Go to the request',
  'chirie {0} zile': 'rental {0} days',
  'Intră în cerere: {0}': 'Go to the request: {0}',
  Poziția: 'Item',
  'fără înălțime: completeaz-o în cerere, la „Poziție de cofraj”':
    'no height: fill it in on the request, under "Formwork item"',
  lipsă: 'missing',
  'Cantitatea pentru {0}': 'Quantity for {0}',
  'Unitatea de măsură': 'Unit of measure',
  'Categoria pentru {0}': 'Category for {0}',
  'Din {0}': 'From {0}',
  'Încarci devizul sau lista de cantități. Citesc pozițiile, le împart pe categorii și faci câte o cerere de ofertă pentru fiecare.':
    'Upload the bill of quantities or the quantity list. I read the items, sort them into categories, and you create one request for quotes for each.',
  'Scot pozițiile, cantitățile și unitățile și le împart pe categorii. De obicei durează sub un minut; la o antemăsurătoare lungă, ceva mai mult.':
    'I pull out the items, quantities and units and sort them into categories. It usually takes under a minute; a long bill of quantities takes a bit more.',
  'Trage aici antemăsurătoarea': 'Drop the bill of quantities here',
  categorie: 'category',
  categorii: 'categories',
  'Din antemăsurătoare': 'From a bill of quantities',
  // apps/web/src/pages/CompanyPage.tsx
  'Datele firmei au fost salvate': 'Company details saved',
  Echipa: 'Team',
  Pachet: 'Plan',
  Aprobări: 'Approvals',
  'Doar un administrator al contului poate schimba datele firmei.':
    'Only an account administrator can change the company details.',
  'Apar în antetul fiecărei comenzi de achiziție, ca firma care cumpără.':
    'They appear in the header of every purchase order, as the buying company.',
  'Numele firmei': 'Company name',
  Țara: 'Country',
  Domeniul: 'Industry',
  Nespus: 'Not specified',
  'Alege categoriile de furnizori propuse.': 'Choose the suggested supplier categories.',
  'Unde ajunge marfa': 'Where the goods go',
  'Cum apare în meniu, pe cereri și în mailurile către furnizori.':
    'How it appears in the menu, on requests and in emails to suppliers.',
  'Semnătura mailurilor': 'Email signature',
  'La finalul cererilor de ofertă, al follow-up-urilor și al comenzilor către furnizori.':
    'At the end of requests for quotes, follow-ups and orders to suppliers.',
  'Ai modificări nesalvate': 'You have unsaved changes',
  '1 câmp schimbat': '1 field changed',
  '{0} câmpuri schimbate': '{0} fields changed',
  'Imaginea are {0} KB. Maximul e {1} KB.': 'The image is {0} KB. The maximum is {1} KB.',
  'Logo-ul a fost salvat': 'Logo saved',
  'Ștergi logo-ul?': 'Delete the logo?',
  'Comenzile, inclusiv cele emise deja, se vor tipări fără logo.':
    'Orders, including ones already issued, will print without a logo.',
  'Șterge logo-ul': 'Delete logo',
  'Logo-ul a fost șters': 'Logo deleted',
  Logo: 'Logo',
  'Apare sus pe comenzile de achiziție și pe paginile pe care le văd furnizorii.':
    'It appears at the top of purchase orders and on the pages suppliers see.',
  'Apare în colțul comenzilor de achiziție, pe ecran și în PDF. PNG, JPG sau WebP, cel mult {0} KB. Un PNG cu fundal transparent arată cel mai bine.':
    'It appears in the corner of purchase orders, on screen and in the PDF. PNG, JPG or WebP, up to {0} KB. A PNG with a transparent background looks best.',
  'Logo {0}': '{0} logo',
  'fără logo': 'no logo',
  'Schimbă logo-ul': 'Change logo',
  'Alege imaginea': 'Choose image',
  'Pachet {0}': '{0} plan',
  'probă, {0} {1}': 'trial, {0} {1}',
  'zi rămasă': 'day left',
  'zile rămase': 'days left',
  Colegi: 'Colleagues',
  '· nelimitat': '· unlimited',
  'din {0}': 'of {0}',
  '{0} active': '{0} active',
  'Toată lumea din Achiziții și Aprobare vede aceleași cereri și furnizori. Șefii de șantier trimit doar necesarul și nu ocupă loc în pachet.':
    "Everyone in Purchasing and Approvals sees the same requests and suppliers. Site managers only send requisitions and don't take up a seat in the plan.",
  'Semnătura e acum a fiecărui om, nu a firmei: fiecare și-o pune în <b>Profilul meu</b> (clic pe nume, jos în stânga), ca o carte de vizită cu logo-ul firmei sau cea din Outlook.':
    'The signature now belongs to each person, not the company: everyone sets their own in <b>My profile</b> (click your name, bottom left), as a business card with the company logo or their Outlook signature.',
  'Completează {0}-ul și adresa: apar pe comenzi.': 'Fill in your {0} and address: they appear on orders.',
  // apps/web/src/pages/DashboardPage.tsx
  'Nu mai e nimic de întrebat la cererea asta': 'Nothing more to ask on this request',
  Compară: 'Compare',
  Preia: 'Pick up',
  Aprobă: 'Approve',
  'Vezi ofertele': 'See quotes',
  'comparație gata': 'comparison ready',
  'comparații gata': 'comparisons ready',
  'comandă de trimis': 'order to send',
  'comenzi de trimis': 'orders to send',
  'Cereri din șantiere': 'Requests from sites',
  'Nicio cerere nouă din șantiere': 'No new requests from sites',
  'La furnizori': 'With suppliers',
  'răspuns întârziat': 'late reply',
  'răspunsuri întârziate': 'late replies',
  'Toți furnizorii sunt în termen': 'All suppliers are on time',
  'Nicio cerere la furnizori acum': 'No requests with suppliers right now',
  'De decis': 'To decide',
  'Nimic de hotărât acum': 'Nothing to decide right now',
  economisiți: 'saved',
  'comandă emisă': 'order issued',
  'comenzi emise': 'orders issued',
  'Au răspuns {0}': '{0} replied',
  'Comandat de {0} ori, cam la {1} zile; de obicei {2}, ultima dată la {3}':
    'Ordered {0} times, roughly every {1} days; usually {2}, last time from {3}',
  'Cere oferte': 'Request quotes',
  'Achizițiile pe {0}': 'Purchasing across {0}',
  'Comandat, {0}': 'Ordered, {0}',
  // apps/web/src/pages/HelpPage.tsx
  'Cum fac o cerere de ofertă': 'How to make a request for quotes',
  'Apasă „Cerere nouă”, alege șantierul și scrie materialele, cu cantitatea și unitatea de măsură.':
    'Press "New request", choose the site and list the materials, with quantity and unit.',
  'Alege furnizorii cărora le trimiți cererea și termenul până la care să răspundă.':
    'Choose the suppliers to send the request to and the deadline for their reply.',
  'Trimite: fiecare furnizor primește un e-mail cu un link unde completează oferta.':
    'Send: each supplier gets an email with a link where they fill in their quote.',
  'Cum răspund furnizorii': 'How suppliers reply',
  'Furnizorii nu au nevoie de cont: deschid linkul din e-mail și trec prețurile pe fiecare poziție.':
    "Suppliers don't need an account: they open the link in the email and enter their prices for each item.",
  'Ofertele ajung singure în cerere; pe panou vezi cine a răspuns și cine întârzie.':
    'Quotes land in the request automatically; on the dashboard you can see who has replied and who is late.',
  'Dacă un furnizor tace, trimite-i un follow-up din panou sau din cerere.':
    'If a supplier goes quiet, send them a follow-up from the dashboard or from the request.',
  'Cum compar ofertele și aleg': 'How to compare quotes and choose',
  'Deschide cererea: ofertele stau una lângă alta, pe poziții, cu cel mai mic preț scos în evidență.':
    'Open the request: the quotes sit side by side, item by item, with the lowest price highlighted.',
  'Vezi și ofertele parțiale sau cele care expiră, ca să nu compari mere cu pere.':
    "Partial quotes and ones about to expire are flagged too, so you're comparing like with like.",
  'Alege furnizorul; economia față de următoarea ofertă se socotește singură.':
    'Choose the supplier; the saving against the next quote is worked out for you.',
  'Cererile de ofertă': 'Requests for quotes',
  'Comanda și aprobarea': 'Orders and approval',
  'După alegere apasă „Fă comanda”: comanda se completează din ofertă.':
    'Once you\'ve chosen, press "Create the order": it\'s filled in from the quote.',
  'Dacă firma are reguli de aprobare, comanda așteaptă aprobatorul înainte să plece.':
    'If your company has approval rules, the order waits for the approver before it goes out.',
  'Livrările se trec pe comandă, ca să știi ce a ajuns pe șantier.':
    'Log deliveries on the order, so you know what has arrived at the site.',
  Comenzile: 'Orders',
  'Necesarul de pe șantier': 'Site requisitions',
  'Oamenii de pe șantier trimit necesarul din aplicație, cu materialele și data la care le trebuie.':
    'Site staff send requisitions from the app, with the materials and the date they need them by.',
  'Achizițiile îl preiau și fac din el o cerere de ofertă, fără să rescrie liniile.':
    'Purchasing picks them up and turns them into a request for quotes, without retyping the lines.',
  Necesarul: 'Requisitions',
  'Furnizorii tăi': 'Your suppliers',
  'Adaugă furnizorii unul câte unul sau importă-i dintr-un tabel.':
    'Add suppliers one by one or import them from a spreadsheet.',
  'Fiecare furnizor are istoricul lui: la ce a răspuns, cât de repede și cât de des a avut cel mai bun preț.':
    'Each supplier has a history: what they replied to, how fast, and how often they had the best price.',
  Furnizorii: 'Suppliers',
  'Echipa, rolurile și aprobările': 'Team, roles and approvals',
  'În „Contul firmei” inviți colegii și le dai rolul potrivit.':
    'In "Company account" you invite colleagues and give them the right role.',
  'Tot acolo stabilești cine aprobă comenzile și de la ce valoare.':
    "That's also where you set who approves orders, and above what value.",
  'Prețurile și analiza': 'Prices and analysis',
  'Fiecare preț primit rămâne în istoric: vezi ce ai plătit, la cine și când.':
    'Every price you receive stays in the history: see what you paid, to whom and when.',
  'În „Analiză” vezi cât ai cumpărat, cât ai economisit și cum lucrează furnizorii.':
    'In "Analysis" you see how much you\'ve bought, how much you\'ve saved and how your suppliers perform.',
  Prețurile: 'Prices',
  'Ajutor {0} – {1}': 'Help {0} – {1}',
  'Bună ziua,\n\nCe încercam să fac:\n\nCe s-a întâmplat:\n\n—\nFirma: {0}\nUtilizator: {1}':
    'Hello,\n\nWhat I was trying to do:\n\nWhat happened:\n\n—\nCompany: {0}\nUser: {1}',
  'Pașii de zi cu zi, pe scurt. Dacă tot nu merge, scrie-ne și te ajutăm.':
    "The day-to-day steps, in brief. If something still doesn't work, write to us and we'll help.",
  Ghiduri: 'Guides',
  'Ai nevoie de ajutor?': 'Need help?',
  'Scrie-ne ce încercai să faci și ce s-a întâmplat. O captură de ecran ne ajută să răspundem mai repede.':
    'Tell us what you were trying to do and what happened. A screenshot helps us reply faster.',
  'Scrie-ne un e-mail': 'Email us',
  'În e-mail trecem deja firma ({0}) și numele tău, ca să știm cine scrie.':
    "We already add your company ({0}) and your name to the email, so we know who's writing.",
  // apps/web/src/pages/InviteScreen.tsx
  'Mergi la ecranul de intrare': 'Go to sign in',
  'Ai fost invitat în {0}': "You've been invited to {0}",
  'Contul se face pe <b>{0}</b>. Alege-ți o parolă și intri direct.':
    "Your account will use <b>{0}</b>. Choose a password and you're in.",
  'Numele tău': 'Your name',
  'ex. Alex Ionescu': 'e.g. Alex Smith',
  'Cel puțin 8 caractere.': 'At least 8 characters.',
  'Se face contul…': 'Creating your account…',
  'Intră în firmă': 'Join the company',
  'Nu sunt eu': "That's not me",
  // apps/web/src/pages/MorningStopScreen.tsx
  'Gata, nu mai primești mailul de dimineață': "Done, you won't get the morning email any more",
  'Îl poți porni din nou din Profilul meu. Celelalte mailuri (aprobări, necesar nou, comentarii) vin în continuare.':
    'You can turn it back on in My profile. Your other emails (approvals, new requisitions, comments) will keep coming.',
  'Mergi în {0}': 'Go to {0}',
  // apps/web/src/pages/NewRequisitionPage.tsx
  rolă: 'roll',
  'Alege șantierul': 'Choose the site',
  'Scrie pe scurt ce trebuie': "Briefly describe what's needed",
  'Alege categoria': 'Choose the category',
  'Adaugă cel puțin un material': 'Add at least one material',
  'Scrie cantitatea pentru „{0}”': 'Enter the quantity for "{0}"',
  'Necesarul a fost modificat': 'Requisition updated',
  'Necesarul {0} a plecat la achiziții': 'Requisition {0} has gone to purchasing',
  'Necesarul {0} nu se mai poate modifica: a fost preluat, respins sau retras.':
    "Requisition {0} can no longer be changed: it's been picked up, rejected or withdrawn.",
  'Poți schimba orice cât timp achizițiile nu l-au preluat într-o cerere de ofertă.':
    'You can change anything until purchasing picks it up into a request for quotes.',
  'Scrie ce materiale trebuie pe șantier și până când. Achizițiile cer oferte și comandă; tu vezi aici unde a ajuns.':
    'Write which materials are needed at the site and by when. Purchasing requests quotes and places the order; you can follow progress here.',
  'Nu e niciun șantier deschis. Roagă achizițiile să-l adauge.':
    "There's no open site. Ask purchasing to add it.",
  'opțional, dar ajută achizițiile să știe ce e urgent':
    "optional, but it helps purchasing know what's urgent",
  'Ce trebuie, pe scurt': "What's needed, in brief",
  'ex. Armătură pentru placa de peste etajul 3': 'e.g. Rebar for the slab above the 3rd floor',
  'Alege categoria…': 'Choose the category…',
  'după ea, achizițiile știu căror furnizori să trimită': 'it tells purchasing which suppliers to send it to',
  'Material, cu ce contează (diametru, clasă, marcă)': 'Material, with what matters (diameter, grade, brand)',
  'Materialul {0}': 'Material {0}',
  'Cant.': 'Qty',
  'Cantitatea pentru materialul {0}': 'Quantity for material {0}',
  'Unitatea de măsură pentru materialul {0}': 'Unit of measure for material {0}',
  'Scoate materialul {0}': 'Remove material {0}',
  'Cofrajul are nevoie de element, înălțime și durată, altfel furnizorii nu știu ce să oferteze.':
    "Formwork needs the element, height and duration, otherwise suppliers don't know what to quote for.",
  'Folosește „Poziție de cofraj”': 'Use "Formwork item"',
  'Încă un material': 'Another material',
  'Adaugă în materiale': 'Add to materials',
  'Pentru achiziții (opțional)': 'For purchasing (optional)',
  'ex. Descărcare doar dimineața, macaraua e liberă până la 12':
    'e.g. Unloading mornings only, the crane is free until 12',
  'Salvează modificările': 'Save changes',
  'Achizițiile văd modificarea în clopoțel.': 'Purchasing will see the change under the bell.',
  'Trimite necesarul': 'Send requisition',
  'Achizițiile primesc un mail. Tu primești unul când îl preiau.':
    'Purchasing gets an email. You get one when they pick it up.',
  'Trebuie pe șantier la': 'Needed at the site by',
  mc: 'm³',
  ml: 'lin. m',
  sac: 'bag',
  palet: 'pallet',
  // apps/web/src/pages/NewRfqPage.tsx
  'Necesarul {0} nu mai așteaptă: a fost preluat, respins sau retras.':
    "Requisition {0} is no longer waiting: it's been picked up, rejected or withdrawn.",
  'Dă un nume cererii': 'Give the request a name',
  'Alege o categorie': 'Choose a category',
  'Adaugă cel puțin o poziție': 'Add at least one item',
  'Scrie în câte zile întregi ții la chirie „{0}”': 'Enter how many whole days you\'ll rent "{0}" for',
  'Alege cel puțin un furnizor': 'Choose at least one supplier',
  'Cererea e salvată, dar nu s-au pus: {0}. Pune-le din nou pe pagina cererii{1}.':
    "The request is saved, but these weren't added: {0}. Add them again on the request page{1}.",
  ', apoi trimite mailurile': ', then send the emails',
  'Cerere salvată. Mailurile de trimis sunt gata pentru {0} furnizori.':
    'Request saved. The emails are ready to send to {0} suppliers.',
  'Au plecat {0} mailuri. N-a plecat la: {1}': '{0} emails sent. Not sent to: {1}',
  'Cererea a plecat la {0} {1}': 'The request has gone to {0} {1}',
  'Cererea e salvată, dar mailurile n-au plecat: {0}':
    "The request is saved, but the emails didn't go out: {0}",
  '[denumire cerere]': '[request name]',
  '[șantier]': '[site]',
  '[poziție]': '[item]',
  'Cerere de ofertă nouă': 'New request for quotes',
  'Scrii cererea o singură dată. Fiecare furnizor ales primește un mail separat, către persoana aleasă pentru el.':
    'You write the request once. Each chosen supplier gets a separate email, addressed to the contact you picked for them.',
  'Necesarul din care pornește cererea': 'The requisition the request starts from',
  'necesarul trece': 'the requisition moves',
  'necesarele trec': 'the requisitions move',
  '{0}, pentru achiziții:': '{0}, for purchasing:',
  'Ce cumperi': "What you're buying",
  'denumirea, șantierul, termenul și pozițiile': 'the name, site, deadline and items',
  'ex. Echipamente HVAC – bloc P+4': 'e.g. HVAC equipment – Block A',
  'Termen răspuns': 'Reply deadline',
  'opțional; apare în mail și te avertizează pe panou':
    'optional; it appears in the email and warns you on the dashboard',
  'Produs / specificație': 'Product / specification',
  Produs: 'Product',
  ' · o singură poziție; pentru cantități separate pe înălțimi, fă câte o poziție':
    ' · one item; for separate quantities by height, make one item per height',
  'Unitate de măsură': 'Unit of measure',
  'Cumpărare sau chirie': 'Purchase or rental',
  'Durata chiriei, în zile': 'Rental period, in days',
  'Șterge poziția': 'Delete item',
  'Adaugă poziție': 'Add item',
  'Mențiuni pentru furnizori (opțional)': 'Notes for suppliers (optional)',
  'ex. Acceptăm echivalente cu fișă tehnică': 'e.g. We accept equivalents with a data sheet',
  'Planuri și documente (opțional)': 'Drawings and documents (optional)',
  'Cui trimiți': "Who you're sending to",
  '{0} din {1} furnizori{2}': '{0} of {1} suppliers{2}',
  'Din agendă': 'From your address book',
  '· din agendă{0}': '· from your address book{0}',
  'Persoana de contact la {0}': 'Contact at {0}',
  'Nu ai furnizori pe categoria {0}. Adaugă unul cu „Adaugă furnizor”, sau treci din secțiunea Furnizori un distribuitor existent și pe această categorie.':
    'You have no suppliers in the {0} category. Add one with "Add supplier", or tag an existing distributor with this category too in the Suppliers section.',
  'Alege o categorie ca să vezi furnizorii.': 'Choose a category to see the suppliers.',
  'Caută în agendă după nume sau categorie': 'Search your address book by name or category',
  'Caută în agendă': 'Search the address book',
  'fără categorie': 'no category',
  'Niciun furnizor cu „{0}” în agendă. Dacă e nou, apasă „Furnizor nou”.':
    'No supplier matching "{0}" in your address book. If they\'re new, press "New supplier".',
  'Toți furnizorii din agendă sunt deja în listă.':
    'All suppliers in your address book are already on the list.',
  Mailul: 'The email',
  'cum îl vede furnizorul': 'as the supplier sees it',
  'Începutul mailului': 'Opening of the email',
  'Pune înapoi textul obișnuit': 'Restore the standard text',
  'Scrie-l cum vorbești cu furnizorii; restul mailului se completează singur.':
    'Write it the way you talk to your suppliers; the rest of the email fills itself in.',
  'Previzualizare pentru': 'Preview for',
  Către: 'To',
  'alege un furnizor': 'choose a supplier',
  Subiect: 'Subject',
  'Semnătura e a ta, din <b>Profilul meu</b> (clic pe numele tău, jos în stânga): carte de vizită făcută de Procumi sau cea din Outlook.':
    'The signature is yours, from <b>My profile</b> (click your name, bottom left): a business card made by Procumi or your Outlook signature.',
  'Rezumatul cererii': 'Request summary',
  Rezumat: 'Summary',
  Cererea: 'Request',
  'fără denumire': 'untitled',
  Planuri: 'Drawings',
  'Memento automat cu o zi înainte de termen, la furnizorii care n-au răspuns':
    "Automatic reminder the day before the deadline, to suppliers who haven't replied",
  'Trimite la {0} {1}': 'Send to {0} {1}',
  'Doar salvează, trimit eu': "Just save, I'll send them",
  'Pleacă în numele tău, „{0} · {1}”. Când furnizorul apasă „Răspunde”, mailul ajunge la {2}. Mailul are și un buton prin care furnizorul trece prețurile direct în tabelul tău.':
    'It goes out in your name, "{0} · {1}". When the supplier presses "Reply", the email comes to {2}. The email also has a button the supplier can use to enter their prices straight into your table.',
  'Salvează și pregătește mailurile': 'Save and prepare the emails',
  'Mailurile le trimiți tu, din programul tău de mail. Le găsești gata de copiat pe pagina cererii.':
    "You send the emails yourself, from your email program. You'll find them ready to copy on the request page.",
  'În pachetele Echipă și Companie, Procumi trimite singur mailurile, în numele tău, și le amintește furnizorilor de termen.':
    'On the Team and Company plans, Procumi sends the emails for you, in your name, and reminds suppliers of the deadline.',
  '‹ Înapoi la antemăsurătoare': '‹ Back to the bill of quantities',
  necesarul: 'the requisition',
  necesarele: 'the requisitions',
  '. Liniile, șantierul și data sunt copiate; alege categoria și furnizorii. La salvare, {0} în „se cer oferte”, iar cine l-a trimis primește un mail.':
    '. The lines, site and date are copied over; choose the category and suppliers. When you save, {0} to "requesting quotes", and whoever sent it gets an email.',
  '&lt;': '&lt;',
  '&gt;': '&gt;',
  neales: 'not chosen',
  niciuna: 'none',
  // apps/web/src/pages/OrderPage.tsx
  '‹ Înapoi la cerere': '‹ Back to the request',
  'Comanda nu a fost găsită.': 'Order not found.',
  'Comanda {0} e din nou în desfășurare': 'Order {0} is in progress again',
  'Comanda {0} e {1} integral': 'Order {0} is fully {1}',
  returnată: 'returned',
  livrată: 'delivered',
  'Trimiți comanda din nou?': 'Send the order again?',
  'Trimiți comanda?': 'Send the order?',
  'Comanda {0} pleacă la {1}, cu semnătura ta. Răspunsul furnizorului ajunge la tine.':
    "Order {0} goes to {1}, with your signature. The supplier's reply comes to you.",
  'Comanda {0} a plecat la {1}': 'Order {0} sent to {1}',
  'Comanda {0} e trecută ca trimisă': 'Order {0} marked as sent',
  'Comanda {0} a fost anulată': 'Order {0} cancelled',
  Suplimentarea: 'Top-up order',
  Comanda: 'Order',
  'Așteaptă aprobare: nu o trimite încă furnizorului.':
    "Awaiting approval: don't send it to the supplier yet.",
  'Respinsă la aprobare. Din cerere poți face alta, pornind de la ce ai scris pe asta.':
    'Rejected at approval. You can create another from the request, starting from what you wrote on this one.',
  'Anulată. Rămâne aici pentru istoric; numărul nu se mai folosește.':
    "Cancelled. It stays here for the record; the number won't be reused.",
  'Marfa e pe șantier din {0}.': 'The goods have been on site since {0}.',
  'Trimisă furnizorului pe {0}{1}. Așteaptă confirmarea și livrarea.':
    'Sent to the supplier on {0}{1}. Waiting for confirmation and delivery.',
  ', din Procumi, la {0}': ', from Procumi, to {0}',
  'Mailul n-a plecat: {0}': "The email didn't go out: {0}",
  'Încă n-a plecat la furnizor: apasă „Trimite furnizorului”.':
    'Not sent to the supplier yet: press "Send to supplier".',
  'Salveaz-o ca PDF și trimite-o furnizorului din programul tău de mail.':
    'Save it as a PDF and send it to the supplier from your email program.',
  ' Suplimentare la comanda {0}, fără concurență.': ' Top-up to order {0}, without competition.',
  '{0} fără TVA': '{0} excl. VAT',
  'Livrare: {0}': 'Delivery: {0}',
  'Cererea: {0}': 'Request: {0}',
  'Trimite furnizorului': 'Send to supplier',
  'Mailul către furnizor': 'Email to the supplier',
  'Am trimis-o': "I've sent it",
  'Comanda iese din „în desfășurare” de pe panou': 'The order leaves "in progress" on the dashboard',
  'Redeschide comanda': 'Reopen the order',
  'Returnată integral': 'Fully returned',
  'Livrată integral': 'Fully delivered',
  'Tipărește / PDF': 'Print / PDF',
  'Trimite din programul meu de mail': 'Send from my email program',
  'Am trimis-o eu': 'I sent it myself',
  'Retrage comanda': 'Withdraw the order',
  'Anulează comanda': 'Cancel the order',
  'De ce o anulezi': "Why you're cancelling it",
  's-au schimbat cantitățile': 'the quantities changed',
  'Comanda rămâne în istoric, marcată anulată. Din cerere poți face una nouă, cu număr nou; pornește de la ce ai scris pe asta.':
    'The order stays in the history, marked as cancelled. You can create a new one from the request, with a new number; start from what you wrote on this one.',
  'Anulează comanda {0}': 'Cancel order {0}',
  'Chiria a stat {0} pe șantier ({1} → {2}, fără ziua returului).':
    'The rental ran for {0} at the site ({1} → {2}, not counting the return day).',
  'Pe șantier de {0}, din {1}.': 'On site for {0}, since {1}.',
  'Se plătește chiria minimă, {0} de zile. ': 'The minimum rental applies, {0} days. ',
  ' (pe comandă, estimat: {0})': ' (on the order, estimated: {0})',
  respinsă: 'rejected',
  anulată: 'cancelled',
  'returnată integral': 'fully returned',
  'livrată integral': 'fully delivered',
  'livrată pe aviz': 'delivered on a note',
  'livrare întârziată': 'late delivery',
  'de livrat': 'to be delivered',
  Emisă: 'Issued',
  'Drumul comenzii': 'Order timeline',
  urmează: 'next',
  'Comanda {0}': 'Order {0}',
  Anulată: 'Cancelled',
  'Neemisă: așteaptă aprobare. Nu o trimite furnizorului.':
    "Not issued: awaiting approval. Don't send it to the supplier.",
  'Comandă suplimentară': 'Top-up order',
  'Comandă de achiziție': 'Purchase order',
  'În atenția: {0}': 'For the attention of: {0}',
  'Data dorită: {0}': 'Requested date: {0}',
  'Termen: {0}': 'Lead time: {0}',
  'Vă rugăm să livrați produsele de mai jos, conform ofertei dumneavoastră pentru „{0}”.':
    'Please deliver the products below, in line with your quote for "{0}".',
  'Valoare produse': 'Goods value',
  'Total de plată': 'Total payable',
  'Curs de referință: 1 € = {0} lei.': 'Reference rate: €1 = {0} lei.',
  'Transportul până la locul de livrare este inclus în prețuri.':
    'Delivery to the delivery address is included in the prices.',
  'Vă rugăm să confirmați primirea comenzii și data livrării.':
    'Please confirm receipt of this order and the delivery date.',
  'Emis de': 'Issued by',
  'Confirmare furnizor': 'Supplier confirmation',
  'nume, semnătură, dată': 'name, signature, date',
  '{0} pe {1}{2}': '{0} on {1}{2}',
  'Nr. {0}': 'No. {0}',
  'Nr.': 'No.',
  'Returnată integral, marcată pe {0}.': 'Fully returned, marked on {0}.',
  'Livrată integral, marcată pe {0}.': 'Fully delivered, marked on {0}.',
  'Cost până azi: <b>{0}</b> fără TVA{1}.': 'Cost to date: <b>{0}</b> excl. VAT{1}.',
  'Cost real: <b>{0}</b> fără TVA{1}.': 'Actual cost: <b>{0}</b> excl. VAT{1}.',
  // apps/web/src/pages/OrdersPage.tsx
  mâine: 'tomorrow',
  'de ieri': 'since yesterday',
  'în {0} zile': 'in {0} days',
  'de {0} zile': 'for {0} days',
  'pasul {0} din {1} · ': 'step {0} of {1} · ',
  'trebuia pe {0}': 'was due on {0}',
  'fără dată de livrare': 'no delivery date',
  'de azi': 'since today',
  'Toate comenzile de achiziție ale firmei: ce așteaptă aprobare, ce e de livrat și ce a întârziat.':
    "All of the company's purchase orders: what's awaiting approval, what's to be delivered and what's late.",
  'Starea comenzilor': 'Order status',
  'Caută după număr, furnizor sau cerere…': 'Search by number, supplier or request…',
  'Făcută de': 'Created by',
  Oricine: 'Anyone',
  'emise, fără TVA': 'issued, excl. VAT',
  'chirie până azi': 'rental to date',
  'întârziată {0}': 'late {0}',
  'aviz de pe șantier, de confirmat': 'delivery note from the site, to confirm',
  '{0} avize de pe șantier, de confirmat': '{0} delivery notes from the site, to confirm',
  'Nicio comandă aici. Schimbă filtrul de sus.': 'No orders here. Change the filter above.',
  'Încă nu ai nicio comandă. O comandă se face din cererea de ofertă, după ce alegi furnizorul.':
    "You don't have any orders yet. An order is created from the request for quotes, once you've chosen the supplier.",
  'Cerere · șantier': 'Request · site',
  suplimentare: 'top-up',
  'de o zi': 'for one day',
  // apps/web/src/pages/PricesPage.tsx
  '6 luni': '6 months',
  'în ultimele 6 luni': 'over the last 6 months',
  '12 luni': '12 months',
  'în ultimele 12 luni': 'over the last 12 months',
  Tot: 'All',
  'toată perioada': 'all time',
  'din tot istoricul': 'across all history',
  '{0} {1} · ultima pe {2}': '{0} {1} · latest on {2}',
  'același preț: {0}': 'same price: {0}',
  'următorul: {0}, {1}': 'next: {0}, {1}',
  'o singură ofertă': 'a single quote',
  'Închide {0}': 'Close {0}',
  'Deschide {0}': 'Open {0}',
  'Caută un material…': 'Search for a material…',
  'Caută un material': 'Search for a material',
  'Cel mai mic acum': 'Lowest now',
  'Față de data trecută': 'Compared with last time',
  'Toată perioada': 'All time',
  'Ultimele {0}': 'Last {0}',
  'Minim – maxim, {0}': 'Min – max, {0}',
  'Cel mai ieftin acum': 'Cheapest now',
  'Încă nu ai prețuri în istoric.': 'No prices in your history yet.',
  'Prima ofertă salvată pe o cerere intră aici, iar de la a doua vezi și evoluția.':
    "The first quote saved on a request appears here, and from the second one on you'll see the trend.",
  'Verde înseamnă că plătești mai puțin decât data trecută, roșu că plătești mai mult. Punctele din grafic sunt cererile: între ele nu știm prețul. Prețuri fără TVA.':
    "Green means you're paying less than last time, red that you're paying more. The points on the chart are requests: we don't know the price in between. Prices excl. VAT.",
  'Cel mai mic preț primit la ultima cerere, pentru fiecare material. Se adună singur din oferte.':
    'The lowest price received on the latest request, for each material. It builds up automatically from quotes.',
  'Niciun material nu se potrivește cu „{0}".': 'No material matches "{0}".',
  // apps/web/src/pages/PublicOfferPage.tsx
  'într-{0}': 'in {0}',
  'în {0}': 'in {0}',
  'Ofertă — {0}': 'Quote — {0}',
  'Prețul la „{0}” nu e un număr bun.': 'The price for "{0}" isn\'t a valid number.',
  'Treceți prețul la cel puțin o poziție.': 'Enter a price for at least one item.',
  '{0}: scrieți un număr de zile.': '{0}: enter a number of days.',
  'Costul transportului nu e un număr bun.': "The delivery cost isn't a valid number.",
  Livrarea: 'Delivery',
  Plata: 'Payment',
  'Linkul nu se deschide': "The link doesn't open",
  'Cererea s-a încheiat': 'The request has closed',
  'Oferta nu se mai trimite aici': 'Quotes can no longer be sent here',
  'Livrare la': 'Deliver to',
  'Oferta până pe': 'Quotes by',
  'Necesar pe șantier': 'Needed on site',
  'Oferta a ajuns la {0}': 'Your quote has reached {0}',
  '{0}E deja în tabelul comparativ al firmei {1}. O puteți schimba cât timp cererea e deschisă.':
    "{0}It's already in {1}'s comparison table. You can change it while the request is open.",
  'Trimisă pe {0}. ': 'Sent on {0}. ',
  'Poziții cu preț': 'Items with a price',
  'la livrare': 'on delivery',
  'Schimbă oferta': 'Change quote',
  'Întrebări despre cerere: {0},': 'Questions about the request: {0},',
  'Cerere de ofertă de la {0}': 'Request for quotes from {0}',
  'Bună ziua, {0}. Treceți prețurile unitare, în lei, fără TVA, la pozițiile pe care le aveți. Oferta ajunge direct la {1}.':
    'Hello {0}. Enter unit prices, in lei, excluding VAT, for the items you can supply. Your quote goes straight to {1}.',
  ' · chirie {0}; prețul pe unitate, pentru toată perioada':
    ' · rental {0}; price per unit, for the whole period',
  'Preț unitar pentru {0}': 'Unit price for {0}',
  'Chirie / unitate': 'Rental / unit',
  'Preț / unitate': 'Price / unit',
  'lei / {0}': 'lei / {0}',
  'Produsul propus în loc': 'Product offered instead',
  'ex. echivalent Baumit în loc de Knauf': 'e.g. Baumit equivalent instead of Knauf',
  'Propun alt produs': "I'm offering a different product",
  'Ce nu aveți, lăsați gol.': "Leave anything you don't have blank.",
  'Livrare în (zile)': 'Delivery in (days)',
  'ex. 3': 'e.g. 3',
  'Plata la (zile)': 'Payment in (days)',
  'ex. 30': 'e.g. 30',
  'Oferta valabilă până pe': 'Quote valid until',
  Transportul: 'Delivery',
  Separat: 'Separate',
  'Nu știu încă': "Don't know yet",
  'Costul transportului, pentru toată comanda (lei fără TVA)':
    'Delivery cost, for the whole order (lei excl. VAT)',
  'gol dacă nu se știe': 'empty if unknown',
  'Mențiuni (opțional)': 'Notes (optional)',
  'ex. Prețurile includ descărcarea cu macaraua': 'e.g. Prices include crane unloading',
  '{0} din {1} poziții · fără TVA': '{0} of {1} items · excl. VAT',
  'Trimite oferta schimbată': 'Send updated quote',
  'Trimite oferta': 'Send quote',
  '<b>Și firma dumneavoastră cere oferte de la furnizori?</b> Cu {0} trimiteți aceeași cerere tuturor și primiți ofertele într-un singur tabel, comparate pe fiecare poziție.':
    '<b>Does your company request quotes from suppliers too?</b> With {0} you send the same request to everyone and get the quotes back in one table, compared item by item.',
  'Încercați gratuit 14 zile': 'Try it free for 14 days',
  '{0}Nu aveți nevoie de cont.': '{0}No account needed.',
  'Pagină trimisă prin {0} în numele {1}. ': 'Page sent via {0} on behalf of {1}. ',
  'Ce este {0}?': 'What is {0}?',
  // apps/web/src/pages/ReceivingPage.tsx
  Achiziții: 'Purchasing',
  'Trecută de {0} · așteaptă confirmarea Achizițiilor': 'Logged by {0} · waiting for Purchasing to confirm',
  'Trecută de {0}': 'Logged by {0}',
  ' · suplimentare': ' · top-up',
  'trebuia pe': 'was due on',
  'dorită pe': 'wanted on',
  'vine pe': 'arriving on',
  'Ce s-a comandat': 'What was ordered',
  '· chirie': '· rental',
  'Livrare la: {0}': 'Deliver to: {0}',
  'Adaugă încă o livrare': 'Add another delivery',
  'Nicio comandă pe șantierul ales. Alege „Toate șantierele”.':
    'No orders for the selected site. Choose "All sites".',
  'Nu așteptăm nimic acum. Când Achizițiile fac o comandă pentru șantier, apare aici, cu ce vine și când.':
    "Nothing expected right now. When Purchasing places an order for the site, it shows up here, with what's coming and when.",
  'Achizițiile o confirmă după; până atunci o poți schimba.':
    'Purchasing confirms it afterwards; until then you can change it.',
  'Ce s-a comandat pentru șantier și când se livrează. La fiecare livrare, adaugă avizul cu o poză: Achizițiile îl confirmă după.':
    "What has been ordered for the site and when it's being delivered. For each delivery, add the delivery note with a photo: Purchasing confirms it afterwards.",
  'comanda {0}': 'order {0}',
  // apps/web/src/pages/ReorderPage.tsx
  Valabil: 'Valid',
  'Expiră curând': 'Expiring soon',
  Expirat: 'Expired',
  'Comanzi din nou la prețurile convenite cu furnizorii, fără cerere de ofertă. Pentru fiecare produs, Procumi alege cel mai bun preț încă valabil și face câte o comandă pe furnizor.':
    'Reorder at the prices agreed with your suppliers, without a request for quotes. For each product, Procumi picks the best price still valid and creates one order per supplier.',
  Liste: 'Lists',
  'Prețuri convenite': 'Agreed prices',
  'Alege șantierul de livrare.': 'Choose the delivery site.',
  'Fără preț convenit: {0}.': 'No agreed price: {0}.',
  'Scrie cel puțin o cantitate.': 'Enter at least one quantity.',
  'Comanda e făcută': 'Order created',
  '{0} comenzi făcute': '{0} orders created',
  emisă: 'issued',
  'Din pagina comenzii o trimiți furnizorului și treci livrarea, ca la orice comandă.':
    'From the order page you send it to the supplier and log the delivery, as with any order.',
  'Altă comandă': 'Another order',
  'Încă nu ai prețuri convenite': 'No agreed prices yet',
  'Când alegi furnizorul la o cerere de ofertă, apasă „Păstrează prețurile”: prețurile câștigătoare devin prețuri convenite pentru 90 de zile. Sau scrie-le de mână dintr-o listă de prețuri sau un contract.':
    'When you choose the supplier on a request for quotes, press "Keep the prices": the winning prices become agreed prices for 90 days. Or enter them by hand from a price list or contract.',
  'Adaugă prețuri convenite': 'Add agreed prices',
  Lista: 'List',
  'Toate produsele cu preț convenit': 'All products with an agreed price',
  'Livrare pe șantier': 'Deliver to site',
  'Când trebuie (opțional)': "When it's needed (optional)",
  ' · minim {0}': ' · minimum {0}',
  'Fără preț convenit valabil': 'No valid agreed price',
  'Cantitate {0}': 'Quantity {0}',
  'sub comanda minimă': 'below the minimum order',
  'Fără preț convenit: {0}. Scoate cantitatea sau cere oferte.':
    'No agreed price: {0}. Remove the quantity or request quotes.',
  'Fă {0} comenzi · {1}': 'Create {0} orders · {1}',
  'Fă comanda{0}': 'Create the order{0}',
  'Prețuri fără TVA. Peste pragul de aprobare, comanda așteaptă aprobatorul.':
    'Prices excl. VAT. Above the approval threshold, the order waits for the approver.',
  'Lista „{0}” a fost ștearsă.': 'List "{0}" deleted.',
  'O listă e ce comanzi de obicei pentru un șantier, cu cantitățile obișnuite. La comandă doar le schimbi.':
    'A list is what you usually order for a site, with the usual quantities. When ordering, you just adjust them.',
  'Listă nouă': 'New list',
  'Nicio listă încă. Fă una cu produsele pe care le comanzi des.':
    'No lists yet. Make one with the products you order often.',
  'Listele se fac din produsele cu preț convenit. Adaugă întâi prețuri convenite.':
    'Lists are made from products with an agreed price. Add agreed prices first.',
  'Dă un nume listei.': 'Give the list a name.',
  'Bifează cel puțin un produs.': 'Tick at least one product.',
  'Lista e salvată.': 'List saved.',
  'Modifică „{0}”': 'Edit "{0}"',
  'Numele listei': 'List name',
  'ex. Bucătărie – săptămânal': 'e.g. Kitchen – weekly',
  'Șantierul obișnuit': 'Usual site',
  'Se alege la comandă': 'Chosen when ordering',
  'de obicei': 'usual',
  'Cantitatea obișnuită {0}': 'Usual quantity {0}',
  'Salvează lista': 'Save list',
  'Scrie cel puțin un produs.': 'Enter at least one product.',
  'Scrie prețul pentru „{0}”.': 'Enter the price for "{0}".',
  'preț salvat': 'price saved',
  'prețuri salvate': 'prices saved',
  'Prețuri fără TVA, bune până la data lor. Un preț nou de la același furnizor îl înlocuiește pe cel vechi. Când expiră, fă o cerere de ofertă: prețurile câștigătoare se păstrează din nou.':
    'Prices excl. VAT, valid until their date. A new price from the same supplier replaces the old one. When they expire, send a request for quotes: the winning prices are kept again.',
  'Adaugă prețuri': 'Add prices',
  Furnizorul: 'Supplier',
  'Alege…': 'Choose…',
  'Bune până la': 'Valid until',
  'Produsul, cum apare pe comandă': 'The product, as it appears on the order',
  Produsul: 'Product',
  Unitatea: 'Unit',
  'Prețul în lei, fără TVA': 'Price in lei, excl. VAT',
  'Încă un produs': 'Another product',
  'Salvează prețurile': 'Save prices',
  '{0} / {1}{2} · până la {3} · {4}': '{0} / {1}{2} · until {3} · {4}',
  'din cerere de ofertă': 'from a request for quotes',
  'scris de mână': 'entered by hand',
  Elimină: 'Remove',
  'Niciun preț convenit încă.': 'No agreed prices yet.',
  'Același produs înseamnă aceeași denumire și aceeași unitate (literele mari și diacriticele nu contează).':
    "The same product means the same name and the same unit (capitals and accents don't matter).",
  produs: 'product',
  produse: 'products',
  // apps/web/src/pages/ReportPage.tsx
  'Luna asta': 'This month',
  'luna asta': 'this month',
  '90 de zile': '90 days',
  'ultimele 90 de zile': 'in the last 90 days',
  Anul: 'Year',
  'anul acesta': 'this year',
  'Raport pentru conducere': 'Management report',
  'În {0}: {1} comandat în {2} {3}{4}.': '{1} ordered {0}, across {2} {3}{4}.',
  ', cu {0} sub a doua ofertă': ', {0} below the second quote',
  'În {0} nu s-a emis încă nicio comandă.': 'Nothing has been ordered {0} yet.',
  'fără comenzi în perioada de dinainte': 'no orders in the previous period',
  '{0}{1}% față de perioada de dinainte': '{0}{1}% on the previous period',
  Economisit: 'Saved',
  'față de a doua ofertă, la {0} din {1} {2}': 'against the second quote, on {0} of {1} {2}',
  'cerere hotărâtă': 'decided request',
  'cereri hotărâte': 'decided requests',
  'Rămas pe masă': 'Left on the table',
  'diferența până la cel mai bun preț posibil, la cererile hotărâte':
    'the gap to the best possible price, on decided requests',
  'Așteaptă aprobarea ta': 'Waiting for your approval',
  '{0} · deschide panoul': '{0} · open the dashboard',
  'nimic de aprobat': 'nothing to approve',
  'Alese peste cea mai mică ofertă': 'Chosen above the lowest quote',
  'poate cu motiv (termen, calitate, transport): merită întrebat':
    'maybe for a reason (lead time, quality, delivery): worth asking',
  '{0} · ales {1}, cea mai mică {2}': '{0} · chosen {1}, lowest {2}',
  'Toate cererile hotărâte în perioadă au mers la cea mai mică ofertă completă.':
    'Every request decided in this period went to the lowest complete quote.',
  'Apare după ce se alege furnizorul la o cerere cu cel puțin două oferte.':
    'Shows up once a supplier is chosen on a request with at least two quotes.',
  'Pe ce se duc banii': 'Where the money goes',
  'comandat în perioadă': 'ordered in this period',
  'Apare după prima comandă din perioadă.': 'Shows up after the first order in this period.',
  'cât ia fiecare din comenzi': "each one's share of orders",
  '{0} ia {1} din comenzi. Dacă nu poate livra, firma depinde de el: cere oferte și de la alții.':
    "{0} takes {1} of orders. If they can't deliver, the company depends on them: get quotes from others too.",
  Concurența: 'Competition',
  'cererile trimise în perioadă': 'requests sent in this period',
  'oferte primite în medie pe cerere': 'quotes received per request on average',
  '{0} din {1} cu cel mult o ofertă: fără comparație, prețul nu e verificat':
    "{0} of {1} had at most one quote: with no comparison, the price isn't checked",
  'Apare după prima cerere trimisă în perioadă.': 'Shows up after the first request sent in this period.',
  'Bugetul pe șantiere': 'Budget by site',
  'comandat de la început, față de buget': 'ordered since the start, against budget',
  // apps/web/src/pages/RequisitionPage.tsx
  'Se cer oferte': 'Requesting quotes',
  'Se comandă': 'Being ordered',
  Livrat: 'Delivered',
  'Unde a ajuns necesarul': 'Where the requisition stands',
  'Livrat parțial': 'Partly delivered',
  'Necesarul nu a fost găsit.': 'Requisition not found.',
  'Scrie motivul: omul de pe șantier îl primește pe mail':
    'Give a reason: the person on site gets it by email',
  '{0} a fost respins': '{0} rejected',
  'Retragi necesarul {0}?': 'Withdraw requisition {0}?',
  'Achizițiile nu-l mai văd de preluat. Dacă tot trebuie, faci altul.':
    "Purchasing will no longer see it to pick up. If it's still needed, make a new one.",
  'Retrage necesarul': 'Withdraw requisition',
  '{0} a fost retras': '{0} withdrawn',
  '‹ Tot necesarul': '‹ All requisitions',
  '{0} · {1}{2} · trimis de {3}, {4}': '{0} · {1}{2} · sent by {3}, {4}',
  'cineva care nu mai e în firmă': 'someone no longer in the company',
  'Fă cerere de ofertă': 'Request quotes',
  '{0} așteaptă din nou': '{0} is waiting again',
  Redeschide: 'Reopen',
  Editează: 'Edit',
  'nu s-a spus': 'not specified',
  ' · a trecut': ' · passed',
  'Livrare promisă': 'Promised delivery',
  'Respins de': 'Rejected by',
  'Preluat de': 'Picked up by',
  'Cererea de ofertă': 'Request for quotes',
  'Motivul:': 'Reason:',
  'Pentru achiziții': 'For purchasing',
  'Respingi {0}?': 'Reject {0}?',
  '{0} primește motivul pe mail și îl vede în aplicație.':
    '{0} gets the reason by email and sees it in the app.',
  'Omul de pe șantier': 'The person on site',
  'ex. Avem pe stoc în depozit, le aduce Mihai joi':
    'e.g. We have it in stock at the depot, Mike will bring it on Thursday',
  'Respinge necesarul': 'Reject requisition',
  'Trebuie pe șantier': 'Needed on site',
  // apps/web/src/pages/RequisitionsPage.tsx
  'Necesar de pe șantier': 'Site requisitions',
  'Ce au cerut șefii de șantier. Din necesar faci cererea de ofertă cu un clic: liniile se copiază singure.':
    'What site managers have asked for. Turn a requisition into a request for quotes in one click: the lines copy across automatically.',
  'Ce ai cerut pentru șantier și unde a ajuns: trimis, se cer oferte, comandat, livrat.':
    "What you've requested for the site and where it stands: sent, requesting quotes, ordered, delivered.",
  'Stadiul necesarului': 'Requisition status',
  'Caută după număr, material sau cine l-a trimis…': 'Search by number, material or sender…',
  'Un necesar bifat': 'One requisition ticked',
  '{0} necesare bifate': '{0} requisitions ticked',
  Debifează: 'Untick',
  'Fă o cerere de ofertă din ele': 'Make one request for quotes from them',
  'Ce trebuie': "What's needed",
  'Trebuie la': 'Needed by',
  'Trimis de': 'Sent by',
  Stadiu: 'Status',
  'Bifează {0} pentru o cerere de ofertă comună': 'Tick {0} for a combined request for quotes',
  'a trecut': 'passed',
  'livrare pe {0}': 'delivery on {0}',
  'Niciun necesar aici. Schimbă filtrul de sus.': 'No requisitions here. Change the filter above.',
  'Încă nu a venit niciun necesar. Invită-ți șefii de șantier cu rolul „Șantier” (din Contul firmei → Echipa): nu ocupă loc în pachet.':
    'No requisitions yet. Invite your site managers with the "Site" role (Company account → Team): they don\'t take up a seat in the plan.',
  'Încă n-ai trimis niciun necesar. Apasă „Necesar nou” și scrie ce trebuie pe șantier.':
    'You haven\'t sent any requisitions yet. Press "New requisition" and write what\'s needed at the site.',
  // apps/web/src/pages/ResetScreen.tsx
  'Parolă nouă': 'New password',
  'Pentru contul <b>{0}</b>. După ce o salvezi, intri direct, iar pe celelalte calculatoare și telefoane va trebui să intri din nou.':
    "For the account <b>{0}</b>. Once you save it you're signed in; on your other computers and phones you'll need to sign in again.",
  'Parola nouă': 'New password',
  'Salvează parola și intră': 'Save password and sign in',
  Înapoi: 'Back',
  // apps/web/src/pages/RfqDetailPage.tsx
  '‹ Comandă rapidă': '‹ Quick order',
  '‹ Toate cererile': '‹ All requests',
  'Cererea nu a fost găsită.': 'Request not found.',
  '{0} {1} până la {2}. Le găsești la Comandă rapidă.':
    "{0} {1} until {2}. You'll find them under Quick order.",
  'preț păstrat': 'price kept',
  'prețuri păstrate': 'prices kept',
  'Cerere închisă': 'Request closed',
  'Cerere redeschisă': 'Request reopened',
  ' Se pierde și împărțirea între {0}, fiindcă o cerere anulată nu are comandă.':
    ' The split between {0} is lost too, because a cancelled request has no order.',
  ' Se pierde și furnizorul ales ({0}), fiindcă o cerere anulată nu are comandă.':
    ' The chosen supplier ({0}) is lost too, because a cancelled request has no order.',
  'Anulezi cererea?': 'Cancel the request?',
  '„{0}” trece la anulate.{1} Ofertele primite rămân.':
    '"{0}" moves to cancelled.{1} The quotes received are kept.',
  'Anulează cererea': 'Cancel request',
  'Nu anula': "Don't cancel",
  'Cerere anulată': 'Request cancelled',
  ' Se șterg și {0} {1}.': ' {0} {1} will also be deleted.',
  'documentul primit': 'received document',
  'documentele primite': 'received documents',
  'Se șterg cererea și {0} {1}, cu tot cu prețurile din ele.{2} Dacă vrei doar să nu-ți mai stea în listă, închide cererea.':
    "The request and {0} {1} will be deleted, along with their prices.{2} If you just don't want it in your list, close the request.",
  'oferta primită': 'quote received',
  'oferte primite': 'quotes received',
  '„{0}” nu a primit nicio ofertă.{1}': '"{0}" hasn\'t received any quotes.{1}',
  ' Nu se pierde nimic.': ' Nothing will be lost.',
  'Ștergi definitiv cererea?': 'Permanently delete the request?',
  'Ștergi cererea?': 'Delete the request?',
  'Șterge cererea': 'Delete request',
  'Cerere ștearsă, împreună cu {0} {1}': 'Request deleted, along with {0} {1}',
  'Cerere ștearsă': 'Request deleted',
  Închisă: 'Closed',
  Mailurile: 'Emails',
  'Schimbă furnizorul': 'Change supplier',
  'Am ales furnizorul': "I've chosen the supplier",
  'Închide cererea': 'Close the request',
  '{0} a primit oferta de la {1} pe mail': '{0} received the quote from {1} by email',
  ' și a citit {0} {1}': ' and read {0} {1}',
  ' Verific-o și salveaz-o.': ' Check it and save it.',
  'Furnizorul ales și comanda': 'Chosen supplier and order',
  'Ai ales': 'You chose',
  'emisă {0} · {1} fără TVA': 'issued {0} · {1} excl. VAT',
  '{0} așteaptă aprobare': '{0} is awaiting approval',
  'Nu pleacă la furnizor până nu e aprobată.': "It won't go to the supplier until it's approved.",
  'Motivul: {0}. Refă-o pornind de la ea.': 'Reason: {0}. Redo it starting from this one.',
  'Refă-o: pornește de la ce scrisesei pe cea anulată.':
    'Redo it: start from what you wrote on the cancelled one.',
  'Se completează din oferta aleasă, fără reintroducere.': 'Filled in from the chosen quote, no retyping.',
  'Mai comanzi de la același furnizor, pe același proiect':
    "You're ordering more from the same supplier, for the same job",
  'Refă comanda': 'Redo the order',
  'Suplimentări:': 'Top-ups:',
  '· fără concurență, nu intră la diferența obținută': '· without competition, not counted towards savings',
  'Anulate:': 'Cancelled:',
  'Comandă rapidă la prețurile convenite, fără cerere de ofertă.':
    'Quick order at the agreed prices, without a request for quotes.',
  'Comanzi des produsele astea? Păstrează prețurile câștigătoare ca prețuri convenite pentru 90 de zile și comandă-le din nou fără o cerere nouă.':
    'Order these products often? Keep the winning prices as agreed prices for 90 days and reorder them without a new request.',
  'Păstrează prețurile': 'Keep the prices',
  'Tabel comparativ': 'Comparison table',
  '{0}{1} fără răspuns': '{0}{1} with no reply',
  '{0} de trimis · ': '{0} to send · ',
  'primită {0}{1}': 'received {0}{1}',
  'prin link ': 'via link ',
  'trimisă {0}{1}{2}{3}{4}': 'sent {0}{1}{2}{3}{4}',
  'din Procumi ': 'from Procumi ',
  ' · {0} follow-up': ' · {0} follow-up(s)',
  ' · memento automat': ' · automatic reminder',
  ' · a deschis linkul {0}': ' · opened the link {0}',
  'mailul n-a plecat încă': 'email not sent yet',
  'mailul din Procumi n-a plecat': "the Procumi email didn't go out",
  'Editează oferta': 'Edit quote',
  'Trimite mailul': 'Send the email',
  'Adaugă oferta': 'Add quote',
  ales: 'chosen',
  'Termen răspuns: {0}': 'Reply deadline: {0}',
  // apps/web/src/pages/RfqListPage.tsx
  'trecut de ieri': 'passed yesterday',
  'trecut de {0} zile': 'passed {0} days ago',
  'Fiecare cerere pleacă o dată către toți furnizorii aleși. Ofertele primite se adună într-un tabel comparativ.':
    'Each request goes out once to all the chosen suppliers. The quotes you receive are collected in a comparison table.',
  'Etapa cererilor': 'Request stage',
  'Caută după titlu sau categorie…': 'Search by title or category…',
  'Caută o cerere': 'Search for a request',
  'Filtrează după șantier': 'Filter by site',
  Etapa: 'Stage',
  'niciun furnizor': 'no suppliers',
  'Nicio cerere nu se potrivește.': 'No requests match.',
  'Nu ai nimic de lucru. Creează o cerere de ofertă și alege furnizorii.':
    'Nothing to work on. Create a request for quotes and choose the suppliers.',
  'Nicio cerere aici.': 'No requests here.',
  'Șterge filtrele': 'Clear filters',
  'Se aduc…': 'Loading…',
  'Arată mai multe ({0})': 'Show more ({0})',
  // apps/web/src/pages/SignupScreen.tsx
  'Am trimis alt cod. Folosește-l pe cel din ultimul mail.':
    "We've sent another code. Use the one from the latest email.",
  'Spune-ne ce face firma și câți oameni fac achizițiile.':
    'Tell us what your company does and how many people do the buying.',
  'Cont nou': 'New account',
  'Contul face o firmă nouă, cu tine ca primul utilizator. Ai {0} zile gratuite, fără card, cu tot ce are pachetul Echipă. Colegii îi inviți apoi din aplicație.':
    'This creates a new company, with you as its first user. You get {0} days free, no card needed, with everything in the Team plan. You can invite colleagues from inside the app.',
  'Firma ta': 'Your company',
  'ex. Construct Brașov SRL': 'e.g. Northside Builders Ltd',
  'Țara firmei': 'Company country',
  'Ce face firma ta?': 'What does your company do?',
  'Îți propunem categoriile de furnizori potrivite.': "We'll suggest the right supplier categories.",
  'Câți oameni fac achizițiile în firmă?': 'How many people do the buying in your company?',
  'Îți trimitem aici un cod, ca să știm că e al tău.': "We'll send a code here to confirm it's yours.",
  'Scrie codul primit pe mail': 'Enter the code we emailed you',
  'L-am trimis pe <b>{0}</b>. Merge 15 minute. Dacă nu-l vezi în câteva minute, uită-te și în Spam.':
    "We sent it to <b>{0}</b>. It works for 15 minutes. If you don't see it within a few minutes, check your spam folder.",
  'Codul de 6 cifre': '6-digit code',
  'Se verifică…': 'Checking…',
  'Confirmă și intră': 'Confirm and sign in',
  'Trimite-mi codul': 'Send me the code',
  'Trimite alt cod': 'Send another code',
  'Am greșit emailul': 'I typed the wrong email',
  'Am deja cont': 'I already have an account',
  // apps/web/src/pages/SiteDetailPage.tsx
  'Șantierul nu a fost găsit.': 'Site not found.',
  'Șantier redeschis': 'Site reopened',
  'Șantier închis': 'Site closed',
  'Ștergi șantierul?': 'Delete the site?',
  '„{0}” nu are nicio cerere, deci nu se pierde nimic.': '"{0}" has no requests, so nothing will be lost.',
  'Șterge șantierul': 'Delete site',
  'Șantier șters': 'Site deleted',
  Închis: 'Closed',
  Activ: 'Active',
  '{0} {1} de ofertă · {2} {3} · {4} {5}': '{0} {1} · {2} {3} · {4} {5}',
  'ofertă primită': 'quote received',
  'Închide șantierul': 'Close the site',
  'Cererea în lucru': 'Request in progress',
  'Ultima cerere încheiată': 'Latest completed request',
  'Buget de achiziții': 'Purchasing budget',
  'fără buget': 'no budget',
  'peste buget cu {0}': 'over budget by {0}',
  'folosit {0}% · rămân {1}': '{0}% used · {1} left',
  'Trece bugetul': 'Set the budget',
  ' · urmează {0}': ' · coming up {0}',
  'la {0} {1}, față de a doua ofertă': 'on {0} {1}, against the second quote',
  'după prima comandă cu două oferte': 'after the first order with two quotes',
  'Comparație oferte': 'Quote comparison',
  'încheiată · {0}': 'completed · {0}',
  'Cererea comparată': 'Compared request',
  ' Apasă „Cerere nouă” ca să primești oferte.': ' Press "New request" to get quotes.',
  '{0} deschise din {1}': '{0} open out of {1}',
  'termen {0} · trimisă {1}': 'deadline {0} · sent {1}',
  ' Apasă „Cerere nouă".': ' Press "New request".',
  'Distribuția achizițiilor': 'Purchasing breakdown',
  'Furnizori și status': 'Suppliers and status',
  'Documente și oferte': 'Documents and quotes',
  Anulate: 'Cancelled',
  'anulată {0}': 'cancelled {0}',
  'fără comandă': 'no order',
  Închise: 'Closed',
  'închisă {0}': 'closed {0}',
  '· împărțită între': '· split between',
  ' · {0} lei': ' · {0} lei',
  '‹ Toate șantierele': '‹ All sites',
  'Nicio cerere deschisă pe acest șantier.{0}': 'No open requests on this site.{0}',
  '· ales': '· chosen',
  // apps/web/src/pages/SitesPage.tsx
  '{0} de decis': '{0} to decide',
  '{0} cu termen depășit': '{0} past deadline',
  '{0} fără răspuns': '{0} with no reply',
  '{0} cu termen aproape': '{0} with a deadline coming up',
  'o ofertă nouă': 'one new quote',
  '{0} oferte noi': '{0} new quotes',
  Deschise: 'Open',
  'Caută după nume, localitate sau beneficiar…': 'Search by name, town or client…',
  'Caută un șantier': 'Search for a site',
  'fără localitate': 'no town',
  'lei cumpărat': 'lei bought',
  'nimic comandat': 'nothing ordered',
  'nicio cerere': 'no requests',
  '{0} {1} în istoric': '{0} {1} in history',
  'nimic azi': 'nothing today',
  'Șterge căutarea': 'Clear search',
  'Niciun șantier închis.': 'No closed sites.',
  'Nu ai niciun șantier deschis. Adaugă primul — de exemplu {0}.':
    'You have no open sites. Add your first one — for example {0}.',
  '„Creșă Pucioasa"': '"Riverside Nursery"',
  '„Sediul central"': '"Head office"',
  'Fiecare cerere de ofertă ține de un șantier, ca să vezi într-un loc tot ce s-a cerut și tot ce s-a cumpărat pentru el. Primele sunt cele care cer ceva azi.':
    'Every request for quotes belongs to a site, so you can see everything requested and bought for it in one place. The ones needing something today come first.',
  'Niciun șantier nu se potrivește.': 'No sites match.',
  // apps/web/src/pages/SuppliersPage.tsx
  Toți: 'All',
  'Arhivezi „{0}”?': 'Archive "{0}"?',
  'Apare în {0} {1}, deci nu poate fi șters fără să strici istoricul. Arhivat, nu mai apare la cereri noi, dar rămâne în cererile trecute.':
    "They appear on {0} {1}, so they can't be deleted without breaking the history. Once archived, they no longer appear on new requests, but stay on past ones.",
  Arhivează: 'Archive',
  'Ștergi „{0}”?': 'Delete "{0}"?',
  'Nu apare în nicio cerere, deci nu se pierde nimic.':
    "They don't appear on any request, so nothing will be lost.",
  'Șterge furnizorul': 'Delete supplier',
  'Furnizor șters': 'Supplier deleted',
  'Furnizor arhivat': 'Supplier archived',
  'Furnizor readus în agendă': 'Supplier back in your address book',
  'Agenda ta de furnizori. Un distribuitor poate fi trecut pe mai multe categorii și poate avea câte o persoană pe fiecare gamă.':
    'Your supplier address book. A distributor can be listed under several categories and have a different contact for each product range.',
  'Importă din Excel': 'Import from Excel',
  Categoria: 'Category',
  'Caută după firmă, persoană sau email…': 'Search by company, contact or email…',
  'Caută un furnizor': 'Search for a supplier',
  'Răspunde la cereri': 'Replies to requests',
  Acțiuni: 'Actions',
  'o dată': 'once',
  'de {0} ori': '{0} times',
  'Agenda e goală. Adaugă primul furnizor sau importă-i dintr-un tabel Excel.':
    'Your address book is empty. Add your first supplier or import them from an Excel sheet.',
  'Niciun furnizor nu se potrivește.': 'No suppliers match.',
  'Niciun furnizor în această categorie.': 'No suppliers in this category.',
  'Furnizori arhivați': 'Archived suppliers',
  'nu apar la cereri noi, dar rămân în cererile trecute':
    "they don't appear on new requests, but stay on past ones",
  '{0} din {1} oferte': '{0} of {1} quotes',
  'Readu în agendă': 'Restore to address book',
  'nicio cerere încă': 'no requests yet',
  'n-a răspuns încă': "hasn't replied yet",
  'în {0} {1}, în medie': 'in {0} {1}, on average',
  principală: 'main',
  'Istoric cu tine': 'History with you',
  'Cel mai bun preț': 'Best price',
  '0 din {0}': '0 of {0}',
  'Ultima dată': 'Last time',
  'Livrează în': 'Delivers to',
  'Editează furnizorul': 'Edit supplier',
  nespus: 'not specified',
  // packages/shared/src/activity.ts
  'cerere ștearsă': 'request deleted',
  'Cerere nouă: {0}': 'New request: {0}',
  '{0} a plecat la {1} furnizori': '{0} sent to {1} suppliers',
  '{0} a plecat la {1}': '{0} sent to {1}',
  'Ofertă de la {0} pentru {1}': 'Quote from {0} for {1}',
  'Ales {0} pentru {1}{2}': 'Chose {0} for {1}{2}',
  'Comanda {0} către {1}{2}': 'Order {0} to {1}{2}',
  'Suplimentare {0} către {1}{2}': 'Top-up {0} to {1}{2}',
  'Comanda {0} către {1} așteaptă aprobare{2}': 'Order {0} to {1} is awaiting approval{2}',
  'Comanda {0} a fost aprobată': 'Order {0} approved',
  'Comanda {0} a fost respinsă': 'Order {0} rejected',
  'Comanda {0} e livrată integral': 'Order {0} fully delivered',
  'Livrare trecută de pe șantier pe comanda {0} ({1}): de confirmat':
    'Delivery logged from the site on order {0} ({1}): to confirm',
  'Livrare pe comanda {0} ({1})': 'Delivery on order {0} ({1})',
  'Retur trecut de pe șantier pe comanda {0} ({1}): de confirmat':
    'Return logged from the site on order {0} ({1}): to confirm',
  'Retur pe comanda {0} ({1})': 'Return on order {0} ({1})',
  'Cererea {0} a fost închisă': 'Request {0} closed',
  'Cererea {0} a fost anulată': 'Request {0} cancelled',
  'Necesar nou {0} de pe șantier: {1}': 'New requisition {0} from the site: {1}',
  'Necesarul {0} a fost respins': 'Requisition {0} rejected',
  'Necesarul {0} {1} a fost modificat': 'Requisition {0} {1} updated',
  'Comentariu la {0}{1}': 'Comment on {0}{1}',
  'acum {0} min': '{0} min ago',
  'acum o oră': 'an hour ago',
  'acum {0} ore': '{0} hours ago',
  ieri: 'yesterday',
  'acum {0} zile': '{0} days ago',
  // packages/shared/src/anaf.ts
  'CUI-ul nu există la ANAF. Verifică-l pe o factură.':
    "This CUI doesn't exist at ANAF. Check it on an invoice.",
  'Firmă radiată din {0}.': 'Company struck off since {0}.',
  'Inactiv fiscal{0}: facturile lui nu îți dau drept de deducere a TVA și a cheltuielii.':
    "VAT-inactive{0}: their invoices don't let you deduct the VAT or the expense.",
  'Nu e plătitor de TVA: facturile vin fără TVA.': 'Not VAT registered: invoices come without VAT.',
  'Aplică TVA la încasare: deduci TVA-ul abia după ce plătești factura.':
    "Uses VAT on cash accounting: you can only deduct the VAT once you've paid the invoice.",
  'conform ANAF, la {0}': 'according to ANAF, as of {0}',
  'CUI inexistent': 'CUI not found',
  Radiat: 'Struck off',
  'Inactiv fiscal': 'VAT-inactive',
  ' din {0}': ' since {0}',
  // packages/shared/src/analyse.ts
  'comanda minimă': 'the minimum order',
  'transportul și costurile pe comandă': 'delivery and per-order costs',
  'costurile peste prețuri': 'the costs on top of the prices',
  '{0} nu spune nimic despre transport. Dacă se plătește separat, clasamentul se poate schimba.':
    "{0} doesn't say anything about delivery. If it's charged separately, the ranking could change.",
  '{0} are prețurile listate cele mai mici, dar cu {1} {2} iese mai ieftin cu {3}.':
    '{0} has the lowest listed prices, but with {1}, {2} works out cheaper by {3}.',
  ' și ': ' and ',
  '{0} taxează transportul separat, dar n-a dat suma: totalurile nu sunt complete încă. Întreabă-l cât costă înainte de a decide.':
    "{0} charges delivery separately but hasn't given the amount, so the totals aren't complete yet. Ask what it costs before deciding.",
  '{0}: {1} e mai ieftin pe {2} ({3}/{2}/lună față de {4}), dar ofertează {5} {2} din {6} {2} cerute. La total, {7} iese mai ieftin cu {8} pe poziția asta.':
    '{0}: {1} is cheaper per {2} ({3}/{2}/month against {4}), but quotes for {5} {2} of the {6} {2} requested. On the total, {7} works out cheaper by {8} for this item.',
  // packages/shared/src/approvals.ts
  'Aprobările comenzilor sunt incluse din pachetul Echipă. Alege un pachet ca să le pornești.':
    'Order approvals come with the Team plan. Choose a plan to turn them on.',
  // packages/shared/src/attentionGroups.ts
  'Follow-up': 'Follow-up',
  'răspuns de la furnizor întârziat': 'late supplier reply',
  'răspunsuri de la furnizori întârziate': 'late supplier replies',
  'Sună furnizorul': 'Call the supplier',
  'livrări întârziate': 'late deliveries',
  'comandă așteaptă aprobarea ta': 'order waiting for your approval',
  'comenzi așteaptă aprobarea ta': 'orders waiting for your approval',
  'decizie fără comandă': 'decision without an order',
  'decizii fără comandă': 'decisions without an order',
  Verifică: 'Check',
  'ofertă de verificat': 'quote to check',
  'oferte de verificat': 'quotes to check',
  'termen pe șantier': 'site deadline',
  'termene pe șantier': 'site deadlines',
  '{0} de pe șantier': '{0} from the site',
  'necesar nou': 'new requisition',
  'necesare noi': 'new requisitions',
  '{0} · {1} din {2} oferte{3}': '{0} · {1} of {2} quotes{3}',
  ' · de la {0}': ' · from {0}',
  // packages/shared/src/benchmark.ts
  'cel mai mic primit vreodată': 'the lowest ever received',
  'la nivelul mediei': 'in line with the average',
  '{0}{1} față de medie': '{0}{1} vs the average',
  'media ta: {0} {1}': 'your average: {0} {1}',
  'plătit ultima dată: {0} {1}': 'last paid: {0} {1}',
  'Media pe ultimele {0} luni, din {1} cereri: din fiecare, prețul plătit sau cea mai mică ofertă.':
    'Average over the last {0} months, from {1} requests: for each, the price paid or the lowest quote.',
  'Cel mai mic primit: {0} lei, de la {1}.': 'Lowest received: {0} lei, from {1}.',
  'Plătit ultima dată la {0}.': 'Last paid on {0}.',
  'ce ai plătit ultima dată': 'what you paid last time',
  'media ta': 'your average',
  'istoricul tău': 'your history',
  'la nivelul istoricului': 'in line with your history',
  ', pe {0} din {1} poziții': ', on {0} of {1} items',
  'La nivelul istoricului tău{0}.': 'In line with your history{0}.',
  'Pe fiecare poziție: ultimul preț plătit sau, dacă n-ai comandat-o încă prin Procumi, media pe {0} luni. Prețul listat × cantitatea cerută.':
    "For each item: the last price paid or, if you haven't ordered it through Procumi yet, the {0}-month average. Listed price × requested quantity.",
  'Cu {0} ({1}) peste {2}{3}.': '{0} ({1}) above {2}{3}.',
  'Cu {0} ({1}) sub {2}{3}.': '{0} ({1}) below {2}{3}.',
  // packages/shared/src/billing.ts
  'fără dată de plată': 'no payment date',
  'plata a expirat pe {0}': 'payment expired on {0}',
  'plătit până la {0}': 'paid until {0}',
  // packages/shared/src/categories.ts
  Armătură: 'Rebar',
  Cofraje: 'Formwork',
  'Instalații sanitare': 'Plumbing',
  Electrice: 'Electrical',
  Beton: 'Concrete',
  Zidărie: 'Masonry',
  Schele: 'Scaffolding',
  'Țevi și fitinguri': 'Pipes and fittings',
  Izolații: 'Insulation',
  Vopsele: 'Paints',
  Pardoseli: 'Flooring',
  Tâmplărie: 'Doors and windows',
  Agregate: 'Aggregates',
  Asfalt: 'Asphalt',
  'Tuburi și cămine': 'Pipes and manholes',
  'Materii prime': 'Raw materials',
  Ambalaje: 'Packaging',
  'Piese de schimb': 'Spare parts',
  'Scule și consumabile': 'Tools and consumables',
  'Echipamente de protecție': 'Protective equipment',
  'Mentenanță utilaje': 'Machine maintenance',
  'Transport marfă': 'Freight',
  'Rafturi și mobilier': 'Shelving and furniture',
  'Echipamente IT': 'IT equipment',
  'Materiale promoționale': 'Promotional materials',
  Alimente: 'Food',
  Băuturi: 'Drinks',
  'Curățenie și igienă': 'Cleaning and hygiene',
  'Lenjerie și textile': 'Linen and textiles',
  'Echipamente de bucătărie': 'Kitchen equipment',
  'Servicii subcontractate': 'Subcontracted services',
  Combustibil: 'Fuel',
  Anvelope: 'Tyres',
  'Service auto': 'Vehicle servicing',
  Paleți: 'Pallets',
  Semințe: 'Seeds',
  Îngrășăminte: 'Fertilisers',
  'Produse fitosanitare': 'Crop protection products',
  Furaje: 'Animal feed',
  'Consumabile medicale': 'Medical consumables',
  Reactivi: 'Reagents',
  'Echipamente medicale': 'Medical equipment',
  'Curățenie și dezinfecție': 'Cleaning and disinfection',
  'Licențe software': 'Software licences',
  Papetărie: 'Stationery',
  'Mobilier de birou': 'Office furniture',
  'Servicii de curățenie': 'Cleaning services',
  // packages/shared/src/cockpit.ts
  'întârziată, trebuia {0}': 'late, was due {0}',
  'așteaptă livrarea': 'awaiting delivery',
  'pe șantier de {0} {1}': 'on site for {0} {1}',
  'returnată, de închis': 'returned, to close',
  'livrare pe aviz, de închis': 'delivered on a note, to close',
  netrimisă: 'not sent',
  'așteaptă răspunsuri': 'awaiting replies',
  'termen depășit': 'past deadline',
  'de decis': 'to decide',
  'de comandat': 'to order',
  'Cantitate insuficientă': 'Quantity too low',
  'Ofertă expiră {0}': 'Quote expires {0}',
  'Cea mai bună ofertă a expirat': 'The best quote has expired',
  '{0} · {1} · confirmă prețul înainte să comanzi': '{0} · {1} · confirm the price before ordering',
  'Materialul trebuia deja pe șantier': 'The material was already due on site',
  'Necesar pe șantier {0}': 'Needed on site {0}',
  'comanda așteaptă aprobare': 'order awaiting approval',
  'ales, comanda nu e emisă': 'chosen, order not issued',
  'furnizorul nu e ales': 'supplier not chosen',
  'Livrare întârziată': 'Late delivery',
  'Comanda {0} · {1} · trebuia {2}': 'Order {0} · {1} · was due {2}',
  'Chiria depășește durata cerută': 'Rental is running past the requested period',
  'Comanda {0} · {1} · pe șantier de {2} zile, cerute {3}':
    'Order {0} · {1} · on site for {2} days, {3} requested',
  'Termen de răspuns depășit': 'Quote deadline passed',
  '{0} · {1} {2} fără ofertă': '{0} · {1} {2} without a quote',
  'Fără răspuns de {0} zile': 'No reply for {0} days',
  'De întrebat înainte să alegi': 'To ask before you choose',
  '{0} · {1} · lipsește {2}': '{0} · {1} · missing {2}',
  'livrare {0}': 'delivery {0}',
  // packages/shared/src/comparisonTemplate.ts
  'Furnizor {0}': 'Supplier {0}',
  '„{0}”: lipsește cantitatea': '"{0}": quantity missing',
  'după {0} de poziții, restul': 'after {0} items, the rest',
  'Șablonul nu are nicio poziție cu cantitate. Completează pozițiile și încarcă-l din nou.':
    'The template has no items with a quantity. Fill in the items and upload it again.',
  'Șablonul nu are niciun preț. Trece prețurile furnizorilor și încarcă-l din nou.':
    "The template has no prices. Enter the suppliers' prices and upload it again.",
  'Furnizorul „{0}” apare de două ori în capul tabelului. Dă-le nume diferite.':
    'Supplier "{0}" appears twice in the table header. Give them different names.',
  // packages/shared/src/conditions.ts
  'fără avans': 'no deposit',
  '{0}% avans': '{0}% deposit',
  // packages/shared/src/coverage.ts
  'ofertat {0} din {1} {2} (−{3} {4})': 'quoted {0} of {1} {2} (−{3} {4})',
  // packages/shared/src/dashboard.ts
  'încă {0} șantiere': '{0} more sites',
  // packages/shared/src/emailDomains.ts
  'Firma ta are deja cont în Procumi (adrese @{0}). Cere-i administratorului contului o invitație.':
    'Your company already has a Procumi account (@{0} addresses). Ask the account administrator for an invitation.',
  // packages/shared/src/format.ts
  '{0} days ago': '{0} days ago',
  // packages/shared/src/i18n.ts
  '…': '…',
  'Ai {0} cereri deschise': 'You have {0} open requests',
  // packages/shared/src/ledger.ts
  'Preț mediu (lei fără TVA)': 'Average price (lei excl. VAT)',
  'Valoare (lei fără TVA)': 'Value (lei excl. VAT)',
  // packages/shared/src/mail.ts
  'Cerere de ofertă – {0}{1}': 'Request for quotation – {0}{1}',
  'Cerere de ofertă': 'Request for quotation',
  'Termen pentru ofertă': 'Quotation deadline',
  'închiriere, aproximativ {0}': 'rental, approximately {0}',
  'Vă rugăm ca oferta să cuprindă:': 'Please include in your quotation:',
  'Vă rugăm să ne transmiteți oferta până la data de {0}. Pentru orice clarificare, vă stăm la dispoziție.':
    "Please send us your quotation by {0}. We're happy to clarify anything you need.",
  'Mențiuni: {0}': 'Notes: {0}',
  'Revenire la cererea de ofertă': 'Follow-up on our request for quotation',
  'Revin cu privire la cererea noastră de ofertă „{0}”{1}. Termenul de transmitere a ofertei este {2}.':
    'I\'m following up on our request for quotation "{0}"{1}. The deadline for quotations is {2}.',
  ', transmisă pe {0}': ', sent on {0}',
  'Vă rugăm să ne confirmați dacă ne puteți transmite o ofertă.':
    "Please let us know whether you'll be able to send us a quotation.",
  'Clarificări la ofertă': 'Questions about your quotation',
  'Vă mulțumim pentru oferta transmisă pentru „{0}”. Pentru a o putea compara cu celelalte oferte primite, avem nevoie de câteva precizări.':
    'Thank you for your quotation for "{0}". To compare it with the other quotations we\'ve received, we need a few details.',
  'Vă rugăm să ne precizați:': 'Could you please confirm:',
  'Vă mulțumim.': 'Thank you.',
  'Memento: cerere de ofertă – {0}': 'Reminder: request for quotation – {0}',
  'Memento · cerere de ofertă': 'Reminder · request for quotation',
  'Vă reamintim că termenul de transmitere a ofertei pentru „{0}” este mâine, {1}.':
    'Just a reminder that the deadline for quotations for "{0}" is tomorrow, {1}.',
  'Dacă nu ne puteți transmite o ofertă de această dată, vă rugăm să ne anunțați, pentru a ne putea organiza.':
    "If you're unable to quote this time, please let us know so we can plan accordingly.",
  'Vă rugăm să ne transmiteți o ofertă de preț pentru produsele de mai jos.':
    'Please send us a quotation for the items below.',
  'prețurile unitare, fără TVA': 'unit prices, excluding VAT',
  'condițiile de plată': 'payment terms',
  'perioada de valabilitate a ofertei': 'how long the quotation is valid',
  'costul transportului, dacă nu este inclus în preț': 'the delivery cost, if not included in the price',
  'pentru pozițiile la închiriere: chiria pe zi sau pe lună, chiria minimă, suprafața sau cantitatea acoperită de materialul ofertat, valoarea de înlocuire a materialului și costul transportului dus-întors':
    'for rental items: the daily or monthly rate, the minimum rental period, the area or quantity covered by the equipment offered, its replacement value and the cost of delivery and collection',
  // packages/shared/src/markets.ts
  'Nr. Reg. Com.': 'Trade Register No.',
  'Cod fiscal (VAT)': 'Tax / VAT number',
  'Nr. înregistrare': 'Registration number',
  'Construcții generale (antreprenor)': 'General contracting',
  'Structuri și beton armat': 'Structures and reinforced concrete',
  'Instalații (HVAC, sanitare, electrice)': 'Building services (HVAC, plumbing, electrical)',
  'Finisaje și amenajări': 'Finishes and fit-out',
  'Drumuri și infrastructură': 'Roads and infrastructure',
  'Producție și industrie': 'Manufacturing and industry',
  'Comerț și distribuție': 'Retail and distribution',
  'Hoteluri, restaurante, catering': 'Hotels, restaurants, catering',
  'Facility management și servicii': 'Facility management and services',
  'Transport și logistică': 'Transport and logistics',
  'Agricultură și zootehnie': 'Farming and livestock',
  'Clinici și laboratoare': 'Clinics and laboratories',
  'Birouri, IT și servicii profesionale': 'Offices, IT and professional services',
  Altceva: 'Something else',
  Construcții: 'Construction',
  'Alte domenii': 'Other industries',
  'Doar eu': 'Just me',
  '2–5 oameni': '2–5 people',
  '6 sau mai mulți': '6 or more',
  // packages/shared/src/offerLink.ts
  'Nu mai primește oferte. Mulțumim pentru timpul acordat!':
    'This request is no longer accepting quotes. Thank you for your time!',
  'Oferta voastră a fost deja primită și trecută în tabel. Pentru schimbări, răspundeți la mail.':
    'Your quote has already been received and added to the table. For any changes, please reply to the email.',
  'Linkul nu mai e activ. Trimiteți oferta răspunzând la mail.':
    'This link is no longer active. Please send your quote by replying to the email.',
  'Completează oferta online': 'Fill in the quote online',
  // packages/shared/src/orderList.ts
  'livrată pe aviz, de închis': 'delivered on a note, to close',
  'De livrat': 'To be delivered',
  'De închis': 'To close',
  'Livrate integral': 'Fully delivered',
  'Respinse și anulate': 'Rejected and cancelled',
  // packages/shared/src/package.ts
  'S-a cerut chirie, iar oferta are un preț fără perioadă':
    'Rental was requested, but the quote has a price with no period',
  'S-a cerut chirie, oferta e de vânzare': 'Rental was requested, the quote is for sale',
  'S-a cerut cumpărare, oferta e de chirie': 'Purchase was requested, the quote is for rental',
  'Liniile din ofertă adunate dau {0}, nu {1}': "The quote's lines add up to {0}, not {1}",
  'Linie repetată de {0} ori: {1}': 'Line repeated {0} times: {1}',
  'Setul acoperă {0} din {1} {2} cerute': 'The set covers {0} of the {1} {2} requested',
  'Chirie minimă {0} de zile: s-au socotit {1}, nu {2}': 'Minimum rental {0} days: {1} were charged, not {2}',
  'Nu include: {0}': 'Excludes: {0}',
  'În ofertă, {0} + TVA {1} nu dau totalul de {2}':
    "In the quote, {0} + VAT {1} doesn't add up to the total of {2}",
  'o lună': 'one month',
  '{0} de zile': '{0} days',
  '{0} luni': '{0} months',
  'pentru {0} {1}': 'for {0} {1}',
  'TVA-ul din ofertă ({0}) nu e o cotă legală din bază ({1}); la {2}% ar fi {3}':
    "The VAT in the quote ({0}) isn't a legal rate on the net amount ({1}); at {2}% it would be {3}",
  // packages/shared/src/panel.ts
  '{0} · {1} · nepreluat': '{0} · {1} · not picked up',
  'Fără categorie': 'No category',
  // packages/shared/src/plans.ts
  Start: 'Start',
  'pe email': 'by email',
  Echipă: 'Team',
  Companie: 'Company',
  'prioritar, cu ajutor la pornire': 'priority, with onboarding help',
  'Pachetul {0} citește automat {1} de documente pe lună și le-ai folosit pe toate. Luna viitoare citirea pornește din nou; până atunci scrie prețurile de mână{2}.':
    "The {0} plan reads {1} documents a month automatically and you've used them all. Reading starts again next month; until then, enter prices by hand{2}.",
  ' sau treci la {0}': ' or move to {0}',
  'Atlas e inclus în pachetele plătite. Alege un pachet ca să-l pornești.':
    'Atlas is included in the paid plans. Choose a plan to turn it on.',
  'Contul nu are încă un pachet. Poți vedea tot, dar ca să creezi sau să schimbi ceva alege un pachet.':
    "The account doesn't have a plan yet. You can see everything, but to create or change anything, choose a plan.",
  'Trimiterea din Procumi e în pachetele Echipă și Companie. În Start copiezi mailul și îl trimiți din programul tău.':
    'Sending from Procumi is included in the Team and Company plans. On Start you copy the email and send it from your own email program.',
  'Firma are mai mulți colegi sau șantiere deschise decât permite pachetul. Administratorul contului trebuie să aleagă ce rămâne activ.':
    'The company has more colleagues or open sites than the plan allows. An account administrator needs to choose what stays active.',
  'În perioada de probă ai {0} utilizatori.': 'During the trial you have {0} users.',
  'Pachetul {0} are {1} utilizatori.': 'The {0} plan has {1} users.',
  'În perioada de probă ai {0} șantiere active.': 'During the trial you have {0} active sites.',
  'Pachetul {0} are {1} șantiere active.': 'The {0} plan has {1} active sites.',
  'Ca să inviți mai mulți colegi, treci la {0}.': 'To invite more colleagues, move to {0}.',
  'Ca să inviți mai mulți colegi, scrie-ne.': 'To invite more colleagues, get in touch with us.',
  'Ca să deschizi încă unul, închide un șantier terminat sau treci la {0}.':
    'To open another one, close a finished site or move to {0}.',
  'Ca să deschizi încă unul, închide un șantier terminat sau scrie-ne.':
    'To open another one, close a finished site or get in touch with us.',
  'Citirea automată cu AI e gratuită doar în primele {0} zile. Poți scrie prețurile de mână sau poți alege un pachet.':
    'Automatic AI reading is free only in the first {0} days. You can enter prices by hand or choose a plan.',
  'În perioada de probă, Procumi citește automat {0} de documente și le-ai folosit pe toate. Poți scrie prețurile de mână sau poți alege un pachet.':
    "During the trial, Procumi reads {0} documents automatically and you've used them all. You can enter prices by hand or choose a plan.",
  // packages/shared/src/po.ts
  '{0} · aviz {1}': '{0} · note {1}',
  '{0}, fără număr de aviz': '{0}, no delivery note number',
  '1 livrare': '1 delivery',
  '{0} livrări': '{0} deliveries',
  '1 retur': '1 return',
  '{0} — chirie {1}': '{0} — rental {1}',
  '{0} — set complet, {1}': '{0} — complete set, {1}',
  '{0} — costuri o singură dată': '{0} — one-off costs',
  '{0} — suplimentare chirie': '{0} — rental top-up',
  'Comandă {0}': 'Order {0}',
  'Preț unitar ({0})': 'Unit price ({0})',
  'TVA {0}%': 'VAT {0}%',
  'Comandă {0} – {1}': 'Order {0} – {1}',
  'Bună ziua{0},\n\nVă transmitem comanda nr. {1} pentru „{2}”, conform ofertei dumneavoastră. Documentul este atașat.\n\nValoare: {3} fără TVA ({4} cu TVA)\nLoc de livrare: {5}{6}\n\nVă rugăm să ne confirmați primirea comenzii și data livrării.\n\nMulțumim,\n{7}':
    'Hello{0},\n\nPlease find attached purchase order no. {1} for "{2}", in line with your quotation.\n\nValue: {3} excl. VAT ({4} incl. VAT)\nDelivery address: {5}{6}\n\nPlease confirm receipt of this order and the delivery date.\n\nThank you,\n{7}',
  '\nLivrare: {0}': '\nDelivery: {0}',
  '{0} retururi': '{0} returns',
  // packages/shared/src/questions.ts
  'costul transportului': 'the delivery cost',
  'Cât costă transportul până la șantier, pentru toată comanda?':
    'How much is delivery to the site, for the whole order?',
  'Prețurile includ transportul până la șantier? Dacă nu, cât costă pentru toată comanda?':
    'Do your prices include delivery to the site? If not, how much is it for the whole order?',
  'termenul de livrare': 'the delivery time',
  'Care este termenul de livrare?': 'What is the delivery time?',
  // packages/shared/src/requisitions.ts
  'așteaptă să-l preia achizițiile': 'waiting for purchasing to pick it up',
  'se cer oferte': 'requesting quotes',
  'achizițiile cer oferte de la furnizori': 'purchasing is requesting quotes from suppliers',
  'se comandă': 'being ordered',
  'furnizorul e ales, comanda se pregătește': 'the supplier is chosen, the order is being prepared',
  'comanda a plecat la furnizor': 'the order has gone to the supplier',
  'livrat parțial': 'partly delivered',
  'a venit o parte pe șantier': 'part of it has arrived at the site',
  'a venit tot pe șantier': 'everything has arrived at the site',
  'cererea de ofertă s-a închis fără comandă': 'the request for quotes closed without an order',
  'achizițiile nu-l preiau': "purchasing won't pick it up",
  'retras de cine l-a trimis': 'withdrawn by the sender',
  'De preluat': 'To pick up',
  Comandate: 'Ordered',
  Livrate: 'Delivered',
  'Respinse sau retrase': 'Rejected or withdrawn',
  '{0} (+{1} necesare)': '{0} (+{1} requisitions)',
  'Contul de șantier trimite necesar de materiale și trece livrările. Restul îl fac achizițiile.':
    'A site account sends material requisitions and logs deliveries. Purchasing does the rest.',
  trimis: 'sent',
  livrat: 'delivered',
  oprit: 'stopped',
  respins: 'rejected',
  retras: 'withdrawn',
  // packages/shared/src/rfqList.ts
  neplecată: 'not sent',
  'așteaptă oferte': 'waiting for quotes',
  'la aprobare': 'awaiting approval',
  comandată: 'ordered',
  închisă: 'closed',
  'De lucru': 'To do',
  Neplecate: 'Not sent',
  'Așteaptă oferte': 'Waiting for quotes',
  'Termen depășit': 'Past deadline',
  'La aprobare': 'Awaiting approval',
  // packages/shared/src/roles.ts
  'cereri, oferte și comenzi': 'requests, quotes and orders',
  Aprobator: 'Approver',
  'aprobă comenzile; face și tot ce face Achiziții': 'approves orders; can also do everything Purchasing can',
  'trimite necesarul, vede unde a ajuns și trece livrările cu avizul, fără prețuri; nu ocupă loc în pachet':
    "sends requisitions, follows their progress and logs deliveries with the delivery note, without prices; doesn't take up a seat in the plan",
  'Un cont de șantier nu poate fi administrator. Alege alt rol întâi.':
    "A site account can't be an administrator. Choose another role first.",
  'Doar un administrator al contului poate face asta.': 'Only an account administrator can do this.',
  'Contul trebuie să aibă cel puțin un administrator. Fă pe altcineva administrator întâi.':
    'The account needs at least one administrator. Make someone else an administrator first.',
  // packages/shared/src/siteTerms.ts
  Locații: 'Locations',
  'Puncte de lucru': 'Work sites',
  Ferme: 'Farms',
  Proiecte: 'Projects',
  // packages/shared/src/specs.ts
  'H {0} m ({1} m)': 'H {0} m ({1} m)',
  'H {0} m': 'H {0} m',
  // packages/shared/src/split.ts
  'Cererea nu a plecat către unul dintre furnizorii aleși.':
    "The request wasn't sent to one of the chosen suppliers.",
  'Poziția „{0}” nu are furnizor.': 'Item "{0}" has no supplier.',
  'Poziția „{0}” e la doi furnizori.': 'Item "{0}" is assigned to two suppliers.',
  'Împărțirea are nevoie de cel puțin doi furnizori.': 'A split needs at least two suppliers.',
  // packages/shared/src/status.ts
  'Ofertă primită': 'Quote received',
  'De trimis': 'To send',
  'Așteaptă răspuns': 'Waiting for reply',
  // packages/shared/src/supplierImport.ts
  'lipsește numele firmei': 'company name missing',
  'lipsește emailul': 'email missing',
  'lipsește categoria': 'category missing',
  'există deja în agendă': 'already in the address book',
  'lipsește {0}-ul': '{0} missing',
  'adresa vine de la ANAF': 'address comes from ANAF',
  'lipsește adresa': 'address missing',
  // packages/shared/src/supplierProfile.ts
  'toată țara': 'the whole country',
  // packages/shared/src/terms.ts
  'câte {0} {1}': 'in packs of {0} {1}',
  '{0}: plătești {1}, nu {2}': '{0}: you pay for {1}, not {2}',
  'minim {0} {1}': 'minimum {0} {1}',
  // packages/shared/src/tsv.ts
  '{0} (preț unitar)': '{0} (unit price)',
  // apps/web/src/components/LiveMap.tsx
  'venit din {0}': 'via {0}',
  'chiar acum': 'just now',
  'loc necunoscut': 'unknown location',
  'a deschis': 'opened',
  'a apăsat „Încearcă gratuit” pe': 'clicked “Try it free” on',
  'a cerut un demo de pe': 'asked for a demo from',
  'om acum pe site': 'person on the site now',
  'oameni acum pe site': 'people on the site now',
  'Locul, după IP:': 'Location from IP:',
  'Acum pe site': 'Live view',
  'fără legătură': 'offline',
  'Afișări azi': 'Page views today',
  '„Încearcă gratuit” azi': '“Try it free” today',
  'Pe site acum': 'On the site now',
  'Ultimele vizite': 'Recent visits',
  'Încă nimeni de la ultima pornire a serverului.': 'No one yet since the server last restarted.',
  'Țările de azi': 'Today’s countries',
  necunoscută: 'unknown',
  'Harta nu s-a putut încărca. Mai încerc o dată în câteva secunde.':
    'The map couldn’t load. Trying again in a few seconds.',
  'Globul cu vizitatorii de acum': 'Globe showing current visitors',
  'Din ce țări': 'Countries',
  // consola echipei și tichetele de suport (2026-10-29)
  'Ai cerut un link pentru parola din consola Procumi.':
    'You asked for a link to set your Procumi console password.',
  'Alege parola': 'Choose your password',
  'Alege rolul din listă.': 'Choose a role from the list.',
  'Alege-ți parola de aici:': 'Choose your password here:',
  'Am primit întrebarea #{0}. Îți răspundem aici și pe mail, de obicei în aceeași zi lucrătoare.':
    'We’ve received question #{0}. We’ll reply here and by email, usually within the same working day.',
  'Am primit întrebarea ta': 'We’ve received your question',
  'Am primit întrebarea ta (#{0}): {1}': 'We’ve received your question (#{0}): {1}',
  'Am primit întrebarea ta (<b>#{0}</b>, „{1}”) și îți răspundem cât de repede putem, de obicei în aceeași zi lucrătoare.':
    'We’ve received your question (<b>#{0}</b>, “{1}”) and will reply as soon as we can, usually within the same working day.',
  'Am primit întrebarea ta și îți răspundem cât de repede putem, de obicei în aceeași zi lucrătoare.':
    'We’ve received your question and will reply as soon as we can, usually within the same working day.',
  'Am trecut întrebarea ca rezolvată. Dacă mai ai nevoie de ceva, răspunde și o redeschidem.':
    'We’ve marked your question as solved. If you need anything else, just reply and we’ll reopen it.',
  Atașează: 'Attach',
  'Atașează doar imagini (PNG, JPG, WebP) sau PDF.': 'You can only attach images (PNG, JPG, WebP) or PDFs.',
  'Atașează o captură de ecran': 'Attach a screenshot',
  'Așteaptă clientul': 'Waiting for customer',
  'Bine ai venit în echipa Procumi': 'Welcome to the Procumi team',
  'Bine ai venit în echipă': 'Welcome to the team',
  'Ce încercai să faci și ce s-a întâmplat': 'What you were trying to do and what happened',
  'Cel mult {0} fișiere.': '{0} files at most.',
  'Ceva nu merge': 'Something isn’t working',
  'Codul a expirat. Intră din nou cu parola.': 'The code has expired. Sign in again with your password.',
  'Codul are 6 cifre.': 'The code has 6 digits.',
  'Codul nu e bun.': 'That code isn’t right.',
  'Codul pentru consola Procumi: {0}': 'Your Procumi console code: {0}',
  'Codul pentru consolă': 'Your console code',
  'Codul pentru intrarea în consola Procumi:': 'Your code for signing in to the Procumi console:',
  'Consola echipei': 'Team console',
  'Dacă nu tu încerci să intri, schimbă-ți parola: cineva o știe.':
    'If this wasn’t you, change your password: someone else knows it.',
  'De răspuns': 'Needs reply',
  Demonstrație: 'Demo',
  'Deschide în consolă': 'Open in the console',
  'Despre ce e vorba': 'What it’s about',
  'Doar citire': 'Read-only',
  'Echipa trebuie să aibă cel puțin un proprietar.': 'The team needs at least one owner.',
  'Felul întrebării': 'Type of question',
  'Fără pachet (veche)': 'No plan (older account)',
  'Idee sau cerere': 'Idea or request',
  'Intră în consolă din nou.': 'Sign in to the console again.',
  'La fiecare intrare, după parolă, primești pe mail un cod de 6 cifre.':
    'Each time you sign in, you’ll also get a 6-digit code by email after your password.',
  'Link pentru parolă trimis la {0}': 'Password link sent to {0}',
  'Linkul merge o singură dată și expiră în <b>{0} ore</b>.':
    'The link works once and expires in <b>{0} hours</b>.',
  'Linkul merge o singură dată și expiră în {0} ore.': 'The link works once and expires in {0} hours.',
  'Linkul nu mai merge. Cere altul din pagina de intrare.':
    'This link no longer works. Ask for a new one from the sign-in page.',
  'Mi s-a rezolvat': 'It’s solved',
  'Ne poți răspunde din aplicație, la „Ajutor”.': 'You can reply from the app, under “Help”.',
  'Notița nu a fost găsită.': 'Note not found.',
  'Notiță la #{0}': 'Note on #{0}',
  'Nu-ți poți scoate singur rolul de proprietar sau accesul.':
    'You can’t remove your own owner role or access.',
  'Omul ales nu e în echipă.': 'That person isn’t on the team.',
  'Omul nu e în echipă.': 'That person isn’t on the team.',
  'Pachet și plată': 'Plan and billing',
  'Parola consolei trebuie să aibă cel puțin 10 caractere':
    'Console passwords must be at least 10 characters',
  'Parola pentru consola Procumi': 'Your Procumi console password',
  'Parola pentru consolă': 'Your console password',
  'Plata a expirat': 'Payment lapsed',
  'Plata cu cardul a eșuat': 'Card payment failed',
  Plătește: 'Paying',
  'Poți răspunde direct la acest mail sau din aplicație, la „Ajutor”.':
    'You can reply straight to this email or from the app, under “Help”.',
  'Poți șterge doar notițele tale.': 'You can only delete your own notes.',
  'Proba se termină': 'Trial ending',
  Procumi: 'Procumi',
  Proprietar: 'Owner',
  Rezolvată: 'Solved',
  'Rolul tău din echipă nu permite asta.': 'Your team role doesn’t allow this.',
  'Răspuns la #{0}': 'Replied to #{0}',
  'Răspuns la #{0} și închis': 'Replied to #{0} and closed it',
  'Răspuns la întrebarea ta': 'A reply to your question',
  'Răspuns nou la #{0}': 'New reply on #{0}',
  'Răspunsul tău': 'Your reply',
  'Răspunsul îl vezi și în aplicație, la „Ajutor”.': 'You’ll also see the reply in the app, under “Help”.',
  'Scrie dacă mai ai nevoie de ceva; o redeschidem.':
    'Write here if you need anything else and we’ll reopen it.',
  'Scrie mesajul.': 'Write your message.',
  'Scrie pe scurt despre ce e vorba.': 'Briefly say what it’s about.',
  'Scrie răspunsul.': 'Write your reply.',
  'Scrie-ne ce încercai să faci și ce s-a întâmplat.':
    'Tell us what you were trying to do and what happened.',
  'Scrie-ne o întrebare': 'Ask us a question',
  Suport: 'Support',
  'Suport Procumi': 'Procumi Support',
  Suspendată: 'Suspended',
  'Tichet nou #{0}': 'New ticket #{0}',
  'Tichete, firme, pachete, plăți și linkuri de înscriere.':
    'Tickets, companies, plans, payments and sign-up links.',
  'Tichetele. Firmele le vede, dar nu le schimbă.': 'Tickets. Can see companies but not change them.',
  'Tichetul nu a fost găsit.': 'Ticket not found.',
  'Tot, inclusiv echipa.': 'Everything, including the team.',
  Trimisă: 'Sent',
  'Trimite întrebarea': 'Send question',
  Tu: 'You',
  'Un fișier e prea mare. Maximul e 5 MB.': 'A file is too large. The limit is 5 MB.',
  'Vezi în aplicație': 'View in the app',
  'Vânzări și plăți': 'Sales and billing',
  'acces redat': 'access restored',
  'acces suspendat': 'access suspended',
  'al nimănui': 'unassigned',
  'dat cuiva': 'assigned',
  'fără probă': 'no trial',
  'pachetul {0}': 'the {0} plan',
  'plată anuală': 'billed yearly',
  'plată lunară': 'billed monthly',
  'prioritate mare': 'high priority',
  'prioritate normală': 'normal priority',
  'proba până la {0}': 'trial until {0}',
  '{0} are acum rolul {1}': '{0} is now {1}',
  '{0} e deja în echipă.': '{0} is already on the team.',
  '{0} fișiere': '{0} files',
  '{0} fișiere atașate': '{0} files attached',
  '{0} invitat ca {1}': '{0} invited as {1}',
  '{0} readus în echipă': '{0} added back to the team',
  '{0} scos din echipă': '{0} removed from the team',
  '{0} te-a adăugat în echipa Procumi, cu rolul „{1}”.': '{0} has added you to the Procumi team as “{1}”.',
  '{0} · Procumi': '{0} · Procumi',
  '{0} · Suport Procumi': '{0} · Procumi Support',
  '{0} și-a făcut contul de proprietar': '{0} created their owner account',
  '{0} și-a pus parola': '{0} set their password',
  '{0}: notiță nouă': '{0}: new note',
  'În probă': 'On trial',
  Întrebare: 'Question',
  'Întrebarea nu a fost găsită.': 'Question not found.',
  'Întrebările tale': 'Your questions',
  'Îți răspundem cât de repede putem.': 'We’ll reply as soon as we can.',
  'Ți-am răspuns': 'We’ve replied',
  // auditul de securitate (2026-10-29)
  'Ai trimis multe mesaje într-un timp scurt.': 'You’ve sent a lot of messages in a short time.',
  '[trimis de la {0}]': '[sent from {0}]',
  // Ticket 06: primii pași, runda 1 (2026-11-02)
  '· {0} lei + transport necunoscut': '· {0} lei + unknown delivery',
  ' + transport necunoscut': ' + unknown delivery',
  'transport necunoscut': 'unknown delivery cost',
  'Întreabă furnizorul': 'Ask the supplier',
  'nu se știe încă': 'not known yet',
  'Totalurile nu sunt complete: {0} n-a dat suma transportului.':
    "The totals aren't complete: {0} hasn't given the delivery cost.",
  'Scrie {0}-ul furnizorului: apare pe comandă.': "Enter the supplier's {0}: it appears on the order.",
  'Scrie adresa sediului furnizorului: apare pe comandă.':
    "Enter the supplier's registered address: it appears on the order.",
  'Comanda {0} e generată, dar mailul n-a plecat: {1}': 'Order {0} is generated, but the email didn’t go out: {1}',
  'Comanda {0} e generată. N-a plecat încă la furnizor.': 'Order {0} is generated. It hasn’t been sent to the supplier yet.',
  'Completată din oferta aleasă. Corectează ce s-a negociat; generată, comanda primește număr și nu se mai schimbă.':
    'Filled in from the chosen quote. Correct what you negotiated; once generated, the order gets a number and can’t be changed.',
  'Pentru comandă trebuie {0}-ul și adresa sediului furnizorului. Scrie-le aici: rămân în agendă pentru comenzile următoare.{1}':
    "The order needs the supplier's {0} and registered address. Enter them here: they're saved for future orders.{1}",
  ' Adresa vine de la ANAF, după CUI.': ' The address comes from ANAF, from the CUI.',
  'Adresă sediu': 'Registered address',
  'Doar generează, o trimit eu': 'Just generate it, I’ll send it',
  'Se generează…': 'Generating…',
  'Generează și trimite suplimentarea': 'Generate and send the top-up',
  'Generează și trimite furnizorului': 'Generate and send to supplier',
  'Generează suplimentarea': 'Generate the top-up',
  'Generează comanda': 'Generate the order',
  '{0} (opțional)': '{0} (optional)',
  'Îl poți lăsa gol: îl cere comanda, dacă lipsește.{0}': 'You can leave it empty: the order asks for it if it’s missing.{0}',
  'Adresă sediu (opțional)': 'Registered address (optional)',
  'alege categoria pe fiecare rând sau „+ Categorie nouă”': 'choose a category on each row, or “+ New category”',
  'Numele categoriei': 'Category name',
  'Categorie nouă pentru {0}': 'New category for {0}',
  '+ Categorie nouă…': '+ New category…',
  'furnizorul n-a primit-o încă': 'the supplier hasn’t received it yet',
  'fără {0}: se cere la prima comandă': 'no {0}: asked for on the first order',
  'fără adresă: se cere la prima comandă': 'no address: asked for on the first order',
  // Ticket 08: Atlas în probă, oferta ca fișier pe link (2026-11-03)
  'În probă, {0} citește {1} de documente. Ai folosit {2}.': 'During the trial, {0} reads {1} documents. You’ve used {2}.',
  'Aveți oferta într-un fișier?': 'Is your quote in a file?',
  'Documentul a ajuns la {0}. Prețurile sunt citite automat, iar {0} le verifică. Nu mai trebuie să le treceți și pe pagină.':
    'The document has reached {0}. The prices are read automatically and {0} checks them. You don’t need to enter them on this page too.',
  '{0} · trimis {1}': '{0} · sent {1}',
  'Încărcați-o aici, ca PDF, Excel sau poză, în loc să treceți prețurile de mână. Ajunge la {0}, care o verifică înainte s-o compare.':
    'Upload it here as a PDF, Excel file or photo instead of typing the prices. It goes to {0}, who checks it before comparing.',
  'Încarcă alt fișier': 'Upload another file',
  'Încarcă oferta': 'Upload the quote',
  '{0} a încărcat oferta pe link, ca fișier': '{0} uploaded their quote as a file on the link',
  '; {0} a citit {1} {2}': '; {0} read {1} {2}',
  'Ofertă încărcată pe link: {0}': 'Quote uploaded on the link: {0}',
  'Încărcarea ofertei ca fișier nu e pornită aici. Treceți prețurile pe pagină sau răspundeți la mail.':
    'Uploading the quote as a file isn’t available here. Enter the prices on the page or reply to the email.',
  'Ați încărcat multe fișiere într-un timp scurt. Încercați din nou peste o oră.':
    'You’ve uploaded many files in a short time. Try again in an hour.',
  'Alegeți fișierul cu oferta.': 'Choose the file with your quote.',
  'Încărcați oferta ca PDF, Excel (.xlsx sau .xls) sau poză.':
    'Upload the quote as a PDF, Excel (.xlsx or .xls) file or photo.',

  /* ---- Ticket 08: the guided first dashboard, the buyer's data at the first order ---- */
  'Compară ofertele și alege furnizorul': 'Compare the offers and choose the supplier',
  'Ofertele vin pe mail sau prin link și le vezi una lângă alta, cu transportul și termenele.':
    'Offers arrive by email or through the link, and you see them side by side, with transport and lead times.',
  'Graficele cu bani, economii și prețuri apar aici după prima ofertă primită.':
    'Charts of spending, savings and prices appear here after the first offer comes in.',
  'Completează {0}-ul și adresa sediului firmei tale: apar pe comandă.':
    'Fill in your company’s {0} and registered address: they appear on the order.',
  'Prima comandă: completează {0}-ul și adresa sediului firmei tale. Apar pe comandă și rămân pentru următoarele.{1}':
    'First order: fill in your company’s {0} and registered address. They appear on the order and stay for the next ones.{1}',
  'Pe poziția asta furnizorul ofertează produsul cerut.': 'On this line the supplier offers the requested product.',
  '„{0}”: prețul citit ({1}) nu se potrivea cu calculul din notă ({2} pe {3}). Am păstrat calculul; verifică-l în ofertă.':
    '"{0}": the price read ({1}) didn’t match the working in the note ({2} per {3}). I kept the working; check it in the quote.',
  'produs echivalent': 'equivalent product',
  'produs echivalent · acceptat': 'equivalent product · accepted',
  'produs echivalent · respins': 'equivalent product · rejected',
  'Nu intră la „cel mai mic” până nu hotărăști.': 'Doesn’t count as "lowest" until you decide.',
  Accept: 'Accept',
  Resping: 'Reject',
  '{0} · echivalent de hotărât': '{0} · equivalent to decide',
  'Îl accepți?': 'Do you accept it?',
  'Încă nu': 'Not yet',
  Da: 'Yes',
  Nu: 'No',
  'Comanda are nevoie de datele firmei tale: codul fiscal și adresa sediului. Le completează un administrator, în „Contul firmei”.':
    'The order needs your company details: tax ID and registered address. An administrator fills them in, in "Company account".',
  'Completează {0}-ul și adresa sediului firmei tale în „Contul firmei”: apar pe comandă.':
    'Fill in your company’s {0} and registered address in "Company account": they appear on the order.',
  'Deschide Contul firmei': 'Open Company account',
  'Nu ai furnizori pe categoria {0}. Adaugă unul cu „Furnizor nou” sau alege unul cu „Din agendă”.':
    'You have no suppliers in {0}. Add one with “New supplier” or pick one with “From your address book”.',
  nealeasă: 'not chosen',
  'Adaugă o ofertă primită': 'Add an offer you received',
  'Urmărește ofertele': 'Follow the offers',
  'Codul merge {0} minute.': 'The code works for {0} minutes.',
  'Codul tău: {0}. Merge {1} minute.': 'Your code: {0}. It works for {1} minutes.',
  'Codul merge <b>{0} minute</b>.': 'The code works for <b>{0} minutes</b>.',
  'Bun venit în Procumi': 'Welcome to Procumi',
  'Contul firmei {0} e gata. Ai {1} zile de probă, cu tot ce are Procumi.':
    'The {0} account is ready. You have a {1}-day trial with everything Procumi has.',
  'Primul pas: adaugă șantierul pentru care ceri oferte. Apoi furnizorii (îi lipești dintr-un tabel Excel) și prima cerere: Procumi o trimite fiecărui furnizor și pune ofertele în același tabel.':
    'First step: add the site you’re asking for quotes for. Then your suppliers (paste them from an Excel table) and the first request: Procumi sends it to each supplier and puts the offers in one table.',
  'Panoul de control îți arată la fiecare pas ce urmează.': 'The dashboard shows you what comes next at every step.',
  'Adaug primul șantier': 'Add my first site',
  Administrator: 'Administrator',
  'Se scrie în istoricul șantierului și în evaluarea furnizorilor, din Analiză. Dacă n-ai ales cel mai ieftin, motivul e partea folositoare peste un an.':
    "This goes into the site's history and the supplier ratings in Analysis. If you didn't pick the cheapest, the reason is what will be useful a year from now.",
  'comandat azi, ajunge pe {0}': 'ordered today, arrives on {0}',
  'Ce fel de zile': 'Kind of days',
  'zi lucrătoare': 'working day',
  'zile lucrătoare': 'working days',
  'Livrare în': 'Delivery in',
  // apps/api/src/dataExport.ts (2026-11-04)
  da: 'yes',
  'respinsă la aprobare': 'rejected at approval',
  'preluat într-o cerere': 'taken into a request',
  date: 'data',
  'furnizori.csv': 'suppliers.csv',
  Județe: 'Counties',
  Arhivat: 'Archived',
  Adăugat: 'Added',
  'contacte-furnizori.csv': 'supplier-contacts.csv',
  Principal: 'Main contact',
  'santiere.csv': 'sites.csv',
  Client: 'Client',
  Creat: 'Created',
  'cereri.csv': 'requests.csv',
  'Creată de': 'Created by',
  Creată: 'Created',
  'Termen oferte': 'Quote deadline',
  'Necesar până la': 'Needed by',
  'Furnizori întrebați': 'Suppliers asked',
  'Total ales': 'Chosen total',
  'cereri-pozitii.csv': 'request-lines.csv',
  'Poz.': 'Line',
  Descriere: 'Description',
  'Zile de chirie': 'Rental days',
  'oferte.csv': 'quotes.csv',
  Monedă: 'Currency',
  Alternativă: 'Alternative',
  Valabilitate: 'Validity',
  'Cost transport': 'Transport cost',
  Primită: 'Received',
  'Pe ce cale': 'Received via',
  'comenzi.csv': 'orders.csv',
  Număr: 'Number',
  'Valoare fără TVA (lei)': 'Value excl. VAT (lei)',
  'Motivul anulării': 'Cancellation reason',
  'Emisă de': 'Issued by',
  'livrari.csv': 'deliveries.csv',
  Tip: 'Type',
  'Nr. document': 'Document no.',
  Notă: 'Note',
  Confirmată: 'Confirmed',
  retur: 'return',
  livrare: 'delivery',
  'necesar.csv': 'site-requests.csv',
  Titlu: 'Title',
  'Creat de': 'Created by',
  'preturi-convenite.csv': 'agreed-prices.csv',
  'Cantitate minimă': 'Minimum quantity',
  'Valabil până la': 'Valid until',
  'utilizatori.csv': 'users.csv',
  Dezactivat: 'Deactivated',
  'activitate.csv': 'activity.csv',
  Cine: 'Who',
  Ce: 'What',
  documente: 'documents',
  avize: 'delivery-notes',
  'mailuri-primite': 'received-emails',
  'Datele firmei {0} din Procumi': "{0}'s data from Procumi",
  'Descărcate pe {0} (ora României).': 'Downloaded on {0} (Romanian time).',
  'Listele .csv se deschid în Excel: furnizori, cereri, oferte (un rând pe poziție), comenzi, livrări, necesar, prețuri convenite, utilizatori, activitate.':
    'The .csv lists open in Excel: suppliers, requests, quotes (one row per line), orders, deliveries, site requests, agreed prices, users, activity.',
  'date-complete.json are tot, pentru alt program: aceleași date, cu toate câmpurile.':
    'date-complete.json has everything, for another program: the same data, with every field.',
  'În dosarul „documente” sunt fișierele originale: planurile cererilor, ofertele furnizorilor, avizele și documentele din mailurile primite.':
    'The "documents" folder holds the original files: request drawings, supplier quotes, delivery notes and the attachments of received emails.',
  'Nu sunt incluse parolele, codurile de acces și linkurile trimise furnizorilor.':
    "Passwords, access codes and the links sent to suppliers aren't included.",
  'Întrebări: support@procumi.com': 'Questions: support@procumi.com',
  'Fișiere care nu au mai putut fi citite ({0}):': "Files that couldn't be read ({0}):",
  'CITESTE.txt': 'README.txt',
  // apps/api/src/routes/dataExport.ts
  'Arhiva se pregătește deja. Așteaptă să se termine descărcarea.':
    'The archive is already being prepared. Wait for the download to finish.',
  'Ai descărcat datele de mai multe ori în ultima oră. Încearcă din nou mai târziu.':
    "You've downloaded the data several times in the last hour. Try again later.",
  // apps/web/src/components/DataExportSection.tsx
  'Arhiva nu s-a putut face. Încearcă din nou.': "The archive couldn't be made. Try again.",
  'Arhiva cu datele firmei s-a descărcat.': "The archive with your company's data has downloaded.",
  'Datele firmei, oricând la tine': "Your company's data, whenever you want it",
  'Copia tuturor datelor, pentru arhivă sau pentru alt program.':
    'A copy of all your data, for your records or for another program.',
  'O arhivă ZIP cu tot ce ține firma în Procumi: furnizorii, cererile, ofertele, comenzile și livrările ca liste pentru Excel, plus documentele originale primite de la furnizori.':
    'A ZIP archive with everything your company keeps in Procumi: suppliers, requests, quotes, orders and deliveries as Excel lists, plus the original documents received from suppliers.',
  'Se pregătește arhiva…': 'Preparing the archive…',
  'Descarcă toate datele': 'Download all data',
  // apps/api/src/companyDelete.ts, staff/companyRoutes.ts (2026-11-04)
  'Firma are un abonament activ în Stripe. Anulează-l întâi, ca să nu mai fie facturată.':
    'The company has a live Stripe subscription. Cancel it first, so they are not billed again.',
  'Scrie numele firmei exact, ca să confirmi ștergerea.':
    'Type the company name exactly to confirm the deletion.',
  '{0}: firmă ștearsă definitiv ({1} utilizatori, {2} cereri, {3} comenzi, {4} documente)':
    '{0}: company permanently deleted ({1} users, {2} requests, {3} orders, {4} documents)',
  'Echivalent acceptat': 'Equivalent accepted',
  inclus: 'included',
};
